import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Container,
  Dropdown,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Spinner,
  Badge,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import DatePicker from "react-datepicker";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { ddlSearchWithTab as SingleSearchDropdownList } from "../../Common/Components/ddlSearchWithTab";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import Dropzone from "react-dropzone";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FiChevronDown } from "react-icons/fi";
import "./slideout.scss";
import $ from "jquery";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../Common/Services/Register";
import { Repeating as repeatingservice } from "../../Common/Services/Repeating";
import { ToastContainer, toast } from "react-toastify";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
// import { VendorSearch } from "../../Common/Components/VendorSearch";   /* Added/Commented to improve speed of Withdrawal Slideout */
import { VendorSearchTypeahead as VendorSearch } from "../../Common/Components/VendorSearchTypeahead";
import { TransactionLogHistory } from "./TransactionLogHistory";
import { isNumber, log } from "util";
import { confirmAlert } from "react-confirm-alert";
import { SingleSelectSearchDDL } from "../../Common/Components/SingleSelectSearchDDL";
import { SingleSelectSearchMove } from "../../Common/Components/SingleSelectSearchMove";
import { CommentBox } from "../../Common/Components/CommentBox";
import { BulkImportSlideout } from "./bulkImportSlideout/bulkImportSlideout";
import { Utils } from "../../Common/Utilis";
import { accountService } from "../../Common/Services/account";
import { OtpModal } from "../../Common/Components/OtpModal";
import { OtpValidator } from "../../Common/Components/OtpValidator";
import MasterRoleLock from "../../Common/Assets/Images/icons/forecast-lock.svg";
import ScrollContainer from "react-indiana-drag-scroll";
import PDFViewerNonInvoice from "./pdfviewerNonInvoice";
import _ from "lodash";
import { InvoiceApprovalS } from "../../Common/Services/InvoiceApprovals";
import moment from "moment";
import { request } from "http";
import { CommentWithoutList } from "../../Common/Components/CommentWithoutList";

let docViewerFiles: any = [];
let routeLeavingGuard: any = null;
const STATUSTYPELIST = [
  {
    id: 1,
    name: "Flagged for Review",
    eventName: "Flag for Review",
    commentModalTitle: "Flag for Review"
  },
  {
    id: 2,
    name: "Needs Review",
    eventName: "Needs Review",
    commentModalTitle: "Change Status to Needs Review"
  },
  {
    id: 3,
    name: "Reviewed",
    eventName: "Reviewed",
    commentModalTitle: "Change Status to Reviewed"
  },
  {
    id: 4,
    name: "Review Complete",
    eventName: "Review Complete",
    commentModalTitle: "Change Status to Review Complete"
  }
];
export class TransactionSlideout extends React.Component<any, any> {
  private trdate: any;
  private trdate1: any;
  private trenddate: any;
  private vendorSearch: any;
  private singleSerch: any;
  private refaccountName: any;
  private ChildComment: any;
  private parentScroll: any;

  private footerchk: any;
  private scrollheight: any;
  private ChildOTP: any;

  private pageName = "TransactionPage";
  private entryType = "WithdrawEntry";
  private iconFormatter = (column, colIndex) => {
    return (
      <Dropdown className="more-action bg-blue dropdown rolePermissiondropdown d-flex justify-content-end align-items-center">
        <Dropdown.Toggle
          tabIndex={this.state.tabDisable}
          id="colList"
          className="d-flex align-items-center"
        >
          <div className="icon" id="colList1">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16.3914 2H3.60861C2.72146 2 2 2.79733 2 3.77778V16.2222C2 17.2027 2.72146 18 3.60861 18H16.3914C17.2785 18 18 17.2027 18 16.2222V6.44356V5.55467V4.66578V3.77778V3.77689C17.9992 2.79644 17.2769 2 16.3914 2ZM6.82582 16.2222H3.60861V6.44356H6.82582V16.2222ZM11.6516 16.2222H8.43442V6.44356H11.6516V16.2222ZM13.2602 16.2222V6.44356H16.3914L16.3922 16.2222H13.2602Z" />
            </svg>
          </div>
          <div className="arrow-icon" id="colList2">
            <FiChevronDown />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="rolePermissionSelector" id="colList3">
          <div className="header">Columns</div>
          <div className="dropdownItems">
            {this.state.tableColumnList.map((items, index) => (
              <div className="dropdown-item" key={index}>
                <EllipsisWithTooltip placement="bottom">
                  <Form.Check
                    type="checkbox"
                    id={`list_${items.id}`}
                    name={items.name.toLowerCase()}
                    label={items.name}
                    value={items.id}
                    onChange={(event) =>
                      this.onChangeStatus(event, items, index)
                    }
                    checked={items.isChecked}
                    disabled={items.disabled}
                  />
                </EllipsisWithTooltip>
              </div>
            ))}
          </div>
          <button
            className="mr-auto btn  wht-bg default-view"
            onClick={this.handleSaveColumn}
            disabled={this.state.isdefaultColDisabled}
          >
            Save as Default View
          </button>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  private transactionsColumns = [
    {
      dataField: "lettercode",
      text: "EHID",
      headerClasses: "ehid",
      hidden: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={this.state.splitHIDList}
              handleSelectedItem={this.handleSelectedItem.bind(
                row,
                1 + "_" + rowIndex
              )}
              defaultItem={row.defaultEhid}
              defaultText={"Search EHID"}
              defaultName={row.defaultEhid}
              controlID="1"
              id={"ddlEHID-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(this, "ddlEHID-" + rowIndex + "ddl")}
              disabled={disable}
            />
          </div>
        );
      },
    },
    {
      dataField: "coaName",
      text: "COA",
      headerClasses: "coa",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "COA" + rowIndex + "btn";
        let id = "coa" + rowIndex + "ddl";
        const defaultCoa = row.coa + " " + row.coaName;
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <div
              id={id}
              style={
                row.isCOA === "Yes" ? { display: "block" } : { display: "none" }
              }
              className="more-action single-select-image dropdown coa-select"
            >
              <Typeahead
                inputProps={{
                  className: "coa" + rowIndex + "ddl",
                  title: defaultCoa,
                }}
                id={"coa" + rowIndex + "ddl"}
                options={this.state.coaList}
                placeholder={"Enter COA"}
                disabled={disable}
                renderMenu={(results: any, menuProps) => (
                  <Menu {...menuProps}>
                    {results.map((result: any, index: any) => (
                      <>
                        {this.state.coaList.length > 0 &&
                          results[index - 1]?.orderno === 1 &&
                          result?.orderno === 2 && <Dropdown.Divider />}
                        {result.label !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                            onWheel={() => this.hoverOutEllipsis()}
                          >
                            <EllipsisWithTooltip placement="bottom">
                              {result.label}
                            </EllipsisWithTooltip>
                          </MenuItem>
                        )}
                        {result.label === "" && (
                          <MenuItem
                            className="load-more"
                            option={result}
                            position={index}
                          >
                            Load More
                          </MenuItem>
                        )}
                      </>
                    ))}
                  </Menu>
                )}
                //renderMenuItemChildren={this.renderCOAItemChildren}
                onChange={this.handleSelectedItem.bind(
                  this,
                  2 + "_" + rowIndex
                )}
                selected={row.defaultCoa}
                onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                onKeyDown={this.onTAB.bind(
                  this,
                  "ddlCOA-" + rowIndex.toString() + "ddl"
                )}
              />
            </div>
            <button
              className={
                row.coaName === "" ? "custom-btn placeholder" : "custom-btn"
              }
              id={btnId}
              style={
                row.isCOA === "Yes"
                  ? { display: "none", width: "100%" }
                  : { display: "block", width: "100%" }
              }
              onClick={() => {
                this.handleCOAFocus(
                  btnId,
                  id,
                  "rbt-input-main form-control rbt-input coa" +
                  rowIndex +
                  "ddl",
                  rowIndex
                );
              }}
              onFocus={() => {
                this.handleCOAFocus(
                  btnId,
                  id,
                  "rbt-input-main form-control rbt-input coa" +
                  rowIndex +
                  "ddl",
                  rowIndex
                );
              }}
            >
              {row.coaName === "" && (
                <EllipsisWithTooltip placement="bottom">
                  {"Enter COA"}
                </EllipsisWithTooltip>
              )}
              {row.coaName !== "" && (
                <EllipsisWithTooltip placement="bottom">
                  {defaultCoa}
                </EllipsisWithTooltip>
              )}
            </button>
          </div>
        );
      },
    },
    {
      dataField: "subVendor",
      text: "Sub Vendor",
      headerClasses: "subVendor",
      hidden: true,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={row.subVendorlist}
              handleSelectedItem={this.handleSelectedItem.bind(
                this,
                3 + "_" + rowIndex
              )}
              defaultItem={row.defaultVendor}
              defaultText={"Search sub vendor"}
              defaultName={row.defaultVendor}
              controlID="3"
              id={"ddlSubVendor-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(this, "ddlSubVendor-" + rowIndex + "ddl")}
              disabled={disable}
            />
          </div>
        );
      },
    },
    {
      dataField: "projectName",
      text: "Project",
      headerClasses: "project",
      hidden: true,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <SingleSearchDropdownList
              tabIndex={this.state.tabEnable}
              itemList={row.projectlist}
              handleSelectedItem={this.handleSelectedItem.bind(
                this,
                4 + "_" + rowIndex
              )}
              defaultItem={row.defaultProject}
              defaultText={"Search Project"}
              defaultName={row.defaultProject}
              controlID="4"
              id={"ddlProject-" + rowIndex + "ddl"}
              onTAB={this.onTAB.bind(this, "ddlProject-" + rowIndex + "ddl")}
              disabled={disable}
            />
          </div>
        );
      },
    },
    {
      dataField: "description",
      text: "Description",
      headerClasses: "description",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdesc" + rowIndex + "txt";
        let btnId = "btndesc" + rowIndex + "btn";
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;

        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <Form.Control
              style={
                row.isDescription === "Yes"
                  ? { display: "block" }
                  : { display: "none" }
              }
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Description"
              value={row.description}
              maxLength={99}
              onChange={(e) => this.updateState(e, rowIndex, "desc", id)}
              disabled={disable}
              onBlur={(e) => {
                this.handleDescriptionBlur(btnId, id, rowIndex, e);
              }}
              autoComplete="off"
            />
            <button
              className={
                row.description === "" ? "custom-btn placeholder" : "custom-btn"
              }
              id={btnId}
              style={
                row.isDescription === "Yes"
                  ? { display: "none", width: "100%" }
                  : { display: "block", width: "100%" }
              }
              onClick={() => {
                this.handleDescriptionFocus(btnId, id, rowIndex);
              }}
              onFocus={() => {
                this.handleDescriptionFocus(btnId, id, rowIndex);
              }}
            >
              {row.description === "" && (
                <EllipsisWithTooltip placement="bottom">
                  {"Enter Description"}
                </EllipsisWithTooltip>
              )}
              {row.description !== "" && (
                <EllipsisWithTooltip placement="bottom">
                  {row.description}
                </EllipsisWithTooltip>
              )}
            </button>
          </div>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      headerClasses: "amount",
      classes: "amount",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtamt" + rowIndex + "txt";
        let disable =
        this.state.formData.vendorID === 0 ||
          this.state.isPermission === "No" ||
            this.state.isError === "NotEdit" ||
            this.state.formData.accPeriodstatus.toString().toLowerCase() !==
            "active" ||
            row.isCOAPer !== "Yes"
            ? true
            : false;
        return (
          <div
            className={
              this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && row.isCOAPer === "Yes"
                ? ""
                : "disabled-area"
            }
          >
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Amount"
              value={row.amount}
              onChange={(e) => this.updateState(e, rowIndex, "amt", id)}
              onKeyDown={(e: any) => this.handleBlur(e, rowIndex)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex)}
              onFocus={(e: any) => this.onSplitAmountFocus(e, rowIndex, id)}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },
    {
      dataField: "Attachment",
      text: "",
      headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete ?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        if (this.state.splitData.length === 1) {
          return <div></div>;
        } else {
          return (
            <>
              {this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active" && (
                  <Dropdown
                    className="more-action confirmation-modal"
                    alignRight
                    tabIndex={this.state.tabDisable}
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more fa-trash"
                      id="dropdown-more-delete"
                      tabIndex={this.state.tabDisable}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <ConfirmationModal
                        confirmModalContent={confirmModalContent}
                        ishandleDeletePosition={this.ishandleDeleteRow.bind(
                          this,
                          row
                        )}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                )}
            </>
          );
        }
      },
    },
  ];

  constructor(props: any) {
    super(props);
    this.vendorSearch = React.createRef();
    this.trdate = React.createRef();
    this.trdate1 = React.createRef();
    this.trenddate = React.createRef();
    this.singleSerch = React.createRef();
    this.refaccountName = React.createRef();
    this.ChildComment = React.createRef();
    this.parentScroll = React.createRef();

    this.footerchk = React.createRef();
    this.scrollheight = React.createRef();
    this.ChildOTP = React.createRef();

    this.state = {
      isMovePermission: "no",
      totalAmountdiff: 0.0,
      isAmountDiff: "No",
      printStatus: "No",
      isOtpNeed: false,
      otpSuccess: false,
      isvendorShow: true,
      accountType: "",
      htmlcomment: [],
      isComment: false,
      selectdefaultperiod: "Accounting Period",
      movePaymentType: "",
      isSave: false,
      isStateChanged: false,
      showInvoiceModal: false,
      showVoidModal: false,
      associatedPayment: [],
      associatedPaymentDetail: [],
      hotelName: "",
      hotelValue: this.props.hidValue,
      MoveHID: -1,
      accountName: "",
      accountlist: [],
      isSpinner: false,
      isPermission: "No",
      isDeletePermission: "No",
      rePrintOldCheck: "No",
      isdefaultColDisabled: false,
      totalCount: 0,
      isDisabled: false,
      tabEnable: 0,
      tabDisable: -1,
      savedfiles: [],
      newSelectedfiles: [],
      files: [],
      isPreviousTransactions: false,
      selectedCoa: 0,
      selectedVendor: 0,
      selectedProject: 0,
      selectedEhid: 0,
      selectedpaymentType: 0,
      selectedaccountingPeriod: 0,
      selectedPeriod: "",
      defaultCoa: "Select COA",
      defaultVendor: "Select Sub Vendor",
      defaultProject: "Select Project",
      defaultEhid: "EHID",
      coaList: [],
      splitHIDList: [],
      subVendorList: [],
      projectList: [],
      vendorList: [],
      accPeriodList: [],
      previousTransactionsData: [],
      transactionsColumns: this.transactionsColumns,
      totalAmount: "$0.00",
      amountTotal: 0.0,
      isRepeat: false,
      createOther: false,
      vendorSelected: [],
      PeriodList: [],
      fileSize: 5242880,
      defaultpaymentType: "Select Type",
      defaultaccountingPeriod: "Accounting Period",
      defaultaccountingPeriod1: "Accounting Period",
      defaultvoidPeriod: "Accounting Period",
      defaultPeriod: "Accounting Period",
      voidPeriod: "",
      voidPeriodList: [],
      transcationvoidDate: null,
      chkvoidDate: "",
      voidConcile: "no",
      chkDate: "",
      paymentType: [
        { id: "ACH", name: "Manual ACH" },
        { id: "Check", name: "Check" },
      ],
      paymentTypeWithdrawal: [
        { id: "ACH", name: "Manual ACH" },
        // { id: 'Reserve', name: 'Reserve' }
      ],
      HIDColumn: false,
      showChangeLogModal: false,
      paymentTypelist: [],
      tableColumnList: [
        { id: "ehid", name: "EHID", isChecked: true, disabled: true },
        { id: "coa", name: "COA", isChecked: true, disabled: true },
        {
          id: "sub vendor",
          name: "Sub Vendor",
          isChecked: false,
          disabled: false,
        },
        { id: "project", name: "Project", isChecked: false, disabled: false },
        {
          id: "description",
          name: "Description",
          isChecked: true,
          disabled: false,
        },
        { id: "amount", name: "Amount", isChecked: true, disabled: true },
      ],

      CopytableColumnList: [
        { id: "ehid", name: "EHID", isChecked: true, disabled: true },
        { id: "coa", name: "COA", isChecked: true, disabled: true },
        {
          id: "sub vendor",
          name: "Sub Vendor",
          isChecked: false,
          disabled: false,
        },
        { id: "project", name: "Project", isChecked: false, disabled: false },
        {
          id: "description",
          name: "Description",
          isChecked: true,
          disabled: false,
        },
        { id: "amount", name: "Amount", isChecked: true, disabled: true },
      ],

      moreActionFileUpload: [{ name: "Delete", eventKey: "delete" }],
      moreActionFileUpload1: [],
      requestlist: {
        hotelID: 0,
        oprID: -1,
        etype: "register",
        vid: 0,
        recordCount: 5,
      },
      splitData: [
        {
          rno: 1,
          lettercode: "",
          spiltHoteID: "",
          coa: "",
          coaName: "",
          description: "",
          amount: "",
          srno: 1,
          clMonth: "",
          clYear: "",
          subVID: "0",
          subVendor: "",
          pID: "0",
          projectName: "",
          splitoprID: "0",
          defaultCoa: [],
          defaultVendor: "Select Sub Vendor",
          defaultProject: "Select Project",
          defaultEhid: "EHID",
          subVendorlist: [],
          projectlist: [],
          isCOAPer: "Yes",
          isCOA: "No",
          isDescription: "No",
        },
        {
          rno: 2,
          lettercode: "",
          spiltHoteID: "",
          coa: "",
          coaName: "",
          description: "",
          amount: "",
          srno: 2,
          clMonth: "",
          clYear: "",
          subVID: "0",
          subVendor: "",
          pID: "0",
          projectName: "",
          splitoprID: "0",
          defaultCoa: [],
          defaultVendor: "Select Sub Vendor",
          defaultProject: "Select Project",
          defaultEhid: "EHID",
          subVendorlist: [],
          projectlist: [],
          isCOAPer: "Yes",
          isCOA: "No",
          isDescription: "No",
        },
      ],
      defaultSplitData: [],

      newRow: {
        rno: 1,
        lettercode: "",
        spiltHoteID: "",
        coa: "",
        coaName: "",
        description: "",
        amount: "",
        srno: 1,
        clMonth: "",
        clYear: "",
        subVID: "",
        subVendor: "",
        pID: "",
        projectName: "",
        splitoprID: "0",
        defaultCoa: [],
        defaultVendor: "Select Sub Vendor",
        defaultProject: "Select Project",
        defaultEhid: "EHID",
        subVendorlist: [],
        projectlist: [],
        isCOAPer: "Yes",
        isCOA: "No",
        isDescription: "No",
      },
      formData: {
        incompleteUniqueNo:0,
        uniqueno: 0,
        hotelID: -1,
        transcationDate: null,
        endDate: null,
        accPeriod: "",
        vendorID: 0,
        vendorName: "",
        internalNotes: "",
        checkNo: "",
        transactionTotal: "",
        tenantID: 0,
        pageType: "",
        paymenttype: "",
        oprID: -1,
        entryType: "",
        accountType: "",
        isRepeat: "No",
        repeatDate: "",
        accPeriodstatus: "Active",
        concilestatus: "No",
        saletax: "",
        vendorContract: "",
        aid: 0,
        actionType: "",
        adj: "N",
        oldentryType: "",
        oldpageType: "",
        vendorDays: "0",
        vendorStatus: "Active",
        contractStatus: "Active",
        copyFromentryType: "",
        olduniqueno: 0,
        repeatType: "",
      },
      splitActualList: [],
      moveHID: {
        hidValue: -1,
        hidName: "",
      },
      moveoprID: -1,
      copyoprID: -1,
      defaultaccountType: "Account",
      selectedVoid: [],
      copyIds: [],
      voidNotes: "",
      isError: "",
      oldTranDate: "",
      showBadge: false,

      isOpenViewer: false,
      defaultView: "doc-view",
      isMapped: "No",
      isMappedShow: false,
      chkIds: [],
      currentZoom: 1.0,
      selectedChk: [],
      isAttachmentLoading: false,
      isEntryMoved: false,

      tempUniqueNo: "",
      slideEntryType: "oldEntry",
      isCopyHasAttachment: false,
      currentScreenTop: 0,
      isCopyEntry: false,
      showMoveAfterPaymentModal: false,
      associatedPaymentEtype: "",
      isLoader: false,
      moveHIDAfterPayment: {
        hidValue: -1,
        hidName: "",
      },
      moveSelectedContract: "",
      showContractDropdown: false,
      contractsArray: [],
      moveEHIDArray: [],
      isReconcilePage: this.props.isReconcilePage,
      isCreditcardPayment: "No",
      isApprove: "No",
      moveAccountListArray: [],
      showAccountsDropdown: false,
      moveSelectedAccountOprId: -1,
      oldPaymentType: "",
      epayCheckNo: "",
      epayDigitalID: "",
      isPaymentStatus: "",
      ePayMethod: "",
      paymentSentDT: "",
      isInvoiceLoading: false,
      COAData: [],
      intervalId: -99,
      COADataCount: 0,

      //review flag
      showReviewBanner: false,
      showCommentModal: false,
      isReviewed: false,
      reviewStatus: "Flag for Review",
      statusTypeList: [...STATUSTYPELIST],
      reviewCurrentDescription: "",
      commentModalTitle: "",
      canReview: "No",
      canFlag: "No",
      selectedReviewStatus: "",
      repeatList: [{id: 1, name: 'Monthly', displayName: "Monthly",}, {id: 2, name: 'Every 2 Weeks', displayName: "Every 2 Weeks"}, {id: 3, name: 'Weekly', displayName: "Weekly"}],
      selectedRepeatType: "Monthly",
    };
    this.Previoustransactions = this.Previoustransactions.bind(this);
    this.loadPreviousData = this.loadPreviousData.bind(this);
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.handleNewRow = this.handleNewRow.bind(this);
    this.ishandleDeleteRow = this.ishandleDeleteRow.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveDeposit = this.saveDeposit.bind(this);
    this.SavePayment = this.SavePayment.bind(this);
    this.closeSlideOut = this.closeSlideOut.bind(this);
    this.handleSaveColumn = this.handleSaveColumn.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.moveInvoiceEHID = this.moveInvoiceEHID.bind(this);
    this.handleVoidAction = this.handleVoidAction.bind(this);
    this.hideSlideOut = this.hideSlideOut.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
    this.onAmountFocus = this.onAmountFocus.bind(this);
  }



  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };
  scrollToBottom = () => {
    this.parentScroll.current.scrollTo({
      //top: this.parentScroll.current.clientHeight,
      top: this.parentScroll.current.scrollHeight,
      behavior: "smooth",
    });
  };
  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.formData.transactionTotal ;//this.state.totalAmount;
    return updatedItem;
  };

  pageClose = () => {
    this.setState({ isSave: false }, () => {
      this.closeSlideOut();
    });
  };

  isValidateModelPoupTab() {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.pageClose(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  returnEHIDList = (item: any) => {
    let moveHID = { ...this.state.moveHID };
    moveHID.hidValue = item.hotelID;
    moveHID.hidName = item.lettercode;
    this.setState(
      {
        moveHID,
        PeriodList: [],
        defaultPeriod: "Accounting Period",
        selectedPeriod: "",
        accountlist: [],
        accountNameMove: "Account",
      },
      () => {
        this.GetAccountingPeriod(item.hotelID, 2);
        let registerRequest1: any = {};
        registerRequest1.hotelID = item.hotelID;
        this.loadAccounts(registerRequest1);
      }
    );
  };

  loadAccounts(registerRequest: any) {
    registersevice
      .RegisterAccount(registerRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          let accountlist: any[] = [];

          if (this.state.hotelValue === registerRequest.hotelID) {
            result = result.filter(
              (e) =>
                e.acctType.toLowerCase() ===
                this.state.accountType.toLowerCase() &&
                e.oprID !== this.state.formData.oprID &&
                e.status === "Active"
            );
          } else {
            result = result.filter(
              (e) =>
                e.acctType.toLowerCase() ===
                this.state.accountType.toLowerCase() && e.status === "Active"
            );
          }

          result.forEach((element) => {
            let acctName: any = {};
            acctName.id = element.oprID;
            acctName.name = element.name;
            accountlist.push(acctName);
          });
          this.setState({ accountlist: [] }, () => {
            this.setState({ accountlist: accountlist });
          });
          if (accountlist.length === 0) {
            Utils.toastError(
              "The destination HID does not have any accounts for the selected transaction type.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              }
            );
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  handleaccountNameSelectedItem = (id: any) => {
    this.setState({ moveoprID: id });
  };

  moveInvoiceEHID() {
    if (
      this.state.moveHID.hidValue.toString() === "-1" ||
      this.state.moveHID.hidValue.toString() === ""
    ) {
      Utils.toastError("Please EHID!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    } else if (this.state.moveoprID === -1) {
      Utils.toastError("Please select account.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    } else if (this.state.selectedPeriod.length === 0) {
      Utils.toastError("Please select accounting period.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    }
    let vendorSelected: any = [];
    let formData = { ...this.state.formData };
    formData.actionType = "move";
    formData.hotelID = this.state.moveHID.hidValue;
    formData.accPeriod = this.state.selectedPeriod;
    formData.oprID = this.state.moveoprID;
    let accountName = this.state.accountlist.filter(
      (e) => e.id === this.state.moveoprID
    )[0].name;
    this.setState(
      {
        formData,
        hotelName: "",
        hotelValue: -1,
        vendorList: [],
        isStateChanged: true,
        accountName,
        isvendorShow: false,
      },
      () => {
        this.setState(
          {
            hotelName: this.state.moveHID.hidName,
            hotelValue: this.state.moveHID.hidValue,
            showInvoiceModal: false,
            isvendorShow: true,
            showBadge: false,
          },
          () => {
            let requestlist = { ...this.state.requestlist };
            requestlist.hotelID = this.state.moveHID.hidValue;
            requestlist.etype = this.props.pageType;
            // this.vendorSearch?.current.GetVendorTranlist(requestlist);   /* Added/Commented to improve speed of Withdrawal Slideout */
            if (this.state.formData.vendorID > 0) {
              let vendorItem: any = {};
              vendorItem.id = this.state.formData.vendorID;
              vendorItem.accountNo = "";
              vendorItem.aid = 0;
              vendorItem.salestax = "";
              vendorItem.vendorName = this.state.formData.vendorName;
              vendorSelected.push(vendorItem);
              // this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
              if (vendorSelected[0].vendorName.length > 0) {
                /* Added to improve speed of Invoice Page */
                this.VendorSearchlistWithKey(
                  vendorSelected[0].vendorName,
                  this.state.moveHID.hidValue
                );
              }
              this.GetAccountingPeriod(this.state.moveHID.hidValue, 1);
              requestlist.oprID = this.state.moveoprID;
              requestlist.vid = formData.vendorID;
              this.setState(
                {
                  coaList: [],
                  splitHIDList: [],
                  subVendorList: [],
                  projectList: [],
                  isOpenViewer: false,
                  isEntryMoved: true,
                },
                () => {
                  this.GetHotelCOAlist(requestlist);
                  this.handleMultiContract(this.state.moveHID.hidValue);
                }
              );
            } else {
              let splitData: any = [];
              splitData = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.splitData))
              );
              splitData.forEach((element) => {
                element.defaultEhid = this.state.hotelName;
                element.lettercode = this.state.hotelName;
                element.spiltHoteID = this.state.hotelValue;
              });
              this.setState({ splitData });
            }
            toast.success(
              "The transaction has been moved and is ready to make changes.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              }
            );
          }
        );
      }
    );
  }

  hideMoveInvoiceModal = (event: any) => {
    this.setState({
      showInvoiceModal: false,
      moveHID: { hidValue: -1, hidName: "" },
      moveoprID: -1,
      accountNameMove: "Account",
    });
  };

  hideVoidModal = (event: any) => {
    let voidPeriodLST = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.voidPeriodList))
    );
    this.setState(
      {
        selectedVoid: [],
        copyIds: [],
        showVoidModal: false,
        transcationvoidDate: this.state.chkvoidDate,
        voidNotes: "",
        voidPeriodList: [],
        defaultvoidPeriod:
          this.state.selectdefaultperiod.length === 0
            ? "Accounting Period"
            : this.state.selectdefaultperiod,
        voidPeriod: this.state.selectdefaultperiod,
      },
      () => {
        this.setState({ voidPeriodList: voidPeriodLST });
      }
    );
  };

  handleMultiContract = (movedhidValue: any) => {
    this.contractDetails(
      movedhidValue,
      this.state.formData.vendorName,
      this.state.formData.vendorID,
      "Current",
      "App"
    );
  };

  contractDetails = (movedhidValue, vendorName, vid, vendorType, approval) => {
    let vendorContractRequest: any = {};
    vendorContractRequest.hotelID = movedhidValue;
    vendorContractRequest.vendorType = vendorType;
    vendorContractRequest.VendorId = vid;
    registersevice
      .GetVendorContract(vendorContractRequest)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          if (result.length === 1) {
            let formData = { ...this.state.formData };
            formData.vendorContract = result[0].accountNo;
            formData.aid = result[0].aid;
            this.setState({ formData: formData });
            let vendorSelected: any = [];
            let vendorItem: any = {};
            vendorItem.id = this.state.formData.vendorID;
            vendorItem.accountNo = result[0].accountNo;
            vendorItem.aid = result[0].aid;
            vendorItem.salestax = result[0].salestax;
            vendorItem.vendorName = this.state.formData.vendorName;
            vendorSelected.push(vendorItem);
            this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
          } else {
            this.vendorSearch?.current.contractDetails(
              vendorName,
              vid,
              vendorType,
              approval
            );
          }
        } else {
          this.vendorSearch.current.addNewContract(
            vendorName,
            vid,
            vendorType,
            movedhidValue
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleDescriptionBlur = (btnID, txtID, rowIndex, e: any) => {
    let relatedTargetID = e.relatedTarget?.id;
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isDescription = "No";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        if (relatedTargetID === undefined) {
          //nothing
        } else if (relatedTargetID.includes("ddlEHID")) {
          let btnID = "ddlEHID" + rowIndex + "ddl";
          $("#tblSplit")
            .find("button[id^='" + btnID + "']")
            .focus();
        } else if (relatedTargetID.includes("COA")) {
          let txtID =
            "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
          let btnID = "COA" + rowIndex + "btn";
          // $("input[class^='" + txtID + "']").focus();
          $("#tblSplit")
            .find("button[id^='" + relatedTargetID + "']")
            .focus();
        } else if (relatedTargetID.includes("btndesc")) {
          $("#tblSplit")
            .find("button[id^='" + relatedTargetID + "']")
            .focus();
        } else {
          let txtID1 = "txtamt" + rowIndex + "txt";
          $("#tblSplit")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        }
      })
    );

    //  $("#tblSplit").find("button[id^='" + btnID + "']").css("display", 'block');
    //$("#tblSplit").find("input[id^='" + txtID + "']").css("display", 'none');
  };

  handleDescriptionFocus = (btnID, txtID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isDescription = "Yes";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
      })
    );
  };

  handleCOABlur = (btnID, txtID, ddlID) => {
    $("#tblSplit")
      .find("button[id^='" + btnID + "']")
      .css("display", "block");
    $("#tblSplit")
      .find("div[id^='" + txtID + "']")
      .css("display", "none");
  };

  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isCOA = "Yes";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        $("input[class^='" + ddlID + "']").focus();
      })
    );
  };

  onTAB = (control, event) => {
    let isSubvendor = this.state.tableColumnList.filter(
      (e) => e.id === "sub vendor"
    )[0].isChecked;
    let isProject = this.state.tableColumnList.filter(
      (e) => e.id === "project"
    )[0].isChecked;
    let isDescription = this.state.tableColumnList.filter(
      (e) => e.id === "description"
    )[0].isChecked;
    if (event.key.toLowerCase() === "tab") {
      let controlID = control.split("-")[0];
      let rowIndex = Number(control.split("-")[1]);
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      if (
        controlID === "ddlCOA" &&
        rowIndex >= 1 &&
        splitData[rowIndex]["coa"] === ""
      ) {
        let txtID = "btnSavetran";
        $("button[id^='" + txtID + "']").focus();
        setTimeout(() => {
          $("button[id^='" + txtID + "']").focus();
        }, 50);
      } else if (
        controlID === "ddlCOA" &&
        rowIndex === 0 &&
        splitData[rowIndex]["coa"] === ""
      ) {
        if (isSubvendor) {
          let txtID = "ddlSubVendor-" + rowIndex + "ddl";
          setTimeout(() => {
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else if (isProject) {
          let txtID = "ddlProject-" + rowIndex + "ddl";
          setTimeout(() => {
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else if (isDescription) {
          let txtID = "txtdesc" + rowIndex + "txt";
          let btnID = "btndesc" + rowIndex + "btn";
          setTimeout(() => {
            $("#tblSplit")
              .find("button[id^='" + btnID + "']")
              .css("display", "none");
            $("#tblSplit")
              .find("input[id^='" + txtID + "']")
              .css("display", "block");
            $("#tblSplit")
              .find("input[id^='" + txtID + "']")
              .focus();
          }, 50);
        } else {
          let txtID = "txtamt" + rowIndex + "txt";
          setTimeout(() => {
            $("#tblSplit")
              .find("input[id^='" + txtID + "']")
              .focus();
          }, 50);
        }
      } else if (controlID === "ddlEHID") {
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "trdate") {
        this.trdate.current.setOpen(false);
        let txtID = "trenddate";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "trdate1") {
        this.trdate1.current.setOpen(false);
        let txtID = "trenddate";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "trenddate") {
        this.trenddate.current.setOpen(false);
        // let txtID = "txtdueDate";
        // setTimeout(() => {
        //     $("input[id^='" + txtID + "']").focus();
        // }, 50);
      } else if (controlID === "btnIncompleteInvoice") {
        let txtID = "btnInvoice";
        setTimeout(() => {
          $("button[id^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "btnInvoice") {
        let txtID = "rbt-input-main form-control rbt-input my-Vendor";
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      }
    }
  };

  handleOutsideClick = (rowIndex: any, e: any) => {
    let btnId = "COA" + rowIndex + "btn";
    let id = "coa" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;

    let isSubvendor = this.state.tableColumnList.filter(
      (e) => e.id === "sub vendor"
    )[0].isChecked;
    let isProject = this.state.tableColumnList.filter(
      (e) => e.id === "project"
    )[0].isChecked;
    let isDescription = this.state.tableColumnList.filter(
      (e) => e.id === "description"
    )[0].isChecked;

    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (splitData[rowIndex].coaName.length === 0) {
      splitData[rowIndex].coaName = "";
      splitData[rowIndex].coa = "";
      splitData[rowIndex].defaultCoa = [];
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            let btnID = "ddlEHID" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("txtamt")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (isSubvendor) {
            let txtID = "ddlSubVendor-" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          } else if (isProject) {
            let txtID = "ddlProject-" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          } else if (isDescription) {
            let txtID = "txtdesc" + rowIndex + "txt";
            let btnId = "btndesc" + rowIndex + "btn";
            $("#tblSplit")
              .find("button[id^='" + btnId + "']")
              .focus();
          }
        })
      );
    } else {
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            let btnID = "ddlEHID" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("txtamt")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (isSubvendor) {
            let txtID = "ddlSubVendor-" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          } else if (isProject) {
            let txtID = "ddlProject-" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + txtID + "']")
              .focus();
          } else if (isDescription) {
            let txtID = "txtdesc" + rowIndex + "txt";
            let btnId = "btndesc" + rowIndex + "btn";
            $("#tblSplit")
              .find("button[id^='" + btnId + "']")
              .focus();
          }
        })
      );
    }

    // $("#tblSplit").find("button[id^='" + btnId + "']").css("display", 'block');
    // $("#tblSplit").find("div[id^='" + id + "']").css("display", 'none');
  };

  handleBlur = (event, rowIndex) => {
    if (event.key.toLowerCase() === "tab") {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      splitData[rowIndex].amount =
        event.target.value === ""
          ? ""
          : !isNaN(event.target.value)
            ? Number(event.target.value).toFixed(2)
            : 0;
      this.setState({ splitData }, () => {
        if (splitData.length === rowIndex + 1) {
          this.handleNewRow();
        }
      });
    }
  };

  onSplitAmountFocus = (e, rowIndex, txtID) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newval = Utils.removecurrencyFormat(e.target.value);
    splitData[rowIndex].amount = newval;
    this.setState({ splitData }, () => {
      $("#tblSplit")
        .find("input[id^='" + txtID + "']")
        .focus();
    });
  };

  amountBlur = (e, rowIndex) => {
    // if (Number(e.target.value) === 0) {
    //     let splitData = Object.assign([], JSON.parse(JSON.stringify(this.state.splitData)));
    //     splitData[rowIndex].amount = "";
    //     this.setState({ splitData })
    // } else

    if (e.target.value.includes(".")) {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        splitData[rowIndex].amount = Utils.currencyFormatWithOutdoller(
          timeArray[0]
        ); // Number(timeArray[0]).toFixed(2);
      } else {
        splitData[rowIndex].amount = Utils.currencyFormatWithOutdoller(
          e.target.value
        );
      }
      this.setState({ splitData });
    } else {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      splitData[rowIndex].amount =
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
            ? Utils.currencyFormatWithOutdoller(e.target.value)
            : 0;
      this.setState({ splitData });
    }
  };

  componentDidMount() {
    
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
    requestlist.hotelID = this.state.hotelValue;
    requestlist.oprID = this.props.accDetails.oprID;
    let etype = this.getEtype();
    requestlist.etype = this.getEtype();
    formData.hotelID = this.state.hotelValue;
    formData.oprID = this.props.accDetails.oprID;
    formData.entryType = etype;
    formData.pageType = etype;


    if ((this.props.pageType?.toLowerCase() === "deposit" || this.props.pageType?.toLowerCase() === "withdrawal")) {
      this.getReviewPermissions(this.state.hotelValue, "");
    }

    if (etype === "Withdrawal" && this.props.uniqueNo === 0) {
      formData.paymenttype = "Manual ACH";
    }

    if (
      this.props.uniqueNo === 0 &&
      (this.state.isReconcilePage || this.props.isBankSyncPage) &&
      (etype === "Misc" || etype === "MiscDeposit")
    ) {
      formData.paymenttype = "Manual ACH";
    }
    // if (etype === 'payment') {
    //     this.GetInvoicePaymentType(this.state.hotelValue);
    // }
    // Repeating Entries //
    if (this.props.isFromRepeating) {
      formData.isRepeat = "Yes";
      this.setState({ isRepeat: true });
    }
    this.IsTransactionRolePermission(requestlist, etype);
    if (this.props.uniqueNo === 0 && etype !== "payment") {
      formData.accPeriodstatus = "Active";
      formData.concilestatus = "No";
      this.setState({
        hotelName: this.props.hotelName,
        accountName: this.props.accDetails.accountName,
      });
    }
    if (this.props.uniqueNo === 0) {
      this.GetTempUploadTransNo();
    }
    //Slide-out pre populated values from bank Sync Page -- Start(NW-18318)
    if (this.props.accDetails?.isNewTransBankSync) {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      let transTotal = Utils.currencyFormat(this.props.accDetails?.totalAmount);
      formData.transactionTotal = transTotal;
      formData.transcationDate = this.props.accDetails?.transDate;
      splitData[0].description = this.props.accDetails?.description;
      splitData[0].amount = Utils.currencyFormatWithOutdoller(
        this.props.accDetails?.totalAmount
      );
      this.setState({ totalAmount: transTotal, splitData });
    }
    // End Here
    this.setState(
      { formData, requestlist, accountType: this.props.accDetails.acctType },
      () => {
        if (etype !== "payment") {
          // this.vendorSearch?.current.GetVendorTranlist(requestlist);   /* Added/Commented to improve speed of Withdrawal Slideout */
        }
        let txtID = "rbt-input-main form-control rbt-input";
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 100);
        this.getFileSize();
      }
    );
  }

  GetTempUploadTransNo = () => {
    let request: any = {};
    request.EType = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.getEtype();
    registersevice
      .GetTempUploadTransNo(request)
      .then(async (result: any) => {
        if (result !== null) {
          this.setState(
            { tempUniqueNo: result.result, slideEntryType: "newEntry" },
            () => {
              if (this.state.isCopyHasAttachment) {
                this.SaveCopyTempWithFile([]);
              }
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        setTimeout(() => {
          this.closeSlideOut();
        }, 1500);
        reject();
      });
  };

  getPaymentDetails() {
    let selectedRow: any = {};
    let paymentrequest: any = {};
    selectedRow = this.props.selectedRow;
    selectedRow.checkno =
      selectedRow.checkno.toUpperCase() === "EPay"
        ? "ACH"
        : selectedRow.checkno;

    paymentrequest.hotelID = selectedRow.hid;
    paymentrequest.uniqueNo = selectedRow.groupID;
    paymentrequest.oprID = selectedRow.oprId;
    //  paymentrequest.CkNo = selectedRow.checkno;
    paymentrequest.CkNo =
      selectedRow.checkno.toUpperCase() === "ACH"
        ? "ACH"
        : selectedRow.checkno.toUpperCase() === "Manual ACH"
          ? "ACH"
          : selectedRow.checkno.toUpperCase() === "Credit Card".toUpperCase()
            ? "Credit Card"
            : selectedRow.checkno.toUpperCase().includes("ACH")
              ? "ACH"
              : selectedRow.checkno;

    paymentrequest.series = selectedRow.series;
    paymentrequest.postFix =
      selectedRow.invPostFix.length > 0 ? selectedRow.invPostFix : "";

    registersevice
      .GetAssociatedPayment(paymentrequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          let formData = { ...this.state.formData };
          formData.vendorID = result[0].vid;
          formData.vendorName = result[0].vendor;
          formData.vendorContract = result[0].addContract;
          formData.transcationDate = new Date(result[0].ckDate);
          formData.internalNotes = result[0].memo;
          formData.uniqueno = result[0].paymentUniqueno;
          formData.checkNo = result[0].ckNo;
          formData.adj = result[0].adj;
          formData.aid = result[0].aid;
          formData.chkDate = result[0].ckDate;
          formData.paymenttype = result[0].ckNo;
          let defaultpaymentType = result[0].ckNo;

          this.setState(
            {
              isError: result[0].isError,
              hotelName: result[0].lettercode,
              accountName: result[0].acctName,
              formData: formData,
              isRepeat: false,
              totalAmount: Utils.currencyFormat(result[0].checkTotal),
              associatedPayment: result,
              transcationvoidDate: result[0].ckDate,
              chkvoidDate: result[0].ckDate,
              voidConcile: result[0].isConcile,
              printStatus: result[0].printStatus,
              associatedPaymentEtype: result[0].etype,
              isCreditcardPayment: result[0].isCreditcardPayment,
              defaultpaymentType: defaultpaymentType,
              isApprove: result[0].isApprove,
              oldPaymentType: result[0].ckNo,
              epayCheckNo: result[0].epayCheckNo,
              epayDigitalID: result[0].digitalID,
              isPaymentStatus: result[0].paymentType,
              ePayMethod: result[0].ePayMethod,
              paymentSentDT: result[0].sentdate,
            },
            () => {
              this.getUploadedFileList(1);
              this.GetInvoicePaymentType(this.state.hotelValue);
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  getNewEtype(acctType: any) {
    let etype = "";
    if (
      acctType.toLowerCase() === "O".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "Deposit";
    } else if (
      acctType.toLowerCase() === "O".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "Withdrawal";
    } else if (
      acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "Misc";
    } 
    else if (
      acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Misc".toLowerCase()
    ) {
      etype = "Misc";
    }else if (
      acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "MiscDeposit";
    }
    else if (
      acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "MiscDeposit".toLowerCase()
    ) {
      etype = "MiscDeposit";
    } else if (
      acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "PayrollWithdrawal";
    }
    else if (
      acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "PayrollWithdrawal".toLowerCase()
    ) {
      etype = "PayrollWithdrawal";
    } else if (
      acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "PayrollDeposit";
    } 
    else if (
      acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "PayrollDeposit".toLowerCase()
    ) {
      etype = "PayrollDeposit";
    } else if (acctType.toLowerCase() === "payment".toLowerCase()) {
      etype = "payment";
    }
    return etype;
  }

  getEtype() {
    let etype = "";
    if (
      this.props.accDetails.acctType.toLowerCase() === "O".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "Deposit";
    } else if (
      this.props.accDetails.acctType.toLowerCase() === "O".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "Withdrawal";
    } else if (
      this.props.accDetails.acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "Misc";
    }
    else if (
      this.props.accDetails.acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Misc".toLowerCase()
    ) {
      etype = "Misc";
    } else if (
      this.props.accDetails.acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "MiscDeposit";
    }
    else if (
      this.props.accDetails.acctType.toLowerCase() === "M".toLowerCase() &&
      this.props.pageType.toLowerCase() === "MiscDeposit".toLowerCase()
    ) {
      etype = "MiscDeposit";
    } else if (
      this.props.accDetails.acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "Withdrawal".toLowerCase()
    ) {
      etype = "PayrollWithdrawal";
    }
    else if (
      this.props.accDetails.acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "PayrollWithdrawal".toLowerCase()
    ) {
      etype = "PayrollWithdrawal";
    } else if (
      this.props.accDetails.acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "deposit".toLowerCase()
    ) {
      etype = "PayrollDeposit";
    } 
    else if (
      this.props.accDetails.acctType.toLowerCase() === "P".toLowerCase() &&
      this.props.pageType.toLowerCase() === "PayrollDeposit".toLowerCase()
    ) {
      etype = "PayrollDeposit";
    }else if (this.props.pageType.toLowerCase() === "payment".toLowerCase()) {
      etype = "payment";
    }
    return etype;
  }

  closeSlideOut() {
    this.setState({ isStateChanged: false }, () => {
      this.props.hideSlideOut(this.state.isSave);
    });
  }

  hideSlideOut() {
    if (this.state.isStateChanged) {
      this.isValidateModelPoupTab();
    } else {
      this.setState({ isStateChanged: false }, () => {
        this.props.hideSlideOut(this.state.isSave);
      });
    }
  }

  onFileChange = (event: any, mode) => {
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles);
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  getFileSize() {
    registersevice.GetFileSize().then(async (result: any | null) => {
      if (result > 0) {
        this.setState({ fileSize: result });
      }
    });
  }

  onDrop = (filelist: any) => {
    let size = this.state.fileSize; //5242880//5MB
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    let newfiles: any = [...this.state.newSelectedfiles];
    let isReturn = true;
    let filestext = "";

    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceInbox",
      });
    }
    let isInvalidFile = false;

    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
    }
    newfiles = _.sortBy(newfiles, "name");
    this.setState(
      { files: newfiles, newSelectedfiles: newfiles /*isStateChanged: true*/ },
      () => {
        this.SaveTempWithFile(newfiles);
      }
    );
  };

  SaveTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { formData, slideEntryType, tempUniqueNo } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let acctType = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.state.formData.entryType;
    request.TenantID = tenantID;
    request.actionType = "";
    request.iscopyAttachment = "No";
    request.TempUniqueNo = this.state.isRepeat
      ? tempUniqueNo
      : slideEntryType === "newEntry"
        ? tempUniqueNo
        : "";
    request.UniqueNo = slideEntryType === "newEntry" ? 0 : formData.uniqueno;
    request.oldUniqueNo = slideEntryType === "newEntry" ? 0 : formData.uniqueno;
    request.TypeFrom = acctType;
    request.OldTypeFrom =
      slideEntryType === "newEntry" ? "TempUploadFiles" : acctType;

    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            //   toast.success("Attachment uploaded successfully", { position: toast.POSITION.BOTTOM_RIGHT });
            this.getUploadedFileList(1);
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.getUploadedFileList(1);
            this.setState({ isDisabled: false });
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  GetAccountingPeriod = (hidValue: any, srno) => {
    let requestlist: any = {};
    requestlist.hotelID = hidValue;
    requestlist.etype = this.props.pageType;
    let accPeriod: any = [];
    registersevice
      .GetAccountingPeriod(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          result.forEach((element) => {
            let item: any = {};
            item.id = element.accperiod;
            item.name = element.accperiod;
            accPeriod.push(item);
          });
          if (srno === 1) {
            this.setState({ accPeriodList: [] }, () => {
              let defaultper = this.state.isReconcilePage
                ? this.props.accper
                : accPeriod.length > 0
                  ? result[0].defaultPeriod
                  : "";
              if (accPeriod.length > 0 && this.props.uniqueNo === 0) {
                let formData = { ...this.state.formData };
                if (this.props.isBankSyncPage) {
                  defaultper = moment(
                    new Date(
                      new Date(this.props.accDetails?.transDate).getFullYear(),
                      new Date(this.props.accDetails?.transDate).getMonth(),
                      1
                    )
                  ).format("MM/DD/YY");
                }
                formData.accPeriod = defaultper;
                this.setState({
                  defaultaccountingPeriod: defaultper,
                  formData,
                  defaultaccountingPeriod1: defaultper,
                });
              }
              this.setState({
                accPeriodList: accPeriod,
                selectdefaultperiod: defaultper,
              });
            });
          } else if (srno === 3) {
            this.setState({ accPeriodList: [] }, () => {
              if (accPeriod.length > 0) {
                let defaultper = result[0].defaultPeriod;
                let formData = { ...this.state.formData };
                formData.accPeriod = defaultper;
                this.setState({
                  voidPeriodList: accPeriod,
                  defaultvoidPeriod:
                    defaultper.length === 0 ? "Accounting Period" : defaultper,
                  voidPeriod: defaultper,
                  selectdefaultperiod: defaultper,
                });
              }
            });
          } else {
            this.setState({ PeriodList: [] }, () => {
              setTimeout(() => {
                if (
                  accPeriod.filter(
                    (e) => e.id === this.state.formData.accPeriod
                  ).length === 0
                ) {
                  this.setState({
                    PeriodList: accPeriod,
                    defaultPeriod: "Accounting Period",
                    selectedPeriod: "",
                  });
                } else {
                  this.setState({
                    PeriodList: accPeriod,
                    defaultPeriod: this.state.formData.accPeriod,
                    selectedPeriod: this.state.formData.accPeriod,
                  });
                }
              }, 100);
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  GetInvoicePaymentType(hotelValue: any) {
    let requestlist: any = {};
    requestlist.hotelID = hotelValue;

    let Typelist: any = [];

    registersevice
      .GetInvoicePaymentType(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          result.forEach((element) => {
            let item: any = {};
            item.id = element.id;
            item.name = element.name;
            Typelist.push(item);
          });

          this.setState({ paymentTypelist: Typelist, paymentType: Typelist });
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  IsTransactionRolePermission = (requestlist: any, etype: any) => {
    this.setState({ isSpinner: true });
    registersevice
      .IsTransactionRolePermission(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            this.setState(
              {
                isPermission: result[0].isPermission,
                isDeletePermission: result[0].isDeletePermission,
                rePrintOldCheck: result[0].reprintOldCheck,
                isMovePermission: result[0].isMovePermission,
                isInvoiceLoading:
                  false /* Added/Commented to improve speed of Withdrawal Slideout */,
              },
              () => {
                if (this.state.isDeletePermission === "Yes") {
                  let moreActionFileUpload_1: any = [
                    { name: "Delete", eventKey: "delete" },
                    { name: "Download", eventKey: "download" },
                  ];
                  this.setState({
                    moreActionFileUpload1: moreActionFileUpload_1,
                  });
                } else {
                  let moreActionFileUpload_2: any = [
                    { name: "Download", eventKey: "download" },
                  ];
                  this.setState({
                    moreActionFileUpload1: moreActionFileUpload_2,
                  });
                }

                if (this.props.uniqueNo === 0 && etype !== "payment") {
                  this.GetAccountingPeriod(this.state.hotelValue, 1);
                }

                if (this.props.uniqueNo > 0 && (this.props.pageType?.toLowerCase() === "deposit" || this.props.pageType?.toLowerCase() === "withdrawal")) {
                  this.GetTransactionComment(
                    this.props.uniqueNo
                  );
                }

                if (
                  this.props.uniqueNo > 0 &&
                  etype !== "payment" &&
                  this.props.isFromRepeating
                ) {
                  this.GetTranToUpdateRep(requestlist);
                  this.getUploadedFileList2(); /* Added/Commented to improve speed of Withdrawal Slideout */
                  this.GetCOADatalist(
                    requestlist
                  ); /* Added/Commented to improve speed of Withdrawal Slideout */
                  let intervalId = setInterval(() => {
                    /* Added/Commented to improve speed of Withdrawal Slideout */
                    if (
                      this.state.isInvoiceLoading &&
                      this.state.COADataCount > 0
                    ) {
                      this.loadCOADataList();
                    }
                  }, 500);

                  this.setState({ intervalId: intervalId });
                } else if (this.props.uniqueNo > 0 && etype !== "payment") {
                  this.GetTranToUpdate(requestlist);
                  this.getUploadedFileList2(); /* Added/Commented to improve speed of Withdrawal Slideout */
                  this.GetCOADatalist(
                    requestlist
                  ); /* Added/Commented to improve speed of Withdrawal Slideout */
                  let intervalId = setInterval(() => {
                    /* Added/Commented to improve speed of Withdrawal Slideout */
                    if (
                      this.state.isInvoiceLoading &&
                      this.state.COADataCount > 0
                    ) {
                      this.loadCOADataList();
                    }
                  }, 500);

                  this.setState({ intervalId: intervalId });
                }

                if (etype === "payment") {
                  //this.GetInvoicePaymentType(this.state.hotelValue);

                  this.getPaymentDetails();

                  this.GetAccountingPeriod(this.state.hotelValue, 3);
                }
              }
            );
            // this.setState({ isSpinner: false })
            if (this.props.uniqueNo > 0 && etype !== "payment") {
            } else {
              this.setState({ isSpinner: false });
            }
          } else {
            this.setState({ isSpinner: false });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetVendorTranlist = (requestlist: any) => {
    registersevice
      .GetVendorTranlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ vendorList: result });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  updateVendorList = (result: any) => {
    this.setState({ vendorList: result });
  };

  GetTransactionEntryColoumn = (formData: any) => {
    this.setState({ isSpinner: true });
    let saveRequest: any = {};
    saveRequest.hotelID = formData.hotelID;
    saveRequest.vid = formData.vendorID;
    registersevice
      .GetTransactionColoumn(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            let activeCol = result[0].columnname.split(",");
            let data = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.tableColumnList))
            );
            data.map((item) => (item.isChecked = false));
            data.forEach((element) => {
              let x = activeCol.filter((e) => e === element.id);
              if (x.length > 0) {
                element.isChecked = true;
              }
            });

            let splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );
            let hidExist = splitData.filter((e) => e.spiltHoteID !== "").length;
            // let amountExist =splitData.filter(e=>e.amount !=='').length;
            // let coaExist =splitData.filter(e=>e.coa !=='').length;
            let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
            let projectNameExist = splitData.filter((e) => e.pID > 0).length;
            let descriptionExist = splitData.filter(
              (e) => e.description !== ""
            ).length;

            let chekedColumns = data
              .filter((item) => item.isChecked)
              ?.map((item) => item.name?.toUpperCase());
            const transactionsColumns = this.transactionsColumns.map((item) => {
              // if (this.state.splitHIDList.length > 1 && item.text?.toUpperCase() === "EHID".toUpperCase()) {
              //     item.hidden = false;
              // }
              // else
              if (
                subVendorExist > 0 &&
                item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
              ) {
                item.hidden = false;
              } else if (
                projectNameExist > 0 &&
                item.text?.toUpperCase() === "Project".toUpperCase()
              ) {
                item.hidden = false;
              } else if (
                descriptionExist > 0 &&
                item.text?.toUpperCase() === "Description".toUpperCase()
              ) {
                item.hidden = false;
              } else {
                item.hidden =
                  chekedColumns.includes(item.text?.toUpperCase()) || !item.text
                    ? false
                    : true;
              }
              return item;
            });
            this.setState({ transactionsColumns: [] }, () => {
              this.setState({
                tableColumnList: data,
                HIDColumn: true,
                transactionsColumns,
                isSpinner: false,
              });
            });
          } else {
            let splitData = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.splitData))
            );

            let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
            let projectNameExist = splitData.filter((e) => e.pID > 0).length;
            let data = Object.assign(
              [],
              JSON.parse(JSON.stringify(this.state.CopytableColumnList))
            );
            data
              .filter((item) => item.isChecked)
              ?.map((item) => item.name?.toUpperCase());
            const transactionsColumns = this.transactionsColumns.map((item) => {
              if (
                subVendorExist === 0 &&
                item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
              ) {
                item.hidden = true;
              } else if (
                projectNameExist === 0 &&
                item.text?.toUpperCase() === "Project".toUpperCase()
              ) {
                item.hidden = true;
              } else {
                item.hidden = false;
              }
              return item;
            });
            this.setState({
              tableColumnList: data,
              transactionsColumns,
              isSpinner: false,
            });
          }
        } else {
          this.setState({ isSpinner: false });
        }

        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  GetCOADatalist = (requestlist: any) => {
    /* API for Split Data */   
    requestlist.etype = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : requestlist.etype; // this.getEtype();
    requestlist.isFromRepeating = this.props.isFromRepeating ? "yes" : "no";
    registersevice
      .GetCOADatalist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ COAData: result, COADataCount: 1 });
        } else {
          this.setState({ isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  loadCOADataList = () => {
    /* Added/Commented to improve speed of Withdrawal Slideout */

    let splitData: any = [];

    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newRow = this.state.newRow;
    let result: any = [];
    result = this.state.COAData;

    let dtarr = result.selectedHotelList.filter(
      (e) => e.id === this.state.hotelValue
    );
    if (
      this.props.uniqueNo === 0 ||
      this.state.formData.actionType === "move"
    ) {
      splitData.forEach((element) => {
        element.defaultEhid = this.state.hotelName;
        element.lettercode = this.state.hotelName;
        element.spiltHoteID = this.state.hotelValue;
        element.splitoprID = dtarr[0]?.splitOprID;
        element.defaultVendor = "Select Sub Vendor";
        element.defaultProject = "Select Project";
        element.subVID = "0";
        element.subVendor = "";
        element.pID = "0";
        element.projectName = "";
        element.subVendorlist = result.vendorBYHIDList.filter(
          (x) => x.hid === this.state.hotelValue
        );
        element.projectlist = result.projectBYHIdList.filter(
          (x) => x.hid === this.state.hotelValue
        );
      });
    } else {
      if (splitData.length> 0 &&  splitData[0].lettercode === "") {
        splitData.forEach((element) => {
          element.defaultEhid = this.state.hotelName;
          element.lettercode = this.state.hotelName;
          element.spiltHoteID = this.state.hotelValue;
          element.splitoprID = dtarr[0]?.splitOprID;
          element.defaultVendor = "Select Sub Vendor";
          element.defaultProject = "Select Project";
          element.subVID = "0";
          element.subVendor = "";
          element.pID = "0";
          element.projectName = "";
          element.subVendorlist = result.vendorBYHIDList.filter(
            (x) => x.hid === this.state.hotelValue
          );
          element.projectlist = result.projectBYHIdList.filter(
            (x) => x.hid === this.state.hotelValue
          );
        });
      }
    }

    if (Number(this.props.uniqueNo) > 0) {
      splitData.forEach((element) => {
        element.subVendorlist = result.vendorBYHIDList.filter(
          (x) => x.hid === element.spiltHoteID
        );
        element.projectlist = result.projectBYHIdList.filter(
          (x) => x.hid === element.spiltHoteID
        );
      });
    }

    newRow.defaultEhid = this.state.hotelName;
    newRow.lettercode = this.state.hotelName;
    newRow.spiltHoteID = this.state.hotelValue;
    newRow.splitoprID = dtarr[0]?.splitOprID;
    newRow.subVendorlist = result.vendorBYHIDList.filter(
      (x) => x.hid === this.state.hotelValue
    );
    newRow.projectlist = result.projectBYHIdList.filter(
      (x) => x.hid === this.state.hotelValue
    );

    this.setState({ splitData: [], defaultSplitData: [] }, () => {
      this.setState(
        {
          splitData: splitData,
          newRow: newRow,
          defaultSplitData: splitData,
          coaList: result.transactionChartList,
          splitHIDList: result.selectedHotelList,
          subVendorList: result.vendorBYHIDList,
          projectList: result.projectBYHIdList,
        },
        () => {
          this.setState({ isInvoiceLoading: false, COADataCount: 0 });
          window.clearInterval(this.state.intervalId);
          let formData = { ...this.state.formData };
          this.GetTransactionEntryColoumn(formData);
        }
      );
    });
  };

  GetHotelCOAlist = (requestlist: any) => {
    this.setState({ isSpinner: true });
    let splitData: any = [];
    let newRow: any = {};
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    registersevice
      .GetHotelCOAlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          let dtarr = result.selectedHotelList.filter(
            (e) => e.id === this.state.hotelValue
          );
          if (
            this.props.uniqueNo === 0 ||
            this.state.formData.actionType === "move"
          ) {
            splitData.forEach((element) => {
              element.defaultEhid = this.state.hotelName;
              element.lettercode = this.state.hotelName;
              element.spiltHoteID = this.state.hotelValue;
              element.splitoprID = dtarr[0]?.splitOprID;
              element.defaultVendor = "Select Sub Vendor";
              element.defaultProject = "Select Project";
              element.subVID = "0";
              element.subVendor = "";
              element.pID = "0";
              element.projectName = "";
              element.subVendorlist = result.vendorBYHIDList.filter(
                (x) => x.hid === this.state.hotelValue
              );
              element.projectlist = result.projectBYHIdList.filter(
                (x) => x.hid === this.state.hotelValue
              );
            });
          } else {
            if (splitData[0].lettercode === "") {
              splitData.forEach((element) => {
                element.defaultEhid = this.state.hotelName;
                element.lettercode = this.state.hotelName;
                element.spiltHoteID = this.state.hotelValue;
                element.splitoprID = dtarr[0]?.splitOprID;
                element.defaultVendor = "Select Sub Vendor";
                element.defaultProject = "Select Project";
                element.subVID = "0";
                element.subVendor = "";
                element.pID = "0";
                element.projectName = "";
                element.subVendorlist = result.vendorBYHIDList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
                element.projectlist = result.projectBYHIdList.filter(
                  (x) => x.hid === this.state.hotelValue
                );
              });
            }
          }

          if (Number(this.props.uniqueNo) > 0) {
            splitData.forEach((element) => {
              element.subVendorlist = result.vendorBYHIDList.filter(
                (x) => x.hid === element.spiltHoteID
              );
              element.projectlist = result.projectBYHIdList.filter(
                (x) => x.hid === element.spiltHoteID
              );
            });
          }

          newRow.defaultEhid = this.state.hotelName;
          newRow.lettercode = this.state.hotelName;
          newRow.spiltHoteID = this.state.hotelValue;
          newRow.splitoprID = dtarr[0]?.splitOprID;
          newRow.subVendorlist = result.vendorBYHIDList.filter(
            (x) => x.hid === this.state.hotelValue
          );
          newRow.projectlist = result.projectBYHIdList.filter(
            (x) => x.hid === this.state.hotelValue
          );

          this.setState({ splitData: [], defaultSplitData: [] }, () => {
            this.setState(
              {
                splitData: splitData,
                newRow: newRow,
                defaultSplitData: splitData,
                coaList: result.transactionChartList,
                splitHIDList: result.selectedHotelList,
                subVendorList: result.vendorBYHIDList,
                projectList: result.projectBYHIdList,
              },
              () => {
                let formData = { ...this.state.formData };
                this.GetTransactionEntryColoumn(formData);
              }
            );
          });
        } else {
          this.setState({ isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  VendorSearchlistWithKey = (name, HID) => {
    /* Added/Commented to improve speed of Withdrawal Slideout */

    let request: any = {};
    request.etype = this.props.pageType;
    request.searchKey = name;
    request.hotelID = HID;
    registersevice
      .VendorSearchlistWithKey(request) //Vendor list service method
      .then(async (result: any | null) => {
        if (result !== null) {
          this.vendorSearch?.current.handleArrayFromParent(
            result
          ); /* Added to improve speed of Invoice Page */
          this.vendorSearch?.current.handleSelectFromParent(
            this.state.vendorSelected
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetPreviousTransactionList = (requestlist: any) => {
    requestlist.vid = this.state.formData.vendorID;
    requestlist.etype = this.state.formData.entryType; // this.getEtype();
    registersevice
      .GetPreviousTransactionList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          let totalCount = 0;
          if (result.length > 0) {
            totalCount = result[0].totalCount;
          }
          this.setState({ previousTransactionsData: result, totalCount });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetTranToUpdate = (requestlist: any) => {
    this.setState({ isSpinner: true });
    requestlist.uniqueNo = this.props.uniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";
    requestlist.etype = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.state.formData.entryType; // this.getEtype();
    let splitData: any = [];
    let vendorSelected: any = [];
    let x = 2;
    registersevice
      .GetTranToUpdate(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
          if (result.tranEntryToUpdate[0] !== undefined) {
            let mainArray = result.tranEntryToUpdate[0];
            let splitArray = result.tranAmountEntryToUpdate;
            let uploadFiles = result.uploadFileList;
            let commentlist = result.commentlist;
            let isError = mainArray.isError;

            this.setState({ isError });
            if (isError === "Yes") {
              window.location.href = "/unauthorize-access?Error=NotFound";
            } else {
              for (let i = 0; i < uploadFiles.length; i++) {
                this["myRef" + i] = React.createRef();
              }

              let formData = { ...this.state.formData };
              let hotelName = mainArray.letterCode;
              let accountName = mainArray.acctName;
              formData.uniqueno = mainArray.uniqueno;
              formData.hotelID = mainArray.hotelID;
              formData.oprID = mainArray.oprID;
              formData.transcationDate = mainArray.date;
              formData.accPeriod = mainArray.accper;
              formData.vendorID = mainArray.vid;
              formData.vendorName = mainArray.vendor;
              formData.vendorContract = mainArray.contract;
              formData.aid = mainArray.aid;
              formData.saletax = mainArray.saleTax;
              formData.internalNotes = mainArray.internalnotes;
              formData.checkNo = mainArray.ckNo;
              formData.transactionTotal = Utils.currencyFormat(
                mainArray.transTotal
              );
              formData.entryType = mainArray.entryType;
              formData.accPeriodstatus = mainArray.accPerStatus;
              formData.concilestatus = mainArray.isReconcile;

              formData.vendorDays = mainArray.vendorDays;
              formData.vendorStatus = mainArray.vendorStatus;
              formData.contractStatus = mainArray.contractStatus;

              mainArray.ckNo =
                mainArray.ckNo.toString().toLowerCase() === "ach".toLowerCase()
                  ? "Manual ACH"
                  : mainArray.ckNo;

              let defaultpaymentType = "Select Type";
              let movePaymentType = "";
              if (
                mainArray.ckNo.toString().toLowerCase() !==
                "Ach".toLowerCase() &&
                mainArray.ckNo.toString().toLowerCase() !==
                "Manual Ach".toLowerCase() &&
                mainArray.entryType.toString().toLowerCase() === "misc"
              ) {
                formData.paymenttype = "Check";
                defaultpaymentType = "Check";
                movePaymentType = "Check";
              } else {
                formData.paymenttype = mainArray.ckNo;
                defaultpaymentType = mainArray.ckNo;
                movePaymentType = mainArray.ckNo;
              }

              let vendorItem: any = {};
              vendorItem.id = mainArray.vid;
              vendorItem.accountNo = mainArray.contract;
              vendorItem.aid = mainArray.aid;
              vendorItem.salestax = mainArray.saleTax;
              vendorItem.vendorName = mainArray.vendor;
              vendorSelected.push(vendorItem);
              let splitlist: any = [];
              if(splitArray.length > 0){
                splitArray.forEach((element) => {
                  let defaultCOA: any = [];
                  let objCOA: any = {};
                  objCOA.id = element.coa;
                  objCOA.label = element.defaultCoa;
                  defaultCOA.push(objCOA);
                  element.defaultCoa = defaultCOA;
                element.amount = Utils.currencyFormatWithOutdoller(
                    element.amount
                  );
                  element.subVendorlist = [];
                  element.projectlist = [];
                  splitData.push(element);

                let splitlistItem: any = [];

                  splitlistItem.coa = element.coa;
                  splitlistItem.spiltHoteID = element.spiltHoteID;
                  splitlistItem.subVID = element.subVID;
                  splitlistItem.pID = element.pID;
                  splitlistItem.description = element.description;
                splitlistItem.amount = Utils.currencyFormatWithOutdoller(
                    element.amount
                  );
                  splitlist.push(splitlistItem);
                });
              }
              else{
               
                  splitData = Object.assign(
                    [],
                    JSON.parse(JSON.stringify(this.state.splitData))
                  );
                  splitData.forEach((element) => {
                    element.defaultCoa = [];
                    element.subVendorlist = [];
                    element.projectlist = [];
                  });
                
              }
              let paymentType1: any = [];
              let paymentTypeWithdrawal: any = [];
              paymentType1 = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.paymentType))
              );
              paymentTypeWithdrawal = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.paymentTypeWithdrawal))
              );

              let requestlist1 = { ...this.state.requestlist };
              requestlist.hotelID = mainArray.hotelID;
              requestlist.oprID = mainArray.oprID;
              requestlist.vid = mainArray.vid;
              // let fileList: any = [];   /* Added/Commented to improve speed of Withdrawal Slideout */
              // uploadFiles.forEach(item => {
              //     item.newname = item.name.toString().toLowerCase()
              //     fileList.push(item)
              // })
              // fileList = _.sortBy(fileList, "newname");
              this.setState(
                {
                  splitActualList: splitlist,
                  requestlist: requestlist1,
                  hotelValue: mainArray.hotelID,
                  splitData: [],
                  paymentType: [],
                  paymentTypeWithdrawal: [],
                  defaultpaymentType: "",
                  isComment: false,
                },
                () => {
                  this.setState(
                    (prevState) => ({
                      htmlcomment: commentlist,
                      isComment: true,
                      movePaymentType,
                      hotelName: hotelName,
                      accountName: accountName,
                      // savedfiles: fileList,   /* Added/Commented to improve speed of Withdrawal Slideout */
                      splitData: splitData,
                      formData: formData,
                      paymentType: paymentType1,
                      paymentTypeWithdrawal: paymentTypeWithdrawal,
                      defaultaccountingPeriod: mainArray.accper,
                      vendorSelected: vendorSelected,
                      totalAmount: Utils.currencyFormat(mainArray.transTotal),
                      amountTotal: Utils.currencyFormat(mainArray.transTotal),
                      defaultpaymentType: defaultpaymentType,
                      showBadge: true,
                      isInvoiceLoading:
                        true /* Added/Commented to improve speed of Withdrawal Slideout */,
                      // isOpenViewer: fileList.length > 0,   /* Added/Commented to improve speed of Withdrawal Slideout */
                    }),
                    () => {
                      let requestlist = { ...this.state.requestlist };
                      requestlist.vid = mainArray.vid;
                      requestlist.hotelID = this.state.hotelValue;
                      requestlist.oprID = requestlist.oprID;
                      this.GetAccountingPeriod(this.state.hotelValue, 1);
                      // this.GetHotelCOAlist(requestlist);   /* Added/Commented to improve speed of Withdrawal Slideout */
                      // this.getUploadedFileList(1);   /* Added/Commented to improve speed of Withdrawal Slideout */

                      $(".disabled-area")
                        .find("input, textarea, button, select")
                        .attr("disabled", "disabled");
                    }
                  );
                }
              );
              //Call this after vendor list api call
              // this.vendorSearch.current.handleSelectFromParent(this.state.vendorSelected);
              if (this.state.vendorSelected[0].vendorName.length > 0) {
                /* Added/Commented to improve speed of Withdrawal Slideout */
                this.VendorSearchlistWithKey(
                  this.state.vendorSelected[0].vendorName,
                  mainArray.hotelID
                );
              }
            }
          } else {
            window.location.href = "/unauthorize-access?Error=NotFound";
          }
        } else {
          this.setState({ isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  getUploadedFileList = (mtype) => {
    let requestlist: any = {};
    requestlist.hotelID = this.state.formData.hotelID;
    requestlist.etype =
      this.state.slideEntryType === "newEntry"
        ? "TempUploadFiles"
        : this.state.formData.entryType;
    requestlist.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : this.state.formData.uniqueno;
    requestlist.checkNo = "";
    requestlist.series = "A";

    requestlist.etype =this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : requestlist.etype;

    this.setState({ isAttachmentLoading: true });
    registersevice
      .GetUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          filelist = _.sortBy(filelist, "newname");

          if (mtype === 1) {
            this.setState(
              { savedfiles: [], files: [], newSelectedfiles: [] },
              () => {
                this.setState(
                  (prevState) => ({
                    savedfiles: filelist,
                    isAttachmentLoading: false,
                    isOpenViewer: true, //prevState.isOpenViewer,
                    newSelectedfiles: [],
                    files: [],
                  }),
                  () => {
                    setTimeout(() => {
                      this.scrollheight.current?.getElement().scrollTo({
                        top: Number(this.state.currentScreenTop),
                        behavior: "smooth",
                      });
                    }, 500);
                  }
                );
              }
            );
          } else {
            this.setState({ savedfiles: [], files: [] }, () => {
              this.setState((prevState) => ({
                savedfiles: filelist,
                isAttachmentLoading: false,
                isOpenViewer: prevState.isOpenViewer,
                newSelectedfiles: [],
                files: [],
                bulkSelect: false,
              }));
            });
          }
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  getUploadedFileList2 = () => {
    /* Added/Commented to improve speed of Withdrawal Slideout */
    let requestlist: any = {};
    requestlist.hotelID = this.state.hotelValue;
    requestlist.etype =
      this.state.slideEntryType === "newEntry"
        ? "TempUploadFiles"
        : this.state.formData.entryType;
    requestlist.uniqueNo = this.props.uniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";

    requestlist.etype =this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" :requestlist.etype;

    this.setState({ isAttachmentLoading: true });
    registersevice
      .GetUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          filelist = _.sortBy(filelist, "newname");

          this.setState(
            { savedfiles: [], files: [], newSelectedfiles: [] },
            () => {
              this.setState(
                (prevState) => ({
                  savedfiles: filelist,
                  isAttachmentLoading: false,
                  isOpenViewer: filelist.length > 0,
                  newSelectedfiles: [],
                  files: [],
                }),
                () => {
                  setTimeout(() => {
                    this.scrollheight.current?.getElement().scrollTo({
                      top: Number(this.state.currentScreenTop),
                      behavior: "smooth",
                    });
                  }, 500);
                }
              );
            }
          );
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  whenLoadComplate = () => {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current?.afterUploadDone();
    }
  };

  GetUploadFileList = (mtype) => {
    let requestlist: any = {};
    requestlist.hotelID = this.state.formData.hotelID;
    requestlist.etype = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.state.formData.entryType;
    requestlist.uniqueNo = this.state.formData.uniqueno;
    requestlist.checkNo = "";
    requestlist.series = "A";

    registersevice
      .GetUploadFileList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (mtype === 1) {
            this.setState(
              { savedfiles: [], files: [], newSelectedfiles: [] },
              () => {
                this.setState({ savedfiles: result });
              }
            );
          } else {
            this.setState({ savedfiles: [], files: [] }, () => {
              this.setState({ savedfiles: result });
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  GetTranToUpdateRep = (requestlist: any) => {
    this.setState({ isSpinner: true });
    requestlist.uniqueNo = this.props.uniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";
    requestlist.etype = this.state.formData.entryType; // this.getEtype();
    let splitData: any = [];
    let vendorSelected: any = [];
    let x = 2;
    repeatingservice
      .GetTranToUpdate(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
          if (result.tranEntryToUpdate[0] !== undefined) {
            let mainArray = result.tranEntryToUpdate[0];
            let splitArray = result.tranAmountEntryToUpdate;
            let uploadFiles = [];
            let commentlist = result.commentlist;
            let isError = mainArray.isError;
            if (isError === "Yes") {
              window.location.href = "/unauthorize-access?Error=NotFound";
            } else {
              let formData = { ...this.state.formData };
              let hotelName = mainArray.letterCode;
              let accountName = mainArray.acctName;
              formData.uniqueno = mainArray.uniqueno;
              formData.incompleteUniqueNo = mainArray.uniqueno;
              formData.hotelID = mainArray.hotelID;
              formData.oprID = requestlist.oprID;
              formData.transcationDate = mainArray.date;
              formData.accPeriod = mainArray.accper;
              formData.vendorID = mainArray.vid;
              formData.vendorName = mainArray.vendor;
              formData.vendorContract = mainArray.contract;
              formData.aid = mainArray.aid;
              formData.saletax = mainArray.saleTax;
              formData.internalNotes = mainArray.internalnotes;
              formData.checkNo = mainArray.ckNo;
              formData.transactionTotal = Number(mainArray.transTotal).toFixed(
                2
              );
              formData.entryType = mainArray.entryType;
              formData.accPeriodstatus = "Active"; //mainArray.accPerStatus;
              formData.concilestatus = mainArray.isReconcile;

              formData.vendorDays = mainArray.vendorDays;
              formData.vendorStatus = mainArray.vendorStatus;
              formData.contractStatus = mainArray.contractStatus;
              formData.endDate = mainArray.endDate;
              formData.repeatType = mainArray.repeatType;
              
              let defaultpaymentType = "Select Type";
              let movePaymentType = "";
              if (
                mainArray.ckNo.toString().toLowerCase() !==
                "Ach".toLowerCase() &&
                mainArray.ckNo.toString().toLowerCase() !==
                "Manual Ach".toLowerCase() &&
                mainArray.entryType.toString().toLowerCase() === "misc"
              ) {
                formData.paymenttype = "Manual ACH";
                defaultpaymentType = "Manual ACH";
                movePaymentType = "Manual ACH";
              } else {
                formData.paymenttype = mainArray.ckNo;
                defaultpaymentType = mainArray.ckNo;
                movePaymentType = mainArray.ckNo;
              }

              let vendorItem: any = {};
              vendorItem.id = mainArray.vid;
              vendorItem.accountNo = mainArray.contract;
              vendorItem.aid = mainArray.aid;
              vendorItem.salestax = mainArray.saleTax;
              vendorItem.vendorName = mainArray.vendor;
              //vendorItem.label = mainArray.vendor;

              vendorSelected.push(vendorItem);
              let splitlist: any = [];
              splitArray.forEach((element) => {
                let defaultCOA: any = [];
                let objCOA: any = {};
                objCOA.id = element.coa;
                objCOA.label = element.defaultCoa;
                defaultCOA.push(objCOA);
                element.defaultCoa = defaultCOA;
                element.amount = Number(element.amount).toFixed(2);
                element.subVendorlist = [];
                element.projectlist = [];
                splitData.push(element);

                let splitlistItem: any = [];

                splitlistItem.coa = element.coa;
                splitlistItem.spiltHoteID = element.spiltHoteID;
                splitlistItem.subVID = element.subVID;
                splitlistItem.pID = element.pID;
                splitlistItem.description = element.description;
                splitlistItem.amount = Number(element.amount).toFixed(2);
                splitlist.push(splitlistItem);
              });
              let paymentType1: any = [];
              let paymentTypeWithdrawal: any = [];
              paymentType1 = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.paymentType))
              );
              paymentTypeWithdrawal = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.paymentTypeWithdrawal))
              );

              let requestlist1 = { ...this.state.requestlist };
              requestlist.hotelID = mainArray.hotelID;
              requestlist.oprID = mainArray.oprID;
              requestlist.vid = mainArray.vid;

              this.setState(
                {
                  splitActualList: splitlist,
                  requestlist: requestlist1,
                  hotelValue: mainArray.hotelID,
                  splitData: [],
                  paymentType: [],
                  paymentTypeWithdrawal: [],
                  defaultpaymentType: "",
                  isComment: false,
                },
                () => {
                  this.setState(
                    {
                      selectedRepeatType: mainArray.repeatType,
                      htmlcomment: commentlist,
                      isComment: true,
                      movePaymentType,
                      hotelName: hotelName,
                      accountName: accountName,
                      savedfiles: uploadFiles,
                      splitData: splitData,
                      formData: formData,
                      paymentType: paymentType1,
                      paymentTypeWithdrawal: paymentTypeWithdrawal,
                      defaultaccountingPeriod: mainArray.accper,
                      vendorSelected: vendorSelected,
                      totalAmount: Number(mainArray.transTotal).toFixed(2),
                      amountTotal: Number(mainArray.transTotal).toFixed(2),
                      defaultpaymentType: defaultpaymentType,
                      oldTranDate: mainArray.date,
                      isInvoiceLoading:
                        true /* Added/Commented to improve speed of Withdrawal Slideout */,
                    },
                    () => {
                      let requestlist = { ...this.state.requestlist };
                      requestlist.vid = mainArray.vid;
                      requestlist.hotelID = this.state.hotelValue;
                      requestlist.oprID = requestlist.oprID;
                      this.GetAccountingPeriod(this.state.hotelValue, 1);
                      // this.GetHotelCOAlist(requestlist);   /* Added/Commented to improve speed of Withdrawal Slideout */
                    }
                  );
                }
              );
              //Call this after vendor list api call
              // this.vendorSearch.current.handleSelectFromParent(this.state.vendorSelected);
              if (this.state.vendorSelected[0].vendorName.length > 0) {
                /* Added/Commented to improve speed of Withdrawal Slideout */
                this.VendorSearchlistWithKey(
                  this.state.vendorSelected[0].vendorName,
                  mainArray.hotelID
                );
              }
            }
          } else {
            window.location.href = "/unauthorize-access?Error=NotFound";
          }
        }

        this.setState({ isSpinner: false });
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleVendorChange = (e: any) => {
    let isStateChanged = true;
    if (e.length > 0) {
      let requestlist = { ...this.state.requestlist };
      let formData = { ...this.state.formData };
      requestlist.hotelID = this.state.hotelValue;
      //requestlist.oprID = this.props.accDetails.oprID;
      requestlist.vid = e[0].vid;
      formData.vendorID = e[0].vid;
      formData.vendorName = e[0].vendorName;
      formData.vendorContract = e[0].accountNo;
      formData.aid = e[0].aid;
      formData.saletax = e[0].salestax;
      this.setState({
        requestlist,
        formData,
        vendorSelected: e,
        isStateChanged,
        vendorDays: e[0].vendorDays,
        isComment: true,
      });
      this.GetHotelCOAlist(requestlist);
      //this.GetTransactionEntryColoumn(formData);
    } else {
      // this.resetState();
      let requestlist = { ...this.state.requestlist };
      let formData = { ...this.state.formData };
      requestlist.hotelID = this.state.hotelValue;
      // requestlist.oprID = this.props.accDetails.oprID;
      requestlist.vid = "";
      formData.vendorID = 0;
      formData.vendorName = "";
      formData.vendorContract = "";
      formData.aid = 0;
      formData.saletax = "";
      this.setState({
        requestlist,
        formData: formData,
        vendorSelected: e,
        previousTransactionsData: [],
        isPreviousTransactions: false,
        isStateChanged,
      });
    }
  };

  endDatefocousOut(value) {
    let formData = { ...this.state.formData };
    if (value === "") {
      formData.endDate = null;
      this.setState({ formData });
    }
  }

  handleKeyDown = (event, type) => {
    if (event.key.toLowerCase() === "enter") {
      if (type === "droparea") {
        $("div[id^='" + "droparea" + "']").focus();
      } else {
        this.setState({ createOther: !event.target.checked });
      }
    }
    if (event.key.toLowerCase() === "tab") {
      if (type === "droparea") {
        $("checkbox[id^='" + "chkAnother" + "']").focus();
      }
    }
  };

  totalAmtDiff = (transTotal, splitTotal) => {
    transTotal = Utils.removecurrencyFormat(transTotal);
    splitTotal = Utils.removecurrencyFormat(splitTotal);
    transTotal = transTotal === "" ? 0 : transTotal;
    splitTotal = splitTotal === "" ? 0 : splitTotal;
    let diff = "";
    diff = (
      Number(!isNaN(transTotal) ? transTotal : "0.00") - Number(splitTotal)
    ).toFixed(2);
    let isAmountDiff = diff === "0.00" ? "No" : diff === "0" ? "No" : "Yes";
    this.setState({
      totalAmountdiff: Utils.currencyFormat(diff),
      isAmountDiff: isAmountDiff,
    });
  };

  handleTotalAmount = (event) => {
    let formData = { ...this.state.formData };
    if (!isNaN(event.target.value) && event.target.value !== "") {
      let trTotal = Utils.currencyFormat(formData.transactionTotal);
      formData.transactionTotal = trTotal;
    } else {
      formData.transactionTotal = "";
    }
    this.setState({ formData });
  };

  onAmountFocus = (event: any) => {
    let newval = Utils.removecurrencyFormat(event.target.value);
    let formData = { ...this.state.formData };
    formData.transactionTotal = newval;
    this.setState({ formData });
  };

  handleChange = (event: any, FieldType: string) => {
    let isStateChanged = true;
    let formData = { ...this.state.formData };
    let isformchange = false;
    //checked repeat

    let start = 0;
    let end = 0;
    if (FieldType === "totalAmt") {
      start = event.target.selectionStart;
      end = event.target.selectionEnd;

      let newInputVal = Utils.removeInvaildCharFromAmount(event.target.value);
      event.target.value = newInputVal;

      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (event.target.value.includes("-")) {
        lenbeforePoint = 9;
      }

      if (rx_live.test(event.target.value)) {
        if (event.target.value.includes(".")) {
          const timeArray = event.target.value?.split(".");
          if (
            timeArray[0].length <= lenbeforePoint &&
            timeArray[1].length <= 2
          ) {
            formData.transactionTotal = event.target.value;
          }
        } else {
          if (event.target.value.length <= lenbeforePoint) {
            formData.transactionTotal = event.target.value;
          }
        }
      } else if (
        event.target.value.includes(".") &&
        event.target.value.length === 1
      ) {
        formData.transactionTotal = event.target.value;
      }

      this.setState({ formData, isStateChanged }, () => {
        let txtID = "txttotalAmt";
        let txttotAmt = $("input[id^='" + txtID + "']")[0] as any;
        txttotAmt.selectionStart = start;
        txttotAmt.selectionEnd = end;

        this.totalAmtDiff(
          this.state.formData.transactionTotal,
          this.state.totalAmount
        );
      });
    } else {
      if (FieldType === "trDate") {
        if (event !== null) {
          let today = new Date(event);
          let dateNew =
            today.getMonth() +
            1 +
            "/" +
            today.getDate() +
            "/" +
            today.getFullYear();
          if (this.props?.isFromRepeating) {
            let selMon = today.getMonth() + 1;
            let selYear = today.getFullYear();

            let curDate = Utils.getHotalCurrentDate().getDate();
            let curMon = Utils.getHotalCurrentDate().getMonth() + 1;
            let curYear = Utils.getHotalCurrentDate().getFullYear();

            let posDate = new Date(this.state.oldTranDate).getDate();
            if (
              new Date(this.state.oldTranDate) > Utils.getHotalCurrentDate()
            ) {
              if (
                new Date(this.state.oldTranDate) >
                new Date(curMon + "/" + curDate + "/" + curYear)
              ) {
                if (
                  new Date(dateNew) <
                  new Date(curMon + "/" + curDate + "/" + curYear) ||
                  new Date(selMon + "/" + posDate + "/" + selYear) <
                  Utils.getHotalCurrentDate()
                ) {
                  Utils.toastError(
                    "While editing an existing repeating entry, Post date should be greater or equal to the current date.",
                    {
                      position: toast.POSITION.BOTTOM_RIGHT,
                    }
                  );
                  formData.transcationDate =
                    this.state.formData.transcationDate;
                  this.setState({ formData });
                  return;
                } else {
                  formData.transcationDate = dateNew;
                  isformchange = true;
                  this.setState({ formData });
                }
              }
            } else if (
              new Date(this.state.oldTranDate) < Utils.getHotalCurrentDate()
            ) {
              let curMonthName = Utils.getHotalCurrentDate().toLocaleString(
                "default",
                { month: "long" }
              );
              let seleMonthName = new Date(dateNew).toLocaleString("default", {
                month: "long",
              });
              if (
                new Date(seleMonthName + "-" + selYear) <=
                new Date(curMonthName + "-" + curYear)
              ) {
                Utils.toastError(
                  "While editing an existing repeating entry, Post date should be greater or equal to the transaction date.",
                  {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  }
                );
                formData.transcationDate = this.state.formData.transcationDate;
                this.setState({ formData });
                return;
              } else {
                formData.transcationDate = dateNew;
                isformchange = true;
              }
            }
            // Utils.toastError("While editing an existing repeating entry, Post date should be greater or equal to the transaction date.", {
            //     position: toast.POSITION.BOTTOM_RIGHT,
            // });
            // formData.transcationDate = this.state.formData.transcationDate;
            // this.setState({ formData })
            // return;
          } else {
            formData.transcationDate = dateNew;
          }
        } else {
          formData.transcationDate = null;
        }
        isformchange = true;
      } else if (FieldType === "endDate") {
        if (event !== null) {
          let today = new Date(event);
          let dateNew =
            today.getMonth() +
            1 +
            "/" +
            today.getDate() +
            "/" +
            today.getFullYear();
          formData.endDate = dateNew;
        } else {
          formData.endDate = null;
        }
        isformchange = true;
      } else if (FieldType === "notes") {
        formData.internalNotes = event.target.value;
        isformchange = true;
      } else if (FieldType === "check") {
        if (event.target.value.length > 0) {
          if (Number(event.target.value)) {
            formData.checkNo = Number(event.target.value);
          }
        } else {
          formData.checkNo = event.target.value;
        }
        isformchange = true;
      } else if (FieldType === "repeat") {
        formData.isRepeat = event.target.checked ? "Yes" : "No";
        this.setState({
          isRepeat: event.target.checked,
          selectedRepeatType: "Monthly",
          // files: [], newSelectedfiles: [], isOpenViewer: false
        });
        isformchange = true;
      } else if (FieldType === "createOther") {
        this.setState({ createOther: event.target.checked });
        isformchange = true;
      } else if (FieldType === "trvoidDate") {
        let today = new Date(event);
        let dateNew =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear();

        this.setState({ transcationvoidDate: dateNew });
      } else if (FieldType === "voidnotes") {
        this.setState({ voidNotes: event.target.value });
      }
      if (isformchange) {
        this.setState({ formData, isStateChanged });
      }
    }
  };

  handleNewRow = () => {
    let isStateChanged = true;
    let splitData: any = [];
    let newRow: any = {};
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    let len = splitData.length;
    let maxRno = splitData[len - 1].rno;
    let maxSrno = splitData[len - 1].srno;
    newRow.rno = Number(maxRno) + 1;
    newRow.srno = Number(maxSrno) + 1;
    splitData.push(newRow);
    this.setState({ splitData: [] }, () => {
      this.setState({ splitData: splitData, isStateChanged }, () => {
        let len = splitData.length;
        let txtID = "ddlEHID-" + (len - 1) + "ddl";
        // $("#tblSplit").find("button[id^='" + txtID + "']").focus();
        setTimeout(() => {
          $("#tblSplit")
            .find("button[id^='" + txtID + "']")
            .focus();
        }, 50);
      });
    });
    this.addTotalAmount(splitData);
  };

  Previoustransactions() {
    this.setState((prevState) => ({
      isPreviousTransactions: !prevState.isPreviousTransactions,
    }));
    let requestlist = { ...this.state.requestlist };
    requestlist.recordCount = 5;
    this.GetPreviousTransactionList(requestlist);
    this.setState({ requestlist });
  }

  loadPreviousData() {
    let requestlist = { ...this.state.requestlist };
    let loadrecord = requestlist.recordCount;
    requestlist.recordCount = Number(requestlist.recordCount) + 5;
    if (Number(loadrecord) < Number(this.state.totalCount)) {
      this.GetPreviousTransactionList(requestlist);
      this.setState({ requestlist });
    } else {
      Utils.toastError("No additional transactions exist.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
    }
  }

  ishandleDeleteRow(row: any, mode: any) {
    if (mode) {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      this.setState({ splitData: [] }, () => {
        this.setState(
          {
            splitData: splitData.filter((item) => item.rno !== row.rno),
          },
          () => {
            this.addTotalAmount(this.state.splitData);
          }
        );
      });
    }
  }

  handleSelectedItem = (control: any, id: any) => {
    let isStateChanged = true;
    let formData = { ...this.state.formData };
    let controlID = Number(control.split("_")[0]);
    let rowIndex = Number(control.split("_")[1]);
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (controlID === 1) {
      // SplitHID
      // this.setState({ selectedEhid: id });
      let filterRow = this.state.splitHIDList.filter((x) => x.id === id);
      splitData[rowIndex].lettercode = filterRow[0].name;
      splitData[rowIndex].spiltHoteID = filterRow[0].id;
      splitData[rowIndex].splitoprID = filterRow[0].splitOprID;
      splitData[rowIndex].defaultEhid = filterRow[0].name;
      splitData[rowIndex].subVendorlist = this.state.subVendorList.filter(
        (x) => x.hid === filterRow[0].id
      );
      splitData[rowIndex].projectlist = this.state.projectList.filter(
        (x) => x.hid === filterRow[0].id
      );
      splitData[rowIndex].subVID = "0";
      splitData[rowIndex].subVendor = "";
      splitData[rowIndex].defaultVendor = "Select Sub Vendor";

      splitData[rowIndex].pID = "0";
      splitData[rowIndex].projectName = "";
      splitData[rowIndex].defaultProject = "Select Project";

      this.setState({ splitData: [] }, () => {
        this.setState({ splitData, isStateChanged }, () => {
          let txtID = "ddlEHID-" + rowIndex + "ddl";
          $("#tblSplit")
            .find("button[id^='" + txtID + "']")
            .focus();
        });
      });
    } else if (controlID === 2) {
      // COA
      if (id.length > 0) {
        if (id[0].id > 0) {
          splitData[rowIndex].coaName = id[0].coAname;
          splitData[rowIndex].coa = id[0].id;
          splitData[rowIndex].defaultCoa = id;
          splitData[rowIndex].isCOA = "Yes";
        } else {
          splitData[rowIndex].coaName = "";
          splitData[rowIndex].coa = "";
          splitData[rowIndex].defaultCoa = [];
          splitData[rowIndex].isCOA = "Yes";
        }
      } else {
        splitData[rowIndex].coaName = "";
        splitData[rowIndex].coa = "";
        splitData[rowIndex].defaultCoa = [];
        splitData[rowIndex].isCOA = "Yes";
      }
      this.setState({ splitData, isStateChanged }, () => {
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
        $("#tblSplit")
          .find("input[class^='" + txtID + "']")
          .focus();
      });
      // let txtID = 'ddlSubVendor-' + (rowIndex).toString()
      // $("#tblSplit").find("button[id^='" + txtID + "']").focus();
    } else if (controlID === 3) {
      // subVedor
      let filterRow = this.state.subVendorList.filter(
        (x) => x.id === id && x.hid === splitData[rowIndex].spiltHoteID
      );
      splitData[rowIndex].subVendor = filterRow[0].name;
      splitData[rowIndex].subVID = filterRow[0].id;
      splitData[rowIndex].defaultVendor = filterRow[0].name;
      this.setState({ splitData, isStateChanged }, () => {
        let txtID = "ddlSubVendor-" + rowIndex + "ddl";
        $("#tblSplit")
          .find("button[id^='" + txtID + "']")
          .focus();
      });
    } else if (controlID === 4) {
      // project
      let filterRow = this.state.projectList.filter(
        (x) => x.id === id && x.hid === splitData[rowIndex].spiltHoteID
      );
      splitData[rowIndex].projectName = filterRow[0].name;
      splitData[rowIndex].pID = filterRow[0].id;
      splitData[rowIndex].defaultProject = filterRow[0].name;
      this.setState({ splitData, isStateChanged }, () => {
        let txtID = "ddlProject-" + rowIndex + "ddl";
        $("#tblSplit")
          .find("button[id^='" + txtID + "']")
          .focus();
      });
    } else if (controlID === 5) {
      // payment Type
      formData.paymenttype = id;

      if (this.state.formData.entryType != "payment") {
        formData.checkNo = "";
        formData.isRepeat =
          id.toLowerCase() === "check"
            ? "No"
            : this.state.isRepeat
              ? "Yes"
              : "No";
        this.setState({
          selectedpaymentType: id,
          formData,
          isStateChanged,
          isRepeat: id.toLowerCase() === "check" ? false : this.state.isRepeat,
        });
      } else {
        if (
          id.toLowerCase() !==
          (this.state.defaultpaymentType.toLowerCase() === "M-ACH".toLowerCase()
            ? "ACH".toLowerCase()
            : this.state.defaultpaymentType.toLowerCase().includes("check")
              ? "check"
              : this.state.defaultpaymentType.toLowerCase())
        ) {
          this.setState(
            {
              selectedpaymentType: id,
              formData,
            },
            () => {
              this.SavePaymentData("No");
            }
          );
        }
      }
    } else if (controlID === 10) {
      // Move HID period
      formData.accPeriod = id;
      this.setState({
        formData,
        defaultaccountingPeriod: id,
        selectedaccountingPeriod: id,
        selectedPeriod: id,
        isStateChanged,
      });
    } else if (controlID === 11) {
      // Void period
      this.setState({ voidPeriod: id });
    } else if (controlID === 7) {
      // Account
      this.setState({ moveSelectedAccountOprId: id });
    } else {
      // A/c Period
      formData.accPeriod = id;
      this.setState({ selectedaccountingPeriod: id, formData, isStateChanged });
    }
  };

  onChangeStatus = (e: any, items: any, index: any) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let data = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.tableColumnList))
    );

    let hidExist = splitData.filter((e) => e.spiltHoteID !== "").length;
    // let amountExist =splitData.filter(e=>e.amount !=='').length;
    // let coaExist =splitData.filter(e=>e.coa !=='').length;
    let subVendorExist = splitData.filter((e) => e.subVID > 0).length;
    let projectNameExist = splitData.filter((e) => e.pID > 0).length;
    let descriptionExist = splitData.filter((e) => e.description !== "").length;

    // let data = {...this.state.tableColumnList}
    data[index].isChecked = e.target.checked;
    let chekedColumns = data
      .filter((item) => item.isChecked)
      ?.map((item) => item.name?.toUpperCase());
    const transactionsColumns = this.transactionsColumns.map((item) => {
      if (
        this.state.splitHIDList.length > 1 &&
        item.text?.toUpperCase() === "EHID".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        subVendorExist > 0 &&
        item.text?.toUpperCase() === "Sub Vendor".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        projectNameExist > 0 &&
        item.text?.toUpperCase() === "Project".toUpperCase()
      ) {
        item.hidden = false;
      } else if (
        descriptionExist > 0 &&
        item.text?.toUpperCase() === "Description".toUpperCase()
      ) {
        item.hidden = false;
      } else {
        item.hidden =
          chekedColumns.includes(item.text?.toUpperCase()) || !item.text
            ? false
            : true;
      }
      return item;
    });
    this.setState({ transactionsColumns: [] }, () => {
      this.setState(
        { tableColumnList: data, HIDColumn: true, transactionsColumns },
        () => {
          $("#colList").click();
        }
      );
    });
  };

  updateState = (e: any, index: any, type: any, txtID) => {
    let isStateChanged = true;
    let start = e.target.selectionStart;
    let end = e.target.selectionEnd;
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (type === "desc") {
      splitData[index].description = e.target.value;
      splitData[index].isDescription = "Yes";
      this.setState({ splitData, isStateChanged }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblSplit").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        txtdesc.selectionStart = start;
        txtdesc.selectionEnd = end;
      });
    } else if (type === "amt") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
      let lenbeforePoint = 8;
      if (e.target.value.includes("-")) {
        lenbeforePoint = 9;
      }

      if (rx_live.test(e.target.value)) {
        if (e.target.value.includes(".")) {
          const timeArray = e.target.value?.split(".");
          if (
            timeArray[0].length <= lenbeforePoint &&
            timeArray[1].length <= 2
          ) {
            splitData[index].amount = e.target.value;
          }
        } else {
          if (e.target.value.length <= lenbeforePoint) {
            splitData[index].amount = e.target.value;
          }
        }
      } else if (e.target.value.includes(".") && e.target.value.length === 1) {
        splitData[index].amount = e.target.value;
      }

      this.setState({ splitData, isStateChanged }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtamt = $("#tblSplit").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        txtamt.selectionStart = start;
        txtamt.selectionEnd = end;

        this.addTotalAmount(this.state.splitData);
      });
    }
  };

  addTotalAmount(splitData: any[]) {
    //debugger;
    let splitData1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let totalAmount: string = "0";
    splitData1.forEach((element) => {
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "."
          ? "0"
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === ""
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "-"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      element.amount =
        Utils.removecurrencyFormat(element.amount) === "+"
          ? 0
          : Utils.removecurrencyFormat(element.amount);
      totalAmount = Number(
        Number(Number(totalAmount).toFixed(2)) + Number(element.amount)
      ).toString();
    });
    let newtotalAmount = Utils.currencyFormat(totalAmount);
    let formData = { ...this.state.formData };
    // formData.transactionTotal = totalAmount;
    this.setState(
      { totalAmount: newtotalAmount, formData, isStateChanged: true },
      () => {
        this.totalAmtDiff(
          this.state.formData.transactionTotal,
          this.state.totalAmount
        );
      }
    );
  }

  renderMenuItemChildren(option, props, index) {
    return (
      <>
        <div key={option.id}>
          <div className="vendor-name">
            <EllipsisWithTooltip placement="bottom">
              {option.label}
            </EllipsisWithTooltip>
          </div>
          <div className="contracts">{option.accountNo}</div>
        </div>
      </>
    );
  }

  renderCOAItemChildren(option, props, index) {
    return (
      <>
        <div key={option.id}>
          <div className="vendor-name">
            <EllipsisWithTooltip placement="bottom">
              {option.label}
            </EllipsisWithTooltip>
          </div>
          {/* <div className="contracts">{option.name}</div> */}
        </div>
      </>
    );
  }

  cancelPaymentTypeChange = () => {
    let formData = { ...this.state.formData };
    formData.entryType = "";
    formData.paymenttype = this.state.oldPaymentType;
    this.setState({ selectedpaymentType: 0, formData }, () => {
      let formData = { ...this.state.formData };
      formData.entryType = "payment";
      this.setState({ formData });
    });
  };

  SavePaymentData = (IsSaveDraft) => {
    if (
      this.state.selectedpaymentType !== 0 &&
      this.state.selectedpaymentType.toLowerCase() !==
      (this.state.defaultpaymentType.toLowerCase() === "M-ACH".toLowerCase()
        ? "ACH".toLowerCase()
        : this.state.defaultpaymentType.toLowerCase().includes("check")
          ? "check"
          : this.state.defaultpaymentType.toLowerCase())
    ) {
      setTimeout(() => {
        confirmAlert({
          title: "Alert",
          message:
            "By changing the payment method, this invoice will move back to the Payments page and will no longer be marked as paid.",
          buttons: [
            {
              label: "Proceed",
              onClick: () => this.SavePayment(),
            },
            {
              label: "Cancel",
              onClick: () => this.cancelPaymentTypeChange(),
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      }, 100);
    } else {
      this.SavePayment();
    }
  };
  SavePayment = () => {
    if (this.state.formData.transcationDate === null) {
      Utils.toastError("Please select Transaction Date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    }

    let saverequest: any = {};
    let checkno = this.state.formData.checkNo.toUpperCase();

    saverequest.hotelID = this.state.formData.hotelID;
    saverequest.uniqueno = 0;
    saverequest.internalNotes = this.state.formData.internalNotes;
    saverequest.paymentUniqueno = this.state.formData.uniqueno;
    saverequest.trdate = this.state.formData.transcationDate;
    // saverequest.type = checkno === "ACH" ? 'ACH' : checkno === "Manual ACH" ? 'ACH' :
    //     checkno === "Credit Card".toUpperCase() ? "Credit Card" : checkno.toUpperCase().includes("ACH") ? "ACH" : "Check"; //ach/creditcrad/check
    saverequest.type = checkno.toUpperCase().includes("CHECK")
      ? "Check"
      : checkno.toUpperCase().includes("EPAY")
        ? "ePay"
        : this.state.formData.paymenttype === "M-ACH"
          ? "ACH"
          : this.state.formData.paymenttype === "ACH"
            ? "ACH"
            : this.state.formData.paymenttype === "Manual ACH"
              ? "ACH"
              : this.state.formData.paymenttype;
    saverequest.pageType = "PaymentUpload";
    saverequest.isReconcilePage =
      this.state.formData.actionType === "copy"
        ? false
        : this.state.isReconcilePage;
    saverequest.reconcileAccPer = this.state.isReconcilePage
      ? this.props.accper
      : "";

    let associatedPaymentArray = this.state.associatedPayment.filter(
      (x) => x.viewType === 1
    );
    let uniqueNos = "";
    associatedPaymentArray.map((e, index) => {
      if (index === associatedPaymentArray.length - 1) {
        uniqueNos = uniqueNos + e.uniqueno;
      } else {
        uniqueNos = uniqueNos + e.uniqueno + ",";
      }
    });
    saverequest.UniquenoList = uniqueNos;

    this.setState({ isDisabled: true, isSpinner: true });
    registersevice
      .SavePaymentUploadFile(saverequest, this.state.files)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            isDisabled: false,
            isSpinner: false,
            moveHID: { hidValue: -1, hidName: "" },
            actionType: "",
          });
          if (result.saveStatus === "Success") {
            toast.success("Record Saved Successfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });

            this.getUploadedFileList(1);
            this.setState({ isStateChanged: false }, () => {
              this.props.hideSlideOut(true);
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
          }
        }
        this.setState({ isDisabled: false, isSpinner: false });
        resolve();
      })
      .catch((error) => {
        this.setState({ isDisabled: false, isSpinner: false });
        reject();
      });
  };

  saveDeposit = (IsSaveDraft: string) => {
    let request: any = {};
    request = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.state.formData))
    );
    if(this.props.selectedRow?.isDraftUpdate === "Yes" && IsSaveDraft === "No")
    {
      request.uniqueno = 0;
     
    }
    request.IncompleteUniqueNo = this.state.formData.uniqueno;
    request.isDraftUpdate = this.props.selectedRow?.isDraftUpdate;
    request.paymenttype =
      request.paymenttype.toString().toLowerCase() ===
        "Manual ACH".toLowerCase()
        ? "ACH"
        : request.paymenttype;
    let totalAmountdiff = Utils.removecurrencyFormat(
      this.state.totalAmountdiff
    );
    request.transactionTotal = Utils.removecurrencyFormat(
      request.transactionTotal
    );
    request.isReconcilePage =
      this.state.formData.actionType === "copy"
        ? false
        : this.state.isReconcilePage;
    request.reconcileAccPer = this.state.isReconcilePage
      ? this.props.accper
      : "";
    if (this.ChildComment.current?.isCommentAdd()) {
      Utils.toastError("Please add your comments.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    }
    if (IsSaveDraft === "No") {
      if (request.vendorID === 0) {
        Utils.toastError("Please select vendor.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        this.state.accountlist.length === 0 &&
        this.state.formData.actionType === "copy"
      ) {
        Utils.toastError("This HID does not have any Account.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        request.oprID.toString() === "-1" &&
        this.state.formData.actionType === "copy"
      ) {
        Utils.toastError("Please select account.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        (this.state.formData.entryType === "Misc" ||
          this.state.formData.entryType === "Withdrawal") &&
        request.paymenttype === ""
      ) {
        Utils.toastError("Please select Payment Type.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        (this.state.formData.entryType === "Misc" ||
          this.state.formData.entryType === "Withdrawal") &&
        request.paymenttype.length === 0
      ) {
        Utils.toastError("Please select Payment Type.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        this.state.formData.entryType === "Misc" &&
        this.state.formData.paymenttype === "Check" &&
        request.checkNo.length === 0
      ) {
        Utils.toastError("Please enter check number.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (request.transactionTotal.toString().trim() === "") {
        Utils.toastError("Please enter total amount.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (Number(totalAmountdiff) !== Number(0)) {
        Utils.toastError("Amount Total and split amounts do not match.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (
        request.accPeriod.length === 0 &&
        this.state.isRepeat === false
      ) {
        Utils.toastError("Please select accounting period.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (request.transcationDate === null) {
        Utils.toastError("Please select Transaction Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      } else if (request.isRepeat.toLowerCase() === "yes") {
        if (request.endDate !== null) {
          if (new Date(request.transcationDate) >= new Date(request.endDate)) {
            Utils.toastError("End Date should be greater than Transaction Date.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
            return false;
          }
        }
      } else if (request.transcationDate === null) {
        Utils.toastError("Please choose date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      }
    }
    else{
      if (request.transactionTotal.toString().trim() === "") {
        Utils.toastError("Please enter total amount.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      }
      else if (request.transcationDate === null) {
        Utils.toastError("Please select Transaction Date.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      }
    }
    let arrdata: any[] = [];
    if (this.state.splitHIDList.length > 1) {
      arrdata = this.state.splitData.filter(
        (e) =>
          e.coaName.length > 0 ||
          e.pID > 0 ||
          e.subVID > 0 ||
          e.description.length > 0 ||
          Utils.removecurrencyFormat(e.amount) !== ""
      );
    } else {
      arrdata = this.state.splitData.filter(
        (e) =>
          e.coaName.length > 0 ||
          e.pID > 0 ||
          e.subVID > 0 ||
          e.description.length > 0 ||
          Utils.removecurrencyFormat(e.amount) !== ""
      );
    }

    if (arrdata.length > 0) {
      if (this.state.splitHIDList.length > 1) {
        request.SplitItems = this.state.splitData.filter(
          (e) =>
            e.coaName.length > 0 ||
            e.pID > 0 ||
            e.subVID > 0 ||
            e.description.length > 0 ||
            Utils.removecurrencyFormat(e.amount) !== ""
        );
      } else {
        request.SplitItems = this.state.splitData.filter(
          (e) =>
            e.coaName.length > 0 ||
            e.pID > 0 ||
            e.subVID > 0 ||
            e.description.length > 0 ||
            Utils.removecurrencyFormat(e.amount) !== ""
        );
      }
    } else {
      if (IsSaveDraft === "No") {
        request.SplitItems = this.state.splitData;
        Utils.toastError("Please select at least one COA.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      }
      else {
        request.SplitItems = [];
      }
    }
    if (this.state.formData.concilestatus.toString().toLowerCase() === "yes" && IsSaveDraft === "No") {
      if (
        Utils.removecurrencyFormat(this.state.amountTotal) !==
        Utils.removecurrencyFormat(this.state.totalAmount)
      ) {
        Utils.toastError("Total amount should be same as the approved amount.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        return false;
      }
    }

    if (this.isValidForm(request,IsSaveDraft) && IsSaveDraft === "No") {
      if (new Date(request.transcationDate) > Utils.getHotalCurrentDate()) {
        confirmAlert({
          title: "Confirmation",
          message:
            "Date entered is a future date. Press Cancel to Change, Ok to continue saving?",
          buttons: [
            {
              label: "Ok",
              onClick: () => this.saveDataArray(request, IsSaveDraft),
            },
            {
              label: "Cancel",
              onClick: () => reject(),
            },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.saveDataArray(request, IsSaveDraft);
      }
    }
    else if(IsSaveDraft === "Yes") {
      this.saveDataArray(request, IsSaveDraft);
    }
  };

  saveDataArray(request, IsSaveDraft) {
   
    let userComments: any = [];
    userComments = this.ChildComment.current?.CommentToSave();

    let updatedsplitlist: any = [];
    request.SplitItems.forEach((element) => {
      element.projectlist = [];
      element.subVendorlist = [];
      element.amount = element.amount == "" ? 0 : Utils.removecurrencyFormat(element.amount);
      let splitlistItem: any = [];

      splitlistItem.coa = element.coa;
      splitlistItem.spiltHoteID = element.spiltHoteID;
      splitlistItem.subVID = element.subVID;
      splitlistItem.pID = element.pID;
      splitlistItem.description = element.description;
      splitlistItem.amount = element.amount == "" ? 0 : Utils.removecurrencyFormat(element.amount);
      updatedsplitlist.push(splitlistItem);
    });
    request.isSplitChange = "false";

    let splitActualList = this.state.splitActualList;
    if (this.state.splitActualList.length !== updatedsplitlist.length) {
      request.isSplitChange = "true";
    } else {
      updatedsplitlist.forEach((ele, idx) => {
        if (
          (ele.coa !== splitActualList[idx].coa ||
            ele.spiltHoteID !== splitActualList[idx].spiltHoteID ||
            ele.subVID !== splitActualList[idx].subVID ||
            ele.pID !== splitActualList[idx].pID ||
            ele.description.toLowerCase() !==
            splitActualList[idx].description.toLowerCase() ||
            Utils.removecurrencyFormat(ele.amount) !==
            Utils.removecurrencyFormat(splitActualList[idx].amount)) &&
          request.isSplitChange === "false"
        ) {
          request.isSplitChange = "true";
        }
      });
    }

    request.accPeriod =
      request.accPeriod === ""
        ? ""
        : moment(request.accPeriod).format("DD-MMM-YYYY");
    request.transcationDate =
      request.transcationDate === null
        ? ""
        : moment(request.transcationDate).format("DD-MMM-YYYY");
    request.UserComments = userComments;
    request.repeatDate =
      request.endDate !== null
        ? moment(request.endDate).format("DD-MMM-YYYY")
        : request.endDate;
    let isEntryRepeat =
      this.state.formData.isRepeat.toString().toLowerCase() ===
      "Yes".toLocaleLowerCase();
    request.TempUniqueNo = this.state.isRepeat
      ? this.state.tempUniqueNo
      : this.state.slideEntryType === "newEntry"
        ? isEntryRepeat
          ? ""
          : this.state.tempUniqueNo
        : "";
    request.OldpageType =
      this.state.slideEntryType === "newEntry"
        ? "TempUploadFiles"
        : request.entryType;
    let { isCopyEntry } = this.state;
    request.uniqueno = isCopyEntry ? 0 : request.uniqueno;
    request.actionType = isCopyEntry ? "" : request.actionType;
    request.isSaveDraft = IsSaveDraft;
    request.repeatType = this.state.isRepeat ? this.state.selectedRepeatType : "";

    this.setState({ isDisabled: true, isSpinner: true });
    registersevice
      .SaveTransaction(request, this.state.files)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            isSave: true,
            isDisabled: false,
            isCopyEntry: false,
            isSpinner: false,
            moveHID: { hidValue: -1, hidName: "" },
            actionType: "",
          });
          if (result.saveStatus === "Success") {
            toast.success("Record Saved Successfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
            if (this.props.transationSlideoutSave !== undefined) {
              this.props.transationSlideoutSave(request, result);
            }
            if (!this.state.createOther) {
              setTimeout(() => {
                this.closeSlideOut();
              }, 3000);
            }
            setTimeout(() => {
              this.resetState();
              this.GetTransactionEntryColoumn(this.state.formData);
            }, 3500);
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
          }
        }
        this.setState({ isDisabled: false, isSpinner: false });
        resolve();
      })
      .catch((error) => {
        this.setState({ isDisabled: false, isSpinner: false });
        reject();
      });
  }
  isValidForm = (request: any,IsSaveDraft :any) => {
    let notvalid = true;
    let data = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.tableColumnList))
    );
    let chekedColumns = data.filter(
      (item) => item.name.toString().toLowerCase() === "ehid"
    )[0].isChecked;
    if (!chekedColumns && this.state.splitHIDList.length === 1) {
      request.SplitItems.forEach((element) => {
        element.defaultEhid = this.state.hotelName;
        element.lettercode = this.state.hotelName;
        element.spiltHoteID = this.state.hotelValue;
      });
    }
    if(IsSaveDraft === "No"){
      if (request.SplitItems.length > 0) {
        request.SplitItems.forEach((element) => {
          if (notvalid) {
            if (element.spiltHoteID === "") {
              Utils.toastError("Please EHID.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              });
              notvalid = false;
            } else if (element.coa.length === 0) {
              Utils.toastError("Please select COA.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              });
              notvalid = false;
            } else if (
              request.vendorID.toString() === element.subVID.toString()
            ) {
              Utils.toastError("Vendor and Sub-Vendor can not be same.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              });
              notvalid = false;
            } else if (element.amount.length === 0) {
              Utils.toastError(
                "Amount Cannot be blank and Amount Should be Numeric.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "TransSlideout",
                }
              );
              notvalid = false;
            }
          }
        });
      } else {
        Utils.toastError("Please select at least one COA.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "TransSlideout",
        });
        notvalid = false;
      }
  }

    return notvalid;
  };

  showHideChangeLogModal = () => {
    this.setState({
      showChangeLogModal: !this.state.showChangeLogModal,
    });
  };

  handleSaveColumn = () => {
    let tableColumnList = this.state.tableColumnList.filter(
      (e) => e.isChecked === true
    );
    let columns: any = [];
    tableColumnList.forEach((element) => {
      columns.push(element.id);
    });
    let columnstring = columns.join(",");
    //let requestlist = {...this.state.requestlist};
    let saveRequest: any = {};
    saveRequest.hotelID = this.state.formData.hotelID;
    saveRequest.oprid = this.state.formData.oprID;
    saveRequest.vid = this.state.formData.vendorID;
    saveRequest.columnname = columnstring;

    this.setState({ isdefaultColDisabled: true });
    registersevice
      .SaveTransactionColumn(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ isdefaultColDisabled: false });
          if (result.saveStatus === "Success") {
            toast.success(
              "Default view saved for " +
              this.state.formData.vendorName +
              " successfully.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              }
            );
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
          }

          // this.setState({ vendorList: result })
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false });
        reject();
      });
  };

  resetState() {
    let formData = { ...this.state.formData };
    formData.transactionTotal = "";
    formData.internalNotes = "";
    formData.transcationDate = null;
    formData.endDate = null;
    formData.accPeriod = this.state.defaultaccountingPeriod1;
    formData.checkNo = "";
    //  formData.paymenttype = "";
    let accPeriodList: any = [];
    let paymentType1: any = [];
    let paymentTypeWithdrawal: any = [];
    accPeriodList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    paymentType1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );
    paymentTypeWithdrawal = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentTypeWithdrawal))
    );

    // if (formData.entryType === 'Withdrawal') {
    //     formData.paymenttype = "ACH";
    // }

    let defaultpaymentType = this.state.defaultpaymentType;

    this.setState(
      {
        totalAmount: "$0.00",
        splitActualList: [],
        paymentType: [],
        paymentTypeWithdrawal: [],
        accPeriodList: [],
        defaultpaymentType: "",
        defaultaccountingPeriod: this.state.defaultaccountingPeriod1,
        htmlcomment: [],
        isComment: false,
      },
      () => {
        this.setState({
          moveHID: { hidValue: -1, hidName: "" },
          isComment: true,
          isStateChanged: false,
          newSelectedfiles: [],
          files: [],
          savedfiles: [],
          isOpenViewer: false,
          formData,
          //totalAmount: 0.00,
          defaultpaymentType:
            formData.paymenttype.toString().toLowerCase() === "ach"
              ? "Manual ACH"
              : formData.paymenttype,
          // defaultpaymentType: defaultpaymentType,
          accPeriodList: accPeriodList,
          paymentType: paymentType1,
          paymentTypeWithdrawal: paymentTypeWithdrawal,
          tableColumnList: [
            { id: "ehid", name: "EHID", isChecked: true, disabled: false },
            { id: "coa", name: "COA", isChecked: true, disabled: true },
            {
              id: "sub vendor",
              name: "Sub Vendor",
              isChecked: false,
              disabled: false,
            },
            {
              id: "project",
              name: "Project",
              isChecked: false,
              disabled: false,
            },
            {
              id: "description",
              name: "Description",
              isChecked: true,
              disabled: false,
            },
            { id: "amount", name: "Amount", isChecked: true, disabled: true },
          ],

         splitData: this.state.defaultSplitData,
          // splitData: [{rno: 1,lettercode: "",spiltHoteID: "", coa: "",coaName: "",description: "",amount: "",srno: 1,clMonth: "",clYear: "",
          //     subVID: "0",subVendor: "",pID: "0",projectName: "",splitoprID: "0",defaultCoa: [],defaultVendor: "Select Sub Vendor",
          //     defaultProject: "Select Project",defaultEhid: "EHID",subVendorlist: [],projectlist: [],isCOAPer: "Yes",isCOA: "No",isDescription: "No",
          //   },
          //   {rno: 2,lettercode: "",spiltHoteID: "", coa: "",coaName: "",description: "",amount: "",srno: 2,clMonth: "",clYear: "",
          //     subVID: "0",subVendor: "",pID: "0",projectName: "",splitoprID: "0",defaultCoa: [],defaultVendor: "Select Sub Vendor",
          //     defaultProject: "Select Project",defaultEhid: "EHID",subVendorlist: [],projectlist: [],isCOAPer: "Yes",isCOA: "No",isDescription: "No",
          //   }
          // ],
         
        }, () => {
          this.resetReviewStatus();
        });
        this.GetTempUploadTransNo();
      }
    );
  }

  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      confirmAlert({
        title: "Delete Attachment",
        message: "Are you sure you want to delete?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.deleteUnuploadFile(index),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      // file.Etype =this.getEtype();
      this.downloadTranactionFile(file);
    }
  };

  deleteUnuploadFile(index: any) {
    let newfiles: any = [];
    this.state.newSelectedfiles.forEach((element, idx) => {
      if (index !== idx) {
        newfiles.push(element);
      }
    });
    this.setState({ newSelectedfiles: newfiles, files: newfiles });
  }
  setupAuthentication = () => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userName = storage === null ? 0 : (storage.userName as any);

    let request: any = {};
    request.userName = userName;
    request.purpose = "ReprintCheck";
    request.otpCode = "";
    request.primaryContact = "Phone";

    accountService
      .OTPForAuthentication(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.status === "Success") {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });

            this.setState({ isOtpNeed: true });
          } else {
            toast.success("Something went wrong", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "bankDetailsSlideout",
            });
          }
        }
      });
  };

  closeOtpModal = () => {
    if (this.state.isOtpNeed) {
      this.setState({ isOtpNeed: false });
    }
  };
  ValidateOTP = () => {
    this.setState({ otpSuccess: true, isOtpNeed: false }, () => {
      this.downloadCopyCheck("reprint");
      //this.plaidFunction(this.state.mode);
    });
  };
  ReSendOTP = () => {
    this.setupAuthentication();
  };

  CheckACPeriodStatusByDate = () => {
    let request: any = {};
    request.Date = this.props.chkPrintperiod;
    request.HID = this.props.hidValue;

    this.setState({ isOtpNeed: true });
    this.setupAuthentication();

    InvoiceApprovalS.CheckACPeriodStatusByDate(request)
      .then(async (result: any | null) => {
        if (result?.result?.message.toLowerCase() === "success") {
          let closedDats = [] as any;
          closedDats = result?.result?.result.filter(
            (o) => o?.status?.toLowerCase() === "closed"
          );
          if (closedDats.length > 0) {
            Utils.toastError("Accounting period is closed for the reprint.");
          } else {
            this.setState({ isOtpNeed: true });
            this.setupAuthentication();
          }
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        reject();
      });
  };

  handleAction = (eventKey: any) => {
    if (eventKey === "Flag for Review" || eventKey === "Needs Review" || eventKey === "Reviewed" || eventKey === "Review Complete") {
      this.handleReviewStatus(eventKey);
    }

    if (eventKey === "changeLog") {
      this.showHideChangeLogModal();
    }

    if (eventKey === "move") {
      this.setState({
        PeriodList: [],
        defaultPeriod: "Accounting Period",
        selectedPeriod: "",
        showInvoiceModal: true,
      });
    }

    if (eventKey === "downloadCopy") {
      this.downloadCopyCheck(eventKey);
    }
    if (eventKey === "reprint") {
      this.setState({ isOtpNeed: true });
      //this.setupAuthentication();
      // this.CheckACPeriodStatusByDate();
    }

    if (eventKey === "void") {
      confirmAlert({
        title: "Void Transaction",
        message:
          // "Please note, When Voided, A duplicate entry will be created under the same COA's but with opposite sign amount. The duplicate entry would be posted in current active accounting period. The Invoice No. of original entry would be post-fixed with ''-R1-A'', where n is the serial of voided entry. The Invoice No. of duplicate entry would be post-fixed with ''-R1-B''. Both the entries would be reflected in Operating Account.",
          "Once this transaction is voided, a duplicate entry will be created under the same COA with the opposite sign amount. The Invoice number of the original entry will show ''-Rn-A'', where n is the serial of the voided entry. The invoice number of the duplicate entry will show ''-Rn-B''",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              this.setState({ showVoidModal: true });
            },
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    if (eventKey === "copy") {
      if (this.state.savedfiles.length > 0) {
        confirmAlert({
          title: "Copy Transaction",
          message:
            "Do you want to copy the attachments to the new transaction?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.CopyTransaction("Yes"),
            },
            {
              label: "No",
              onClick: () => this.CopyTransaction("No"),
            },
          ],
          overlayClassName: "copy-trancsation-alert",
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.CopyTransaction("No");
      }
    }
    if (eventKey === "delete") {
      confirmAlert({
        title: "Delete Transaction",
        message: "Are you sure you want to delete this Transaction?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.DeleteTransaction(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }

    if (eventKey === "invoicemove") {
      // this.setState({ showMoveAfterPaymentModal: true, });
      this.getMovePaidInvoiceHotels();
    }

    if (eventKey === "epayCheckImage") {
      this.getEpayCheckImageURL();
      // this.downloadEpayCheckImage("https://manage.cpayplus.com/checks/image?checkId=677c8a8b-df34-41b0-9ebb-2309988e8bfc&urlKey=6882955c-b078-46a4-87a8-8e6285d60625");
    }
  };

  getEpayCheckImageURL = () => {
    let request: any = {};
    request.degitalID = this.state.epayDigitalID;
    InvoiceApprovalS.GetEpayCheckImageURL(request)
      .then(async (result: any | null) => {
        //debugger;
        if (result !== null && result !== "") {
          this.downloadEpayCheckImage(result);
        } else {
          Utils.toastError("Check image is not yet available. This may take up to 24 hours after the check is sent to the vendor.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        reject();
      });
  };

  downloadEpayCheckImage = (url) => {
    let alink = document.createElement("a");
    alink.href = url;
    // alink.target="_blank"
    alink.setAttribute("download", `${this.state.epayCheckNo}.pdf`);
    alink.setAttribute("target", "_blank");
    document.body.appendChild(alink);
    alink.click();
  };

  CopyTransaction = (iscopyFile) => {
    $(".disabled-area")
      .find("input, textarea, button, select")
      .removeAttr("disabled");
    this.copyVendor(iscopyFile);
    let accPeriodList: any = [];
    let paymentType: any = [];
    let splitData: any = [];
    let paymentTypeWithdrawal: any = [];
    let { formData } = this.state;
    paymentType = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentType))
    );
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    paymentTypeWithdrawal = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.paymentTypeWithdrawal))
    );
    accPeriodList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    // iscopyFile ="No";
    if (iscopyFile === "Yes") {
      // formData.olduniqueno = formData.uniqueno;
      this.setState(
        {
          isError: "",
          defaultaccountingPeriod: "",
          defaultPeriod: "",
          isStateChanged: false,
          accPeriodList: [],
          paymentType: [],
          paymentTypeWithdrawal: [],
          splitData: [],
        },
        () => {
          this.setState(
            {
              accPeriodList: accPeriodList,
              paymentType: paymentType,
              paymentTypeWithdrawal: paymentTypeWithdrawal,
              defaultaccountingPeriod: this.state.selectdefaultperiod,
              defaultPeriod: this.state.selectdefaultperiod,
              isStateChanged: true,
              splitData,
              showBadge: false,
              isCopyHasAttachment: true,
              isCopyEntry: true,
            },
            () => {
              this.GetTempUploadTransNo();
              this.resetReviewStatus();
              toast.success(
                "The transaction has been copied and is ready to make changes.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "TransSlideout",
                }
              );
            }
          );
        }
      );
    } else {
      this.setState(
        {
          isError: "",
          defaultaccountingPeriod: this.state.selectdefaultperiod,
          defaultaccountingPeriod1: this.state.selectdefaultperiod,
          showBadge: false,
          accPeriodList: [],
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          paymentType: [],
          paymentTypeWithdrawal: [],
          defaultPeriod: this.state.selectdefaultperiod,
          splitData: [],
          isOpenViewer: false,
        },
        () => {
          this.setState(
            {
              accPeriodList: accPeriodList,
              paymentType: paymentType,
              isCopyEntry: true,
              paymentTypeWithdrawal: paymentTypeWithdrawal,
              isStateChanged: true,
              splitData,
            },
            () => {
              this.GetTempUploadTransNo();
              this.resetReviewStatus();
              toast.success(
                "The transaction has been copied and is ready to make changes.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "TransSlideout",
                }
              );
            }
          );
        }
      );
    }
  };

  SaveCopyTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { formData, entryType, tempUniqueNo } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let acctType = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.state.formData.entryType;
    

    request.TenantID = tenantID;
    request.actionType = "Copy";
    request.UniqueNo = formData.uniqueno;
    request.iscopyAttachment = "Yes";
    request.TempUniqueNo = this.state.tempUniqueNo;
    request.oldUniqueNo = formData.olduniqueno;
    request.TypeFrom = acctType;
    request.OldTypeFrom = acctType;

    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            // if (!this.state.isCopyHasAttachment) {
            //     toast.success("Attachment uploaded successfully", { position: toast.POSITION.BOTTOM_RIGHT });
            // }
            this.setState({ isCopyHasAttachment: false }, () => {
              this.getUploadedFileList(1);
            });
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState(
              { isDisabled: false, isCopyHasAttachment: false },
              () => {
                this.getUploadedFileList(1);
              }
            );
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  copyVendor(iscopyFile) {
    let formData = { ...this.state.formData };
    formData.accPeriod = this.state.selectdefaultperiod;
    formData.invoiceno = "";
    formData.iscopyAttachment = iscopyFile === "Yes" ? "yes" : "no";
    formData.concilestatus = "No";
    formData.accPeriodstatus = "Active";
    formData.adj = "N";
    formData.checkNo = "";
    formData.actionType = "copy";
    formData.olduniqueno = formData.uniqueno;
    formData.transcationDate = null;
    let oldEtype = formData.entryType;
    formData.copyFromentryType = oldEtype;
    formData.oldpageType = oldEtype;

    if (Number(this.state.formData.vendorID) > 0) {
      if (this.state.formData.vendorStatus.toLowerCase() === "inactive") {
        let vendorSelected: any = [];
        let vendorItem: any = {};
        vendorItem.id = 0;
        vendorItem.accountNo = "";
        vendorItem.aid = 0;
        vendorItem.salestax = "";
        vendorItem.vendorName = "";
        vendorSelected.push(vendorItem);
        this.vendorSearch?.current.handleSelectFromParent(vendorSelected);

        formData.vendorID = 0;
        formData.vendorName = "";
        formData.vendorContract = "";
        formData.aid = 0;
        formData.transcationDate = null;
        formData.dueDate = null;
        formData.gDate = null;
        this.setState({ formData });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "inactive"
      ) {
        this.setState({ formData }, () => {
          this.handleMultiContract(this.state.formData.hotelID);
        });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "active"
      ) {
        this.setState({ formData });
      }
      let registerRequest: any = {};
      registerRequest.hotelID = this.state.hotelValue;
      this.bindCopyAccounts(registerRequest);
    }
    this.setState(
      { formData, htmlcomment: [], isComment: false, isError: "" },
      () => {
        this.setState({ isComment: true }, () => {
          $(".disabled-area")
            .find("input, textarea, button, select")
            .attr("disabled", "disabled");
        });
      }
    );
  }

  bindCopyAccounts(registerRequest: any) {
    registersevice
      .RegisterAccount(registerRequest)
      .then(async (result: any[] | null) => {
        if (result !== null) {
          let accountlist: any[] = [];
          result.forEach((element) => {
            if (element.acctType !== "C") {
              let acctName: any = {};
              acctName.id = element.oprID;
              acctName.name = element.name;
              acctName.acctType = element.acctType;
              accountlist.push(acctName);
            }
          });

          let formData = { ...this.state.formData };
          let defaultAccounts = accountlist.filter(
            (e) => e.id === formData.oprID
          );
          let accountName = "Account";
          if (defaultAccounts.length > 0) {
            accountName = accountlist.filter((e) => e.id === formData.oprID)[0]
              .name;
          } else {
            formData.oprID = "-1";
          }

          this.setState(
            {
              accountlist: [],
              accountName,
              defaultaccountType: accountName,
              formData,
            },
            () => {
              this.setState({ accountlist: accountlist });
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  handleCopyaccountName = (id: any) => {
    let formData = { ...this.state.formData };
    let acctType = this.state.accountlist.filter((x) => x.id === id)[0]
      .acctType;
    let newEtype = this.getNewEtype(acctType);
    formData.oprID = id;
    formData.entryType = newEtype;
    formData.pageType = newEtype;
    formData.paymenttype = "";

    if (
      newEtype === "Withdrawal" &&
      this.state.formData.actionType === "copy"
    ) {
      formData.paymenttype = "Manual ACH";
    }
    this.setState({
      formData,
      isStateChanged: true,
      defaultpaymentType: "Select Type",
    });
  };

  DeleteTransaction = () => {
    let deleteRequest: any = {};
    deleteRequest.uniqueno = this.state.formData.uniqueno;
    deleteRequest.fileUniqueNo = 0;
    deleteRequest.type = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : this.state.formData.entryType;
    deleteRequest.isRepeat = this.state.isRepeat ? "Yes" : "No";

    registersevice
      .DeleteTransaction(deleteRequest)
      .then(async (result: any | null) => {
        if (result.saveStatus === "Success") {
          toast.success("Transaction deleted successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "TransSlideout",
          });
          this.setState({ isSave: true }, () => {
            this.closeSlideOut();
          });
        } else {
          Utils.toastError(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "TransSlideout",
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleFileAfterSave = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      confirmAlert({
        title: "Delete Attachment",
        message: "Are you sure you want to delete?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.DeleteTransactionFiles(file),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      // file.Etype =this.getEtype();
      this.downloadTranactionFile(file);
    }
  };

  DeleteTransactionFiles = (file: any) => {
    let deleteRequest: any = {};
    deleteRequest.uniqueno =
      this.state.slideEntryType === "newEntry" ? 0 : file.uniqueNo;
    deleteRequest.fileUniqueNo = file.fileUniqueno;
    deleteRequest.type =
      this.state.slideEntryType === "newEntry" ? "TempUploadFiles" : file.etype;
    deleteRequest.isRepeat = "No";
    let fileno = file.fileNo;
    registersevice
      .DeleteTransactionFiles(deleteRequest)
      .then(async (result: any | null) => {
        if (result.saveStatus === "Success") {
          // toast.success("Attachment deleted successfully", {
          //     position: toast.POSITION.BOTTOM_RIGHT,
          //     containerId: "TransSlideout",
          // });
          this.getUploadedFileList(2);

          for (let i = 0; i < this.state.savedfiles.length; i++) {
            this["myRef" + i].current?.hanndleDeleteFile(Number(fileno));
          }
        } else {
          Utils.toastError(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "TransSlideout",
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  downloadTranactionFile = (file: any) => {
    file.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : file.uniqueNo;
    registersevice
      .DownloadTranactionFile(file)
      .then(async (result: any | null) => {
        // let csvURL = window.URL.createObjectURL(result);
        // let tempLink = document.createElement("a");
        // tempLink.href = csvURL;
        // tempLink.setAttribute("download", file.name);
        // tempLink.click();

        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  handleVoidAction() {
    if (this.state.voidPeriod.length === 0) {
      Utils.toastError("Please select accounting period.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    } else if (this.state.transcationvoidDate === null) {
      Utils.toastError("Please select Transaction Date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
      return false;
    }
    let VoidIds: any = [];
    let Voidrequest: any = [];
    const storage = JSON.parse(localStorage.getItem("storage")!);
    const tenantId = storage === null ? 0 : (storage.tenantID as any);

    VoidIds = this.state.associatedPayment.filter((x) => x.viewType === 1);
    VoidIds.forEach((element) => {
      let voidItem: any = {};
      voidItem.voidUniqueno = element.uniqueno;
      voidItem.voidaccperiod = this.state.voidPeriod;
      voidItem.voidDate = this.state.transcationvoidDate;
      voidItem.voidReason = this.state.voidNotes;
      voidItem.copyUniqueno =
        this.state.copyIds.filter((x) => x === element.uniqueno).length > 0
          ? "Yes"
          : "No";
      voidItem.hotelID = this.props.selectedRow.hid;
      voidItem.tenantID = tenantId;
      Voidrequest.push(voidItem);
    });

    this.SaveInvoiceVoid(Voidrequest);
  }

  SaveInvoiceVoid = (Voidrequest) => {
    this.setState({ isDisabled: true, isSpinner: true });
    registersevice
      .SaveInvoiceVoid(Voidrequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            toast.success("Invoice entry voided successfully.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
            setTimeout(() => {
              this.setState(
                { isDisabled: false, isSpinner: false, isSave: true },
                () => {
                  this.hideVoidModal("");
                  this.closeSlideOut();
                }
              );
            }, 3000);
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
            this.setState({
              isDisabled: false,
              isSpinner: false,
              isSave: true,
            });
          }
        }

        resolve();
      })
      .catch((error) => {
        this.setState({ isDisabled: false, isSpinner: false });
        reject();
      });
  };

  downloadCopyCheck = (eventKey) => {
    let request: any = {};

    let newckno = this.props.selectedRow.checkno.replace("-V", "");
    newckno = newckno.replace("-R1-A", "");
    newckno = newckno.replace("-R1-B", "");

    request.hotelID = this.props.selectedRow.hid;
    request.oprID = this.props.selectedRow.oprId;
    request.CheckNo = newckno;
    request.Checkdate = this.state.formData.chkDate;
    request.CheckType = "";
    request.Downloadcopy =
      eventKey === "downloadCopy"
        ? "DownloadCheck"
        : eventKey === "reprint"
          ? "Reprint"
          : "";
    request.Series = this.props.selectedRow.series;
    request.browserName = "Chrome";
    request.isCopyCheck = eventKey === "reprint" ? "Yes" : "No";
    request.vid = this.state.formData.vendorID;
    request.aid = this.state.formData.aid;

    registersevice
      .PrintActualCheck(request, eventKey)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.props.OpenInvoiceSlideOut(e, row, rowIndex, "child");
    },
  };
  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };

  handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState(() => ({
        selectedVoid: [...this.state.selectedVoid, row.id],
        copyIds: [...this.state.copyIds, row.uniqueno],
      }));
    } else {
      this.setState(() => ({
        selectedVoid: this.state.selectedVoid.filter((x) => x !== row.id),
        copyIds: this.state.copyIds.filter((x) => x !== row.uniqueno),
      }));
    }
  };

  handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    const uniquenos = rows.map((r) => r.uniqueno);
    if (isSelect) {
      this.setState(() => ({
        selectedVoid: ids,
        copyIds: uniquenos,
      }));
    } else {
      this.setState(() => ({
        selectedVoid: [],
        copyIds: [],
      }));
    }
  };

  openFileViewer = (row: any) => {
    let uniqueNo = row.uniqueNo;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let etype = this.state.formData.entryType;
    window.open(
      "/MediaViewer?Uniqueno=" +
      btoa(uniqueNo) +
      "&tenantID=" +
      btoa(tenantID) +
      "&Etype=" +
      btoa(etype),
      "_blank"
    );
  };

  /*Viewer Start*/

  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.filter((file) => file?.etype?.toLowerCase() !== "invoices").forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else if (chktype === "All") {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.fileNo !== fileNo);
        this.setState({ chkIds: newIds });
        // setchkIds(newIds);
      } else {
        const newIds = [...this.state.chkIds];
        files
          .filter((x) => x.fileNo === fileNo)
          .forEach((element) => {
            for (let inx = 0; inx < element.totalpage; inx++) {
              let id = element.fileNo.toString() + "_" + inx.toString();
              const selectedId1 = `custom_${id}`;
              const newId = this.state.chkIds.filter(
                (x) => x.id === selectedId1
              );
              if (newId.length === 0) {
                let item: any = {};
                item.id = selectedId1;
                item.fileNo = element.fileNo;
                newIds.push(item);
              }
            }
            this.setState({ chkIds: newIds });
            // setchkIds(newIds);
          });
      }
    } else {
      // const selectedId = `custom_${id}`

      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };

  hideBulkselect = () => {
    this.setState({ bulkSelect: false, chkIds: [], selectedChk: [] });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  };

  OpenViewer = () => {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        defaultView: "doc-view",
        //fileSelect: this.state.savedfiles.length > 0 ? this.state.savedfiles[0] : this.state.newSelectfiles[0],
      }),
      () => {
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  };

  handleUpdatedFile = () => {
    return this.state.chkIds;
  };

  // adjustMapping = () => {
  //     this.setState({ isMappedShow: true }, () => {
  //         this.pdfExtract();
  //     });
  // }

  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    //console.log("updateZoom-" + updateZoom);
    this.setState({ currentZoom: updateZoom });
  };

  handleAllCheckbox = (event) => {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  };

  handleBulkRotate = () => {
    this.handleRotate(this.state.chkIds, 0, 0);
  };

  handleBulkRemove = () => {
    this.handlePageRemove(this.state.chkIds, 0, 0);
  };

  handleRotate = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : this.state.formData.entryType;
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : this.state.formData.entryType;
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRotation(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select at least one page to rotate.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
    }
  };

  saveRotation = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RotatePDf(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            } else {
              toast.success("Pages rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            }

            this.setState({ selectedChk: chkIds }, () => {
              // this.setState({ selectedChk: [], chkIds: [], bulkSelect: false }, () => {
              this.getUploadedFileList(1);
              // this.GetPostToInvoice();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveCreditCard",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  handlePageRemove = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : this.state.formData.entryType;
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : this.state.formData.entryType;
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRemovepage(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select at least one page to remove.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "TransSlideout",
      });
    }
  };

  saveRemovepage = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RemovePDFPage(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              });
            } else {
              toast.success("Pages removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "TransSlideout",
              });
            }

            this.setState({ selectedChk: [chkIds], isSave: true }, () => {
              this.getUploadedFileList(1);
              // this.GetPostToInvoice();
              this.hideBulkselect();
              // setTimeout(() => {
              //     this.setState({ bulkSelect: true })
              //     for (let i = 0; i < this.state.savedfiles.length; i++) {
              //         this["myRef" + i].current.showBulkSelect();
              //     }
              // }, 1000)
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "TransSlideout",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };
  /*Viewer Ends*/

  handleDatePicker = (event: any, refName: any) => {
    refName?.current?.setOpen(true);//NW-34282
  };

  // handleThreeDotsMenu = (eventKey: any) => {
  //     debugger;
  //     if (eventKey === "move") {
  //         this.setState({ showMoveAfterPaymentModal: true, });
  //     }
  // }

  hideMoveAfterPaymentModal = (event: any) => {
    this.setState({
      showMoveAfterPaymentModal: false,
      moveHIDAfterPayment: {
        hidValue: -1,
        hidName: "",
      },
      moveSelectedContract: "",
      showContractDropdown: false,
      contractsArray: [],
      moveAccountListArray: [],
      showAccountsDropdown: false,
      moveSelectedAccountOprId: -1,
    });
  };

  moveInvoiceEHIDAfterPayment = () => {
    if (
      this.state.moveHIDAfterPayment.hidValue.toString() === "-1" ||
      this.state.moveHIDAfterPayment.hidValue.toString() === ""
    ) {
      Utils.toastError("Please select EHID!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (this.state.hotelValue === this.state.moveHIDAfterPayment.hidValue) {
      this.moveInvoiceYesBtnClicked();
    } else {
      confirmAlert({
        title: "Move Invoice",
        message:
          "Are you sure you want to move this invoice? Moving the invoice to a new EHID will require it to go back through the Invoice Approval process.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.moveInvoiceYesBtnClicked(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
  };

  moveInvoiceYesBtnClicked = () => {
    //debugger;
    this.setState({ isLoader: true });
    let associatedPaymentArray = this.state.associatedPayment.filter(
      (x) => x.viewType === 1
    );
    let uniqueNos = "";
    associatedPaymentArray.map((e, index) => {
      if (index === associatedPaymentArray.length - 1) {
        uniqueNos = uniqueNos + e.uniqueno;
      } else {
        uniqueNos = uniqueNos + e.uniqueno + ",";
      }
    });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request: any = {};
    request.HotelID = this.state.moveHIDAfterPayment.hidValue;
    request.Vid = this.state.formData.vendorID;
    request.UniquenoList = uniqueNos;
    request.Contract =
      this.state.hotelValue === this.state.moveHIDAfterPayment.hidValue
        ? ""
        : this.state.contractsArray.filter(
          (e) => e.displayVendorContract === this.state.moveSelectedContract
        )[0].vendorContract;
    request.Type = "";
    request.OprID = this.state.moveSelectedAccountOprId;
    request.tenantid = tenantID;

    registersevice
      .MovePaidInvoice(request)
      .then(async (result: any | null) => {
        //debugger;
        if (result !== null) {
          if (result[0].error === "success") {
            toast.success(result[0].msg, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState({ isLoader: false }, () => {
              this.props.hideSlideOut(true);
            });
          } else {
            Utils.toastError(result[0].msg, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState({ isLoader: false });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isLoader: false });
        reject();
      });
  };

  onSelectEHIDList = (item: any) => {
    //debugger;
    let moveHIDAfterPayment = { ...this.state.moveHIDAfterPayment };
    moveHIDAfterPayment.hidValue = item.id;
    moveHIDAfterPayment.hidName = item.name;
    this.setState(
      {
        moveHIDAfterPayment,
        moveSelectedContract: "",
        showContractDropdown: false,
        contractsArray: [],
        moveAccountListArray: [],
        showAccountsDropdown: false,
        moveSelectedAccountOprId: -1,
      },
      () => {
        if (this.state.hotelValue === this.state.moveHIDAfterPayment.hidValue) {
          this.getAccountList();
        } else {
          this.GetVendorActiveContract();
        }
      }
    );
  };

  getAccountList = () => {
    let request: any = {};
    request.hotelID = this.state.moveHIDAfterPayment.hidValue;
    request.paymentType = this.state.associatedPaymentEtype
      .toString()
      .toLowerCase()
      .includes("ach")
      ? "ach"
      : this.state.associatedPaymentEtype;

    registersevice
      .GetAccountList(request)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          let accountlist: any = [];
          result.forEach((element) => {
            let item: any = {};
            item.id = element.oprID;
            item.name = element.name;
            if (this.props.accDetails.oprID !== item.id) {
              accountlist.push(item);
            }
          });
          this.setState({
            moveAccountListArray: accountlist,
            showAccountsDropdown: true,
          });
        }
      })
      .catch((error) => {
        reject();
      });
  };

  GetVendorActiveContract = () => {
    //debugger;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request: any = {};
    request.HotelID = this.state.moveHIDAfterPayment.hidValue;
    request.Vid = this.state.formData.vendorID;
    request.UniquenoList = "";
    request.Contract = "";
    request.Type = "";
    request.tenantid = tenantID;

    registersevice
      .GetVendorActiveContract(request)
      .then(async (result: any | null) => {
        //debugger;
        if (result !== null && result.length > 0) {
          if (result.length === 1) {
            this.setState({
              moveSelectedContract: result[0].displayVendorContract,
              contractsArray: result,
            });
          } else {
            this.setState({
              moveSelectedContract: "Select Contract",
              showContractDropdown: true,
              contractsArray: result,
            });
          }
        } else {
          Utils.toastError(
            "This EHID does not have an active contract with this Vendor. Please create a contract and then move the transaction.",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        // this.setState({ isLoader: false});
        reject();
      });
  };

  onSelectContract = (e: any) => {
    this.setState({ moveSelectedContract: e.displayVendorContract });
  };

  getMovePaidInvoiceHotels = () => {
    //debugger;
    let associatedPaymentArray = this.state.associatedPayment.filter(
      (x) => x.viewType === 1
    );
    let uniqueNos = "";
    associatedPaymentArray.map((e, index) => {
      if (index === associatedPaymentArray.length - 1) {
        uniqueNos = uniqueNos + e.uniqueno;
      } else {
        uniqueNos = uniqueNos + e.uniqueno + ",";
      }
    });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let request: any = {};
    request.UniquenoList = uniqueNos;
    request.Type = "Invoice";
    request.tenantid = tenantID;

    registersevice
      .MovePaidInvoiceHotels(request)
      .then(async (result: any | null) => {
        //debugger;
        if (result !== null && result.length > 0) {
          this.setState({ moveInvoiceEHID: result }, () => {
            this.setState({ showMoveAfterPaymentModal: true });
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(`Server Error: ${error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reject();
      });
  };

  //Add Flag and Status Update

  callBackCommentLoad = () => {
    if (this.props?.loadFrom?.toLowerCase() === "depositcomments" || this.props?.loadFrom?.toLowerCase() === "withdrawalcomments") {

      setTimeout(() => {
        this.scrollToBottom();
      }, 600);
    }
  }

  CommentModalClose = () => {
    let uniqueno = this.state.formData.uniqueno;
    this.closeSlideOut();
  };

  showbanner = (status) => {
    this.setState({ reviewStatus: status }, () => {
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let userName = storage.userName;
      let reviewstatus = this.state.reviewStatus;
      let currentFlagName = this.state.statusTypeList.filter(x => x.eventName.toLowerCase() === reviewstatus.toLowerCase())[0].name;
      let reviewCurrentDescription = currentFlagName + ' by ' + userName;



      let isReview = false;
      // if ((this.state.canReview === "Yes" || this.state.canFlag === "Yes") && (this.state.reviewStatus === "Flag for Review" || this.state.reviewStatus === "Needs Review")) {
      //   isReview = true;
      // }

      if ((this.state.reviewStatus === "Flag for Review" || this.state.reviewStatus === "Needs Review")) {
        isReview = true;
      }


      this.setState({ reviewCurrentDescription, isReviewed: isReview }
        , () => {
          this.addReviewStatus();
        });

    })

  }



  GetTransactionComment = (uniqueNo) => {
    let statusTypeList: any[] = [...STATUSTYPELIST]
    let etype =this.getEtype();

    let commentRequest: any = {};
    commentRequest.uniqueNo = uniqueNo;
    commentRequest.etype = this.props.selectedRow?.isDraftUpdate === "Yes" ? "DraftTransaction" : etype;
    registersevice
      .GetTransactionComment(commentRequest)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          let currentStatus = result[0].currentStatus;
          let currentStatusUserName = result[0].currentStatusUserName;
          // if (currentStatus.toLowerCase() === "review") {
          //   currentStatus = "markForReview";
          // }
          let reviewCurrentDescription = "";
          if (currentStatus.length > 0) {
            let currentFlagName = statusTypeList.filter(x => x.eventName.toLowerCase() === currentStatus.toLowerCase())[0].name;
            reviewCurrentDescription = currentFlagName + ' by ' + currentStatusUserName;
          }


          this.setState({ htmlcomment: [], isComment: false }, () => {
            this.setState({ htmlcomment: result, isComment: true, reviewCurrentDescription, reviewStatus: currentStatus, selectedReviewStatus: currentStatus }, () => {
              this.addReviewStatus();
            });
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  addReviewStatus = () => {
   
    let statusTypeList: any[] = [...STATUSTYPELIST]

    let muniqueno = (this.props.pageType?.toLowerCase() === "deposit" || this.props.pageType?.toLowerCase() === "withdrawal") ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno;
    if (this.props.uniqueNo > 0) {
      muniqueno = this.props.uniqueNo;
    }
    if (this.state.formData.actionType === "copy") {
      muniqueno = 0;
    }

    let isShowBanner = false;
    let isReview = false;
    if (this.state.reviewStatus.length > 0) {
      isShowBanner = true;
    }
    if ((this.state.reviewStatus === "Flag for Review" || this.state.reviewStatus === "Needs Review")) {
      isReview = true;
    }

    if ((this.state.reviewStatus === "Review Complete") && muniqueno > 0) {
      isReview = false;
    }

    // if ((this.state.canReview === "Yes" || this.state.canFlag === "Yes") && (this.state.reviewStatus === "Flag for Review" || this.state.reviewStatus === "Needs Review")) {
    //   isReview = true;
    // }

    if ((this.state.canReview === "Yes" || this.state.canFlag === "Yes") && (this.state.reviewStatus === "Review Complete") && muniqueno > 0) {
      isShowBanner = false;
      // isReview = false;
    }

    if (this.props.pageType === "payment") {
      isShowBanner = false
    }


    let statusList: any[] = [];
    statusTypeList.forEach((element, index) => {

      if (element.eventName === "Flag for Review" && this.state.canFlag === "Yes" && (this.state.reviewStatus === "" || this.state.reviewStatus === "Review Complete")) {
        statusList.push(element);
      }
      if (element.eventName === "Needs Review" && this.state.canFlag === "Yes" && (this.state.reviewStatus === "Reviewed") && muniqueno > 0) {
        statusList.push(element);
      }
      if (element.eventName === "Reviewed" && this.state.canReview === "Yes" && (this.state.reviewStatus === "Flag for Review"
        || this.state.reviewStatus === "Needs Review") && muniqueno > 0) {
        statusList.push(element);
      }
      if (element.eventName === "Review Complete" && this.state.canFlag === "Yes" && (this.state.reviewStatus === "Flag for Review"
        || this.state.reviewStatus === "Needs Review" || this.state.reviewStatus === "Reviewed") && muniqueno > 0) {
        statusList.push(element);
      }

    });





    this.setState({ statusTypeList: [], showReviewBanner: isShowBanner, isReviewed: isReview, selectedReviewStatus: this.state.reviewStatus }, () => {
      this.setState({ statusTypeList: statusList });
    });


  }

  getReviewPermissions = (hidValue, type = "") => {
    let request: any = {};
    request.HotelId = hidValue;
    registersevice
      .GetReviewPermissions(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.length > 0) {
            this.setState({
              canReview: result[0].canReview,
              canFlag: result[0].canFlag,
            }, () => {

              if (type === "move") {
                this.setState({ isComment: false }, () => {
                  if (this.state.htmlcomment.length > 0 && this.state.htmlcomment[0].currentStatus.length > 0) {
                    this.addReviewStatus();
                  }
                  this.setState({ isComment: true });
                })
              }
              else {
                this.setState({ isComment: false }, () => {
                  this.setState({ isComment: true });
                })
              }
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  addReviewComment = (mentionData: any) => {
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userName = storage.userName;
    let reviewstatus = this.state.reviewStatus;
    const statusTypeList = [...STATUSTYPELIST]
    let currentFlagName = statusTypeList.filter(x => x.eventName.toLowerCase() === reviewstatus.toLowerCase())[0].name;
    let reviewCurrentDescription = currentFlagName + ' by ' + userName;

    // if (reviewstatus.toLowerCase() === "markforreview") {
    //   reviewstatus = "Review";
    // }
    this.ChildComment?.current.addReviewComment(reviewstatus, mentionData);
    this.closeCommentModal(true);
    this.setState({ reviewCurrentDescription }
      , () => {
        this.addReviewStatus();
        this.ChildComment?.current.addReviewStatus(this.state.reviewStatus);
      });

  }

  handleReviewStatus = (type) => {
    const statusTypeList = [...STATUSTYPELIST]
    const selectedStatus = statusTypeList?.find(x => x.eventName == type)
    const commentModalTitle = selectedStatus ? selectedStatus.commentModalTitle : "";
    this.setState({ commentModalTitle, reviewStatus: type }, () => {
      this.setState({ showCommentModal: true });
    })
  }

  closeCommentModal = (isUpdate) => {
    this.setState({ showCommentModal: false });
  }

  resetReviewStatus = () => {
    this.setState({
      statusTypeList: [], isReviewed: false, showReviewBanner: false, showCommentModal: false,
      commentModalTitle: "", reviewStatus: "Flag for Review", selectedReviewStatus: "", reviewCurrentDescription: "", isComment: false
    }, () => {
      this.setState({ statusTypeList: [...STATUSTYPELIST], isComment: true });
    });

  }

  renderTopBannerWithDropdown = () => {
    return (!(this.props.pageType === "payment") && <div className="top-banner-sec pos-sticky ">
      {this.state.showReviewBanner &&
        <div className={`banner margin d-flex align-items-center ${this.state.isReviewed ? "reviewed orange-bg" : "blue-bg"}`}>
          <div className="flag-icon">
            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
            </svg>
          </div>
          {/* <div>{this.state.isReviewed ? `Reviewed by ${'Todd.Book'}` : `Flagged for Review by ${'Meghan.Dunhagan'}`}</div> */}
          <div>{this.state.reviewCurrentDescription}</div>
          {this.state.statusTypeList.length > 0 && (
            <Dropdown className="custom-selectbox ml-auto" alignRight>
              <Dropdown.Toggle id="dropdownStatusList" className="d-flex align-items-center">

                <div className="value"><EllipsisWithTooltip placement="bottom"> {'Change Status'}</EllipsisWithTooltip></div>

                <div className="arrow ml-auto">
                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                  </svg>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {this.state.statusTypeList.map(
                  (item: any, index: any) => (
                    <Dropdown.Item
                      className={`d-flex align-items-center ${item.eventName == 'Flag for Review' ? "flgForReview" : ""} ${item.eventName == 'delete' ? "delete" : ""}`}
                      key={item.eventName}
                      eventKey={item.name}
                      onClick={() => this.handleReviewStatus(item.eventName)}
                    >
                      <EllipsisWithTooltip placement="bottom">
                        {item.name}
                      </EllipsisWithTooltip>
                      {item.eventName == 'Flag for Review' && (
                        <div className="flag-icon ml-auto">
                          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.9 2.5L9.66 1.3C9.57 0.84 9.16 0.5 8.68 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V16.5C0.5 17.05 0.95 17.5 1.5 17.5C2.05 17.5 2.5 17.05 2.5 16.5V10.5H8.1L8.34 11.7C8.43 12.17 8.84 12.5 9.32 12.5H14.5C15.05 12.5 15.5 12.05 15.5 11.5V3.5C15.5 2.95 15.05 2.5 14.5 2.5H9.9Z" />
                          </svg>
                        </div>
                      )}
                    </Dropdown.Item>

                  )
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      }
    </div>)
  }

  renderFlagDropdownItems = () => {
    const { canFlag, canReview, selectedReviewStatus, formData, isRepeat } = this.state;
    const canShowReviewActions = (this.props.pageType?.toLowerCase() === "deposit" || this.props.pageType?.toLowerCase() === "withdrawal") ? formData.uniqueno : formData.incompleteUniqueno > 0;

    return (!(this.props.pageType === "payment") &&
      <>

        {canFlag === "Yes" && ["", "Review Complete"].includes(selectedReviewStatus) && (
          <Dropdown.Item eventKey="Flag for Review" key="FlagforReview1" disabled={isRepeat}>
            Flag for Review
          </Dropdown.Item>
        )}
        {canFlag === "Yes" && selectedReviewStatus === "Reviewed" && (
          <Dropdown.Item eventKey="Needs Review" key="NeedsReview1">
            Needs Review
          </Dropdown.Item>
        )}
        {canReview === "Yes" && ["Flag for Review", "Needs Review"].includes(selectedReviewStatus) && canShowReviewActions && (
          <Dropdown.Item eventKey="Reviewed" key="Reviewed1">
            Reviewed
          </Dropdown.Item>
        )}
        {canFlag === "Yes" && ["Flag for Review", "Needs Review", "Reviewed"].includes(selectedReviewStatus) && canShowReviewActions && (
          <Dropdown.Item eventKey="Review Complete" key="CompleteReview1">
            Review Complete
          </Dropdown.Item>
        )}
      </>
    );
  }

  // End Add Flag and Status Update

  onSelectRepeatType = (item) => {
    this.setState({ selectedRepeatType: item.name, isStateChanged: true});
  }


  render() {
    const highlightDates = [
      new Date(), // Current date
    ];
    /*Viewer */
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };
    const handleUpdate = (newtext) => {
      //this.setState({ defaultView: "doc-view"});
      toggleSwitch("doc-view");
      setTimeout(function () {
        var currentPos: any = $(`#${newtext}`).offset()?.top;
        var marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      //let docViewerFiles : any =[];
      docViewerFiles.push(docFiles);
      //this.setState({ docViewerFiles: docFiles })
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };

    const currentView = this.state.defaultView;
    const savedfilesCount = this.state.savedfiles.length;
    const allsavedfiles = this.state.savedfiles;
    let hideZoombtn =
      allsavedfiles.length === 1 &&
      allsavedfiles[0].name
        .split(".")
        .pop()
        .includes("xls".toLocaleLowerCase());
    let NoDelPermission =
      (this.props.pageType === "payment" ||
        this.state.isPermission.toString().toLowerCase() === "yes") &&
        this.state.formData.accPeriodstatus.toString().toLowerCase() ===
        "active" &&
        this.state.formData.concilestatus.toString().toLowerCase() !== "yes" &&
        this.state.formData.adj.toString().toLowerCase() !== "y"
        ? false
        : true;
    /*Viewer */

    // $('.disabled-area').find('input, textarea, button, select table').attr('disabled','disabled');
    let IsVendor = false,
      IsProject = false,
      IsDescription = false;
    const maxSize = 1048576;

    let btnlist = true;
    btnlist =
      this.props.pageType === "payment" &&
        !this.state.formData.checkNo.toString().toLowerCase().includes("pay") &&
        this.state.formData.adj === "Y"
        ? false
        : true;
    if (
      this.props.pageType === "payment" &&
      this.state.formData.checkNo.toString().toLowerCase().includes("pay")
    ) {
      btnlist = false;
    }

    if (
      (this.state.associatedPaymentEtype
        .toString()
        .toLowerCase()
        .includes("ach") ||
        this.state.associatedPaymentEtype.toString().toLowerCase() ===
        "Credit Card".toString().toLowerCase()) &&
      this.state.voidConcile.toString().toLowerCase() === "yes"
    ) {
      btnlist = false;
    }

    if (
      this.state.formData.checkNo.toString().toLowerCase() === "epay" &&
      this.state.epayCheckNo !== ""
    ) {
      btnlist = true;
    }

    // if(btnlist === true && (this.state.isMovePermission.toLowerCase() !== "yes" && this.state.isPermission.toLowerCase() !== "yes")) {
    //     btnlist = false;
    // }
    const associatedInvoicesColumns = [
      {
        dataField: "date",
        text: "Date",
      },
      {
        dataField: "invoiceNo",
        text: "Number",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.invoiceNo}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "addContract",
        text: "Customer Num",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.addContract}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "transTotal",
        text: "Amount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div>
              {Utils.amountFormatted(Number(row.transTotal).toFixed(2))}
            </div>
          );
        },
      },
      {
        dataField: "paymentType",
        text: "Status",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return <div className="paid-status">{row.paymentType}</div>;
        },
      },
    ];
    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: this.state.selectedVoid,
      onSelect: this.handleOnSelect,
      onSelectAll: this.handleOnSelectAll,
      selectionHeaderRenderer: ({ mode, ...rest }) => (
        <Form.Check type={mode} {...rest} label="" custom />
      ),
      selectionRenderer: ({ mode, ...rest }) => (
        <>
          {/* <input type={ mode } { ...rest } /> */}
          <Form.Check type={mode} {...rest} label="" custom />
        </>
      ),
    };

    const renderChild = (row) => {
      let associatedPaymentDetail: any = [];
      associatedPaymentDetail = this.state.associatedPayment.filter(
        (x) => x.uniqueno === row.uniqueno && x.viewType === 2
      );
      IsVendor = associatedPaymentDetail[0].isVendor === "Yes" ? false : true;
      IsProject = associatedPaymentDetail[0].isProject === "Yes" ? false : true;
      IsDescription =
        associatedPaymentDetail[0].isDescription === "Yes" ? false : true;

      const columnChild = [
        {
          dataField: "spltCode",
          text: "EHID",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.splitCode}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "coa",
          text: "COA",
          headerClasses: "coa-width",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coa + " " + row.coaName}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "subVendor",
          text: "Sub Vendor",
          hidden: IsVendor,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.subVendor}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "projectName",
          text: "Project",
          hidden: IsProject,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.projectName}
              </EllipsisWithTooltip>
            );
          },
        },

        {
          dataField: "description",
          text: "Description",
          hidden: IsDescription,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.description}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "amount",
          text: "Amount",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div>{Utils.currencyFormatWithOutdoller(row.amount)}</div>;
          },
        },
        {
          dataField: "",
          text: "",
        },
      ];

      return (
        <>
          <BootstrapTable
            id="tblchild"
            keyField="id"
            data={associatedPaymentDetail}
            columns={columnChild}
            rowEvents={this.rowEvents}
          />
        </>
      );
    };

    const expandAssociatedInvoiceRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const files = this.state.newSelectedfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex">
              <div className="name-loader">
                <div className="name">
                  <EllipsisWithTooltip placement="bottom">
                    <div className="full-name">{file.name}</div>
                    {/* <div className="full-size">- {file.size} bytes</div> */}
                  </EllipsisWithTooltip>
                </div>
                {/* <div className="loader"><ProgressBar animated variant="success" now={45} /></div> */}
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
                {/* <div className="percentage d-flex justify-content-center align-items-center">45%</div> */}
              </div>
            </div>
            <div className="action">
              {this.state.newSelectedfiles.length > 0 ? (
                <Spinner
                  size="sm"
                  title="Uploading..."
                  animation="border"
                  variant="success"
                />
              ) : (
                <Dropdown
                  tabIndex={this.state.tabDisable}
                  className="more-action"
                  alignRight
                  onSelect={(event: any) =>
                    this.handleSelectFileUpload(event, file, index)
                  }
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {this.state.moreActionFileUpload.map(
                      (item: any, idx: any) => (
                        <>
                          <Dropdown.Item
                            eventKey={
                              this.state.moreActionFileUpload[idx].eventKey
                            }
                            key={idx}
                          >
                            {this.state.moreActionFileUpload[idx].name}
                          </Dropdown.Item>
                        </>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </li>
      </>
    ));

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex">
              <div className="name-loader">
                <div className="name d-flex">
                  <div className="full-name">{file.name}</div>
                  {/* <div className="full-size">- {file.size} bytes</div> */}
                </div>
                {/* <div className="loader"><ProgressBar animated variant="success" now={45} /></div> */}
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
                {/* <div className="percentage d-flex justify-content-center align-items-center">45%</div> */}
              </div>
            </div>
            <div className="action">
              {this.state.isAttachmentLoading ? (
                <Spinner
                  size="sm"
                  title="Uploading..."
                  animation="border"
                  variant="success"
                />
              ) : (
                <Dropdown
                  tabIndex={this.state.tabDisable}
                  className="more-action"
                  alignRight
                  onSelect={(event: any) =>
                    this.handleFileAfterSave(event, file, index)
                  }
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary more"
                    id="dropdown-more"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                      <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                      <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {file.fileUniqueno > 0 && (
                      <>
                        {(this.props.pageType === "payment" ||
                          this.state.isPermission.toString().toLowerCase() ===
                          "yes") &&
                          this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() === "active" &&
                          this.state.formData.concilestatus
                            .toString()
                            .toLowerCase() !== "yes" &&
                          file.etype.toLowerCase() !== "invoices" &&
                          this.state.formData.adj.toString().toLowerCase() !==
                          "y" && (
                            <Dropdown.Item
                              className={
                                this.state.isError ===
                                  "NotEdit" /* || this.state.formData.actionType === "copy"*/
                                  ? "isHide"
                                  : ""
                              }
                              eventKey={"delete"}
                              key={2}
                            >
                              Delete
                            </Dropdown.Item>
                          )}
                        <Dropdown.Item eventKey={"download"} key={"1"}>
                          {" "}
                          Download{" "}
                        </Dropdown.Item>
                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </li>
      </>
    ));

    // const attachmentheader = (column: any, colIndex: any) => {
    //     return (
    //         <div className="paperClipBtn">
    //             <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path></svg>
    //         </div>
    //     );
    // }

    const attachmentheader = (column: any, colIndex: any) => {
      return (
        <div className="paperClipBtn">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 448 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path>
          </svg>
        </div>
      );
    };
    // const transactionsData = [
    //     {id: 1, coa: "", subVendor: "", description: "", amount: "" }
    // ];
    const previousTransactionsColumns = [
      {
        dataField: "accper",
        text: "AP",
        headerClasses: "cl ap",
        classes: "cl ap",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return <>{row.accper}</>;
        },
      },
      {
        dataField: "date",
        text: "Date",
        headerClasses: "date",
      },
      {
        dataField: "lettercode",
        text: "EHID",
        headerClasses: "ehid",
      },
      {
        dataField: "internalnotes",
        text: "Notes",
        headerClasses: "notes",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.internalnotes}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "isFile",
        text: "Attachments",
        headerClasses: "attachments",
        // hidden: true,
        headerFormatter: attachmentheader,
        formatter: (cell: any, row: any, rowIndex: any) => {
          if (row.isFile === "Yes") {
            return (
              <div
                className="paperClipBtn"
                onClick={() => this.openFileViewer(row)}
              >
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                </svg>
              </div>
            );
          } else {
            return <div></div>;
          }
        },
      },
      // {
      //     dataField: '',
      //     text: '',
      //     headerClasses: "description",
      // },
      {
        dataField: "transTotal",
        text: "Total",
        headerClasses: "amount",
        classes: "amount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.amountFormatted(Number(row.transTotal).toFixed(2))}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "cl",
        text: "CL",
        headerClasses: "cl",
        classes: "cl",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return <>{row.cl}</>;
        },
      },
    ];

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderPreviousTableChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderPreviousTableChild = (mainrow) => {
      let SplitPreviousCOADetail: any = [];
      SplitPreviousCOADetail = this.state.previousTransactionsData.filter(
        (x) => x.uniqueNo === mainrow.uniqueNo && x.mainType === 2
      );

      const columnCOAChild = [
        {
          dataField: "",
          text: "",
          headerClasses: "expand-cell-header",
          classes: "expand-cell-header",
          headerFormatter: whiteBgFormatter,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div className="white-bg"></div>;
          },
        },
        {
          dataField: "",
          text: "",
          headerClasses: "date",
          classes: "date",
        },
        {
          dataField: "coa",
          text: "COA #",
          headerClasses: "ehid",
          classes: "ehid",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coa}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "cOAName",
          text: "COA Name",
          headerClasses: "notes",
          classes: "notes",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coaName}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "description",
          text: "Description",
          headerClasses: "description",
          classes: "description",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.description}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "accper",
          text: "A/C Period",
          hidden: true,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.accper}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "amount",
          text: "Amount",
          headerClasses: "amount",
          classes: "amount",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>{Utils.amountFormatted(Number(row.amount).toFixed(2))}</div>
            );
          },
        },
        // , {
        //     dataField: '',
        //     text: '',
        //     headerClasses: 'blankLastChildofChild',
        // }
        {
          dataField: "",
          text: "",
          headerClasses: "blankLastChildofChild",
        },
        {
          dataField: "",
          text: "",
          headerClasses: "cl",
          classes: "cl",
          headerFormatter: whiteBgFormatter,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div className="white-bg"></div>;
          },
        },
      ];

      return (
        <>
          <BootstrapTable
            id="tblCOAchild"
            keyField="uniqueNo"
            data={SplitPreviousCOADetail}
            columns={columnCOAChild}
          />
        </>
      );
    };

    const notesIcon = () => {
      return (
        <svg
          stroke="currentColor"
          fill="#1d1e20"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1.2em"
          width="1.2em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19,4h-3V2h-2v2h-4V2H8v2H5C3.897,4,3,4.897,3,6v14c0,1.103,0.897,2,2,2h14c1.103,0,2-0.897,2-2V6C21,4.897,20.103,4,19,4z M5,20V7h3h2h4h2h3V6l0.002,14H5z"></path>
          <path d="M7 9H17V11H7zM7 13H12V15H7z"></path>
        </svg>
      );
    };

    const { showChangeLogModal } = this.state;

    const isVendorDisabled =
      this.state.formData.accPeriodstatus.toString().toLowerCase() !==
      "active" ||
      this.state.formData.concilestatus.toString().toLowerCase() === "yes" ||
      this.state.isPermission === "No" ||
      this.state.isError === "NotEdit";
    const iSePayEntry =
      this.state.formData.paymenttype.toString().toLocaleLowerCase() === "epay";
    const isStatusPaidSent =
      this.state.isPaymentStatus.toString().toLocaleLowerCase() === "paid" ||
      this.state.isPaymentStatus.toString().toLocaleLowerCase() === "sent";
    const isePayMethod = this.state.ePayMethod !== "";
    return (
      <div className="transaction-slideout pos-fxd index-1000">
        {/* <ToastContainer
          autoClose={3000}
          containerId={"TransSlideout"}
          enableMultiContainer
        /> */}
        {showChangeLogModal && (
          <TransactionLogHistory
            payPeriodStartDate={""}
            payPeriodEndDate={""}
            showChangeLogModal={showChangeLogModal}
            showHideChangeLogModal={this.showHideChangeLogModal}
            hotelName={""}
            hotelId={0}
            hideCrossAndClearFilters={false}
            shiftId={this.props.uniqueNo}
            shiftDate={""}
            accType={this.state.formData.entryType}
          />
        )}
        <div className="d-flex">
          {/* <div className="back-drop" onClick={this.hideSlideOut}></div> */}
          {!this.state.isOpenViewer && (
            <div
              className="back-drop  viewer-panel opacity"
              onClick={() => this.hideSlideOut()}
            ></div>
          )}
          {this.state.isOpenViewer && (
            <div className="back-drop viewer-panel">
              <div className="header-panel d-flex justify-content-between align-items-center">
                <div className="page-ttl">Attachments</div>
                <div className="toggle-button">
                  <ButtonGroup aria-label="Basic example">
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      value={this.state.defaultView}
                      onChange={toggleSwitch}
                    >
                      <ToggleButton value={"doc-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                          <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                        </svg>
                      </ToggleButton>
                      <ToggleButton value={"grid-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                        </svg>
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </ButtonGroup>
                </div>
                <div className="action d-flex">
                  {this.state.isMapped.toString().toLowerCase() ===
                    "Yes".toString().toLowerCase() && (
                      <button type="button" className="btn wht-bg cross">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0003 13.3333C11.8387 13.3333 13.3337 11.8383 13.3337 9.99996C13.3337 8.16163 11.8387 6.66663 10.0003 6.66663C8.16199 6.66663 6.66699 8.16163 6.66699 9.99996C6.66699 11.8383 8.16199 13.3333 10.0003 13.3333ZM10.0003 8.33329C10.9037 8.33329 11.667 9.09663 11.667 9.99996C11.667 10.9033 10.9037 11.6666 10.0003 11.6666C9.09699 11.6666 8.33366 10.9033 8.33366 9.99996C8.33366 9.09663 9.09699 8.33329 10.0003 8.33329Z"
                            fill="white"
                          />
                          <path
                            d="M2.37086 13.4466L3.20419 14.8883C3.64669 15.6525 4.71169 15.9391 5.47919 15.4966L5.92003 15.2416C6.40503 15.6225 6.93753 15.935 7.50003 16.1683V16.6666C7.50003 17.5858 8.24753 18.3333 9.16669 18.3333H10.8334C11.7525 18.3333 12.5 17.5858 12.5 16.6666V16.1683C13.0625 15.935 13.595 15.6225 14.08 15.2425L14.5209 15.4975C15.29 15.9391 16.3525 15.6541 16.7967 14.8883L17.6292 13.4475C18.0892 12.6516 17.8159 11.63 17.02 11.1708L16.5992 10.9275C16.6442 10.6183 16.6667 10.3091 16.6667 9.99996C16.6667 9.69079 16.6442 9.38079 16.5992 9.07413L17.02 8.83079C17.8159 8.37079 18.0892 7.34996 17.6292 6.55413L16.7967 5.11329C16.3542 4.34663 15.29 4.05913 14.5209 4.50329L14.08 4.75829C13.595 4.37746 13.0625 4.06496 12.5 3.83163V3.33329C12.5 2.41413 11.7525 1.66663 10.8334 1.66663H9.16669C8.24753 1.66663 7.50003 2.41413 7.50003 3.33329V3.83163C6.93753 4.06496 6.40503 4.37746 5.92003 4.75746L5.47919 4.50246C4.70919 4.05996 3.64586 4.34663 3.20336 5.11246L2.37086 6.55329C1.91086 7.34913 2.18419 8.37079 2.98003 8.82996L3.40086 9.07329C3.35586 9.38079 3.33336 9.69079 3.33336 9.99996C3.33336 10.3091 3.35586 10.6183 3.40086 10.9258L2.98003 11.1691C2.18419 11.6291 1.91086 12.6508 2.37086 13.4466ZM5.14253 11.1483C5.04836 10.7708 5.00003 10.3841 5.00003 9.99996C5.00003 9.61496 5.04836 9.22829 5.14169 8.85163C5.23169 8.49079 5.07253 8.11413 4.75003 7.92829L3.81419 7.38663L4.64586 5.94579L5.60003 6.49746C5.92003 6.68163 6.32253 6.63496 6.59003 6.37913C7.15919 5.83996 7.84586 5.43663 8.57669 5.21329C8.92753 5.10663 9.16669 4.78246 9.16669 4.41663V3.33329H10.8334V4.41663C10.8334 4.78246 11.0725 5.10663 11.4234 5.21329C12.1542 5.43746 12.8409 5.83996 13.41 6.37913C13.6775 6.63496 14.0817 6.68079 14.4 6.49746L15.3534 5.94663L16.1867 7.38746L15.25 7.92829C14.9275 8.11496 14.7684 8.49163 14.8584 8.85163C14.9517 9.22829 15 9.61496 15 9.99996C15 10.3841 14.9517 10.7708 14.8575 11.1483C14.7684 11.5091 14.9275 11.8858 15.25 12.0716L16.1859 12.6125L15.3542 14.0533L14.4 13.5025C14.0809 13.3183 13.6775 13.3641 13.41 13.6208C12.8409 14.16 12.1542 14.5633 11.4234 14.7866C11.0725 14.8933 10.8334 15.2175 10.8334 15.5833L10.835 16.6666H9.16669V15.5833C9.16669 15.2175 8.92753 14.8933 8.57669 14.7866C7.84586 14.5625 7.15919 14.16 6.59003 13.6208C6.43169 13.4691 6.22503 13.3916 6.01669 13.3916C5.87336 13.3916 5.73003 13.4283 5.60003 13.5033L4.64669 14.055L3.81336 12.6141L4.75003 12.0716C5.07253 11.8858 5.23169 11.5091 5.14253 11.1483Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    )}
                  <button
                    type="button"
                    className="btn wht-bg cross"
                    onClick={this.OpenViewer}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <ScrollContainer
                className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                  } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}
                ref={this.scrollheight}
                hideScrollbars={false}
              >
                {this.state.savedfiles.map((file: any, i: any) => {
                  return (
                    <div
                      className={this.state.bulkSelect ? "footer-enable" : ""}
                    >
                      <div
                        className={
                          currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                        }
                      >
                        {this.state.isAttachmentLoading ? (
                          <div className="d-flex attachment-Viewer-loader justify-content-center">
                            <Spinner
                              className="d-flex"
                              style={{ margin: "auto" }}
                              animation="border"
                              variant="light"
                            />
                          </div>
                        ) : (
                          <div className="nonInvoicePDFViewer">
                            <PDFViewerNonInvoice
                              //ref={childViewerref}
                              ref={this["myRef" + i]}
                              scrollAreaHeight={this.state.scrollAreaHeight}
                              isModalOpen={this["isModalOpen"]}
                              uniqueno={this.state.invoiceUniqueNo}
                              filePreview={
                                file.fileCode
                              } /*this.state.fileSelect*/
                              defaultView={currentView}
                              fileNo={file.fileUniqueno}
                              fileCount={savedfilesCount}
                              fileName={file.name}
                              // docFile={docViewerFiles}
                              docFile={allsavedfiles}
                              updateState={handleUpdate}
                              updateFiles={handleUpdateFiles}
                              showBulkSelect={showBulkSelect}
                              checkBulkSelect={checkBulkSelect}
                              handleFileCheckBox={this["handleFileCheckBox"]}
                              handleUpdatedFile={this["handleUpdatedFile"]}
                              handleincompleteFile={
                                this["handleincompleteFile"]
                              }
                              saveSplitFile={this["saveSplitFile"]}
                              pageType={this.props.pageType}
                              handleRotate={this["handleRotate"]}
                              handlePageRemove={this["handlePageRemove"]}
                              selectedChk={this.state.selectedChk}
                              selectedZoom={this.state.currentZoom}
                              NoDelPermission={NoDelPermission}
                              isEditPermission={
                                this.state.formData.accPeriodstatus
                                  .toString()
                                  .toLowerCase() !== "active" ||
                                  this.state.formData.concilestatus
                                    .toString()
                                    .toLowerCase() === "yes" ||
                                  this.state.isPermission === "No" ||
                                  this.state.isError === "NotEdit"
                                  ? false
                                  : true
                              }
                              fileEtype={file.etype}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                {!this.state.isAttachmentLoading && !hideZoombtn && (
                  <>
                    {currentView === "doc-view" && (
                      <div className="zoom-btn">
                        <ButtonGroup vertical>
                          <Button
                            onClick={(e) => this.handleZoom("zoomIn")}
                            disabled={
                              this.state.currentZoom >= 3.375 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                          <Button
                            onClick={(e) => this.handleZoom("zoomOut")}
                            disabled={
                              this.state.currentZoom <= 0.44 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                  </>
                )}
                {this.state.bulkSelect && (
                  <div className="footer-section d-flex align-items-center">
                    <Form.Check
                      custom
                      type="checkbox"
                      key={"custom-footer"}
                      id={"custom-footer"}
                      label={"No Page Selected"}
                      onChange={(e: any) => this.handleAllCheckbox(e)}
                      ref={this.footerchk}
                    />
                    {!NoDelPermission && (
                      <button
                        type="button"
                        onClick={this.handleBulkRemove}
                        className="btn-outline-primary btn btn-primary"
                      >
                        Remove
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={this.handleBulkRotate}
                      className="btn-outline-primary btn btn-primary mr-auto"
                    >
                      Rotate
                    </button>
                    <button
                      type="button"
                      className="btn wht-bg cross"
                      onClick={this.hideBulkselect}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </ScrollContainer>
            </div>
          )}

          <Container
            id="SlideBody"
            fluid
            className={
              this.state.isStateChanged || this.props.selectedRow?.isDraftUpdate === "Yes"
                ? "body-sec viewer-panel register-transaction-slideout"
                : "body-sec viewer-panel footer-disable register-transaction-slideout"
            }
            ref={this.parentScroll}
          >
            <div className="page-heading pos-sticky underline d-flex">
              <div className="hid-set d-flex align-items-center">
                {this.state.hotelName}
              </div>
              <div className="mr-auto d-flex align-items-center">
                {this.props.pageType === "payment"
                  ? "Withdrawal"
                  : this.props.pageType}
                {this.state.showBadge && (
                  <>
                    {this.state.showBadge && (
                      <>
                        {this.state.formData.concilestatus
                          .toString()
                          .toLowerCase() === "yes" ? (
                          <Badge className="badge ml-2">Reconciled </Badge>
                        ) : (
                          <Badge className="badge ml-2">Unreconciled </Badge>
                        )}
                        {this.state.formData.accPeriodstatus
                          .toString()
                          .toLowerCase() !== "active" && (
                            <img
                              className="ml-2"
                              src={MasterRoleLock}
                              alt="ScheduleLock"
                            />
                          )}
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="action-group d-flex">
                {!this.state.isReconcilePage && !this.props.isBankSyncPage && this.props?.callFrom !== "Draft"  && (
                  <>
                    {(this.props.uniqueNo === 0 ||
                      this.state.formData.actionType === "copy") && (
                        <div
                          className={
                            this.state.isPermission === "No"
                              ? "disabled-area"
                              : ""
                          }
                        >
                          {this.state.selectedpaymentType === "Check" &&
                            this.state.formData.entryType === "Misc" ? (
                            <></>
                          ) : (
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              label="Repeating"
                              checked={this.state.isRepeat}
                              onChange={(event: any) =>
                                this.handleChange(event, "repeat")
                              }
                            />
                          )}
                        </div>
                      )}

                    {this.props.isFromRepeating && (
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label="Repeating"
                        checked={true}
                        disabled={true}
                      />
                    )}
                  </>
                )}

                {this.state.formData.uniqueno > 0 &&
                  btnlist &&
                  !this.props?.isFromRepeating ? (
                  <Dropdown
                    className="more-action"
                    alignRight
                    onSelect={(event: any) => this.handleAction(event)}
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>

                      {this.renderFlagDropdownItems()}
                      {!(this.state.formData.entryType === "payment") && (
                        <Dropdown.Item eventKey={"changeLog"} key={"changeLog"}>
                          {" "}
                          {"Change Log"}
                        </Dropdown.Item>
                      )}
                      {this.state.isPermission === "Yes" &&
                        this.state.formData.actionType === "" &&
                        this.state.formData.vendorStatus
                          .toString()
                          .toLowerCase() === "active" &&
                        (this.state.formData.entryType !== "payment" && this.props.selectedRow?.isDraftUpdate !== "Yes") && (
                          <Dropdown.Item eventKey={"copy"} key={"copy"}>
                            {" "}
                            {"Copy"}
                          </Dropdown.Item>
                        )}
                      {this.state.isDeletePermission === "Yes" &&
                        this.state.formData.accPeriodstatus
                          .toString()
                          .toLowerCase() === "active" &&
                        this.state.formData.concilestatus
                          .toString()
                          .toLowerCase() !== "yes" &&
                        this.state.formData.actionType === "" && (
                          <Dropdown.Item
                            className={
                              this.state.isError === "NotEdit" ? "isHide" : ""
                            }
                            eventKey={"delete"}
                            key={"delete"}
                          >
                            {" "}
                            {"Delete"}
                          </Dropdown.Item>
                        )}
                      {this.state.formData.accPeriodstatus
                        .toString()
                        .toLowerCase() === "active" &&
                        this.state.formData.concilestatus
                          .toString()
                          .toLowerCase() === "no" &&
                        this.state.isPermission === "Yes" &&
                        this.state.formData.vendorStatus
                          .toString()
                          .toLowerCase() === "active" &&
                        (this.state.formData.entryType !== "payment" &&  this.props.selectedRow?.isDraftUpdate !== "Yes") &&
                        (this.state.formData.actionType === "move" ||
                          this.state.formData.actionType === "") &&
                        this.state.movePaymentType !== "Check" && (
                          <Dropdown.Item
                            className={
                              this.state.isError === "NotEdit" ? "isHide" : ""
                            }
                            eventKey={"move"}
                            key={"move"}
                          >
                            {" "}
                            {"Move"}
                          </Dropdown.Item>
                        )}

                      {this.state.formData.entryType === "payment" &&
                        (this.state.associatedPaymentEtype
                          .toString()
                          .toLowerCase()
                          .includes("ach") ||
                          this.state.associatedPaymentEtype
                            .toString()
                            .toLowerCase() ===
                          "Credit Card".toString().toLowerCase()) &&
                        this.state.isCreditcardPayment === "No" &&
                        this.state.formData.adj !== "Y" &&
                        this.state.voidConcile.toLowerCase() === "no" &&
                        this.state.isMovePermission.toLowerCase() === "yes" &&
                        this.state.formData.checkNo.toString().toLowerCase() !==
                        "epay" && (
                          <Dropdown.Item
                            className={""}
                            eventKey={"invoicemove"}
                            key={"invoicemove"}
                          >
                            {" "}
                            {"Move"}
                          </Dropdown.Item>
                        )}

                      {this.state.formData.checkNo.toString().toLowerCase() ===
                        "epay" &&
                        this.state.epayCheckNo !== "" && (
                          <Dropdown.Item
                            eventKey={"epayCheckImage"}
                            key={"epayCheckImage"}
                          >
                            {" "}
                            {"View Check Image"}
                          </Dropdown.Item>
                        )}

                      {this.props.pageType === "payment" &&
                        (!this.state.formData.checkNo
                          .toString()
                          .toLowerCase()
                          .includes("ach") ||
                          !this.state.formData.checkNo
                            .toString()
                            .toLowerCase()
                            .includes("credit card") ||
                          !this.state.formData.checkNo
                            .toString()
                            .toLowerCase()
                            .includes("pay")) &&
                        this.state.formData.adj !== "Y" && (
                          <>
                            {this.state.printStatus == "Yes" && (
                              <Dropdown.Item
                                eventKey={"downloadCopy"}
                                key={"downloadCopy"}
                              >
                                {" "}
                                {"Download Copy"}
                              </Dropdown.Item>
                            )}

                            {this.state.rePrintOldCheck === "Yes" &&
                              this.state.printStatus == "Yes" &&
                              this.state.voidConcile != "Yes" && (
                                <Dropdown.Item
                                  eventKey={"reprint"}
                                  key={"reprint"}
                                >
                                  {" "}
                                  {"Reprint"}
                                </Dropdown.Item>
                              )}
                          </>
                        )}

                      {this.props.pageType === "payment" &&
                        !this.state.formData.checkNo
                          .toString()
                          .toLowerCase()
                          .includes("pay") &&
                        this.state.formData.adj !== "Y" && (
                          <>
                            {this.state.isPermission === "Yes" &&
                              this.state.formData.adj !== "Y" &&
                              this.state.voidConcile === "no" && (
                                <Dropdown.Item
                                  className={
                                    this.state.isError === "NotEdit"
                                      ? "isHide"
                                      : ""
                                  }
                                  eventKey={"void"}
                                  key={"void"}
                                >
                                  {" "}
                                  {"Void"}
                                </Dropdown.Item>
                              )}
                          </>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : this.props?.isFromRepeating && this.props?.pageType !== "payment" ? (
                  <Dropdown
                    className="more-action"
                    alignRight
                    onSelect={(event: any) => this.handleAction(event)}
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>

                      {this.renderFlagDropdownItems()}
                      {this.state.isDeletePermission ===
                        "Yes" /*&& this.state.formData.accPeriodstatus.toString().toLowerCase() === "active"*/ &&
                        this.state.formData.concilestatus
                          .toString()
                          .toLowerCase() !== "yes" &&
                        this.state.formData.actionType === "" && (
                          <Dropdown.Item
                            className={
                              this.state.isError === "NotEdit" ? "isHide" : ""
                            }
                            eventKey={"delete"}
                            key={"delete"}
                          >
                            {" "}
                            {"Delete"}
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (((Number(this.state.formData.vendorID) > 0 && this.state.selectedReviewStatus != "Flag for Review")) || (this.state.selectedReviewStatus != "Flag for Review" && this.props?.callFrom == "Draft")) && this.props?.pageType !== "payment" ? (
                  <Dropdown
                    className="more-action"
                    alignRight
                    onSelect={(event: any) => this.handleAction(event)}
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>

                      {this.renderFlagDropdownItems()}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : <></>}

                <button
                  type="button"
                  className="btn wht-bg cross"
                  onClick={this.hideSlideOut}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                      fill="#84888C"
                    />
                  </svg>
                </button>
              </div>
            </div>


            {this.renderTopBannerWithDropdown()}
            <div className="parent">
              <div className="filter-sec">
                <div className="vendor-type-sec d-flex">
                  <div className="d-flex flex-wrap mr-auto">
                    <Form.Group controlId="vendorName">
                      <div
                        className={
                          this.state.isPermission === "No" ||
                            this.state.isError === "NotEdit"
                            ? "parent"
                            : ""
                        }
                      >
                        <Form.Label
                          className={
                            this.state.formData.accPeriodstatus
                              .toString()
                              .toLowerCase() !== "active" ||
                              this.state.formData.concilestatus
                                .toString()
                                .toLowerCase() === "yes"
                              ? "disabled-area"
                              : ""
                          }
                        >
                          Vendor
                        </Form.Label>
                        <div
                          tabIndex={this.state.tabEnable}
                          /*className={(this.state.formData.accPeriodstatus.toString().toLowerCase() !== "active"
                                                    || this.state.formData.concilestatus.toString().toLowerCase() === "yes") ? "type-head" : "type-head"}*/
                          className={`${iSePayEntry && isStatusPaidSent && isePayMethod
                            ? "setVendorW2"
                            : ""
                            } type-head`}
                        >
                          <>
                            {this.state.isvendorShow &&
                              this.state.formData.entryType !== "payment" && (
                                <VendorSearch
                                  ref={this.vendorSearch}
                                  updateVendorList={this.updateVendorList}
                                  HID={this.state.hotelValue}
                                  handleVendorChange={this.handleVendorChange}
                                  pageName={this.pageName}
                                  entryType={this.entryType}
                                  disabled={
                                    this.props?.isFromRepeating
                                      ? this.props?.isFromRepeating
                                      : isVendorDisabled
                                  }
                                />
                              )}
                          </>

                          {this.state.formData.entryType === "payment" && (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip id={"VendorName"}>
                                  {`${this.state.formData.vendorName} (${this.state.formData.vendorContract})`}
                                </Tooltip>
                              }
                            >
                              <Form.Control
                                disabled={true}
                                type="text"
                                value={`${this.state.formData.vendorName} (${this.state.formData.vendorContract})`}
                                autoComplete="off"
                              />
                            </OverlayTrigger>
                          )}
                        </div>
                      </div>
                      {this.state.formData.vendorID > 0 &&
                        this.props.pageType !== "payment" && (
                          <div
                            className="transactionsLinks"
                            onClick={this.Previoustransactions}
                          >
                            {this.state.isPreviousTransactions
                              ? "Hide Previous Transactions"
                              : "Previous Transactions"}
                          </div>
                        )}
                    </Form.Group>

                    <div
                      // className={
                      //   this.state.formData.vendorID === 0 ||
                      //     this.state.isPermission === "No" ||
                      //     this.state.isError === "NotEdit"
                      //     ? "mr-auto d-flex disabled-area"
                      //     : "mr-auto d-flex"
                      // }
                      className={`mr-auto d-flex 
                      ${this.state.isPermission === "No" || this.state.isError === "NotEdit" ? "disabled-area" : ""}
                      ${(this.state.formData.vendorID === 0 && this.props?.callFrom !== "Draft") ? "disabled-area" : ""}
                      `}
                    >
                      <div className="d-flex">
                        <div>
                          {this.state.formData.actionType === "copy" ? (
                            <>
                              {/* {this.state.accountlist.length > 0 && ( */}
                              <Form.Group controlId="amount">
                                <Form.Label>Account</Form.Label>
                                <div className="single-select type w-200">
                                  <SingleDropdownListWithoutSearch
                                    id={"accoutlist"}
                                    itemList={this.state.accountlist}
                                    handleSelectedItem={this.handleCopyaccountName.bind(
                                      this
                                    )}
                                    defaultItem={this.state.defaultaccountType}
                                    defaultText={this.state.accountName}
                                    defaultName={this.state.defaultaccountType}
                                    controlID="7"
                                  />
                                </div>
                              </Form.Group>
                              {/* )} */}
                            </>
                          ) : (
                            <>
                              <Form.Group controlId="amount">
                                <Form.Label>Account</Form.Label>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip id={"accountName"}>
                                      {this.state.accountName}
                                    </Tooltip>
                                  }
                                >
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Account Name"
                                    className="account-name"
                                    value={this.state.accountName}
                                    autoComplete="off"
                                    disabled
                                  />
                                </OverlayTrigger>
                              </Form.Group>
                            </>
                          )}
                        </div>
                        {(this.state.formData.entryType === "Misc" ||
                          this.state.formData.entryType === "Withdrawal") && (
                            <Form.Group controlId="type">
                              <Form.Label>Type</Form.Label>
                              <div
                                className={
                                  this.state.formData.accPeriodstatus
                                    .toString()
                                    .toLowerCase() !== "active" ||
                                    this.state.formData.concilestatus
                                      .toString()
                                      .toLowerCase() === "yes" ||
                                    this.props?.isFromRepeating
                                    ? "single-select type  disabled-area"
                                    : "single-select type"
                                }
                              >
                                {/* // paymentTypeWithdrawal */}
                                {this.state.paymentType.length > 0 &&
                                  !this.state.isReconcilePage &&
                                  !this.props.isBankSyncPage &&
                                  (this.state.formData.entryType === "Misc" ||
                                    this.state.formData.entryType ===
                                    "MiscDeposit") && (
                                    <SingleDropdownListWithoutSearch
                                      //tabIndex={this.state.tabEnable}
                                      id={"paymentType"}
                                      itemList={this.state.paymentType}
                                      handleSelectedItem={this.handleSelectedItem.bind(
                                        this,
                                        5 + "_" + 0
                                      )}
                                      defaultItem={this.state.defaultpaymentType}
                                      defaultText={"Type"}
                                      defaultName={this.state.defaultpaymentType}
                                      controlID="5"
                                    />
                                  )}

                                {this.state.paymentType.length > 0 &&
                                  (this.state.isReconcilePage ||
                                    this.props.isBankSyncPage) &&
                                  (this.state.formData.entryType === "Misc" ||
                                    this.state.formData.entryType ===
                                    "MiscDeposit") && (
                                    <Form.Control
                                      className="account-type"
                                      type="text"
                                      value={this.state.formData.paymenttype}
                                      autoComplete="off"
                                      disabled
                                    />
                                  )}

                                {this.state.paymentTypeWithdrawal.length > 0 &&
                                  this.state.formData.entryType ===
                                  "Withdrawal" && (
                                    // <SingleDropdownListWithoutSearch
                                    //     id={"paymentType"}
                                    //     itemList={this.state.paymentTypeWithdrawal}
                                    //     handleSelectedItem={this.handleSelectedItem.bind(
                                    //         this, 5 + '_' + 0)}
                                    //     defaultItem={this.state.defaultpaymentType}
                                    //     defaultText={"Type"}
                                    //     defaultName={this.state.defaultpaymentType}
                                    //     controlID="5"

                                    // />
                                    <Form.Control
                                      className="account-type"
                                      type="text"
                                      value={this.state.formData.paymenttype}
                                      autoComplete="off"
                                      disabled
                                    />
                                  )}
                              </div>
                            </Form.Group>
                          )}
                        {this.state.formData.entryType === "Misc" &&
                          this.state.formData.paymenttype === "Check" && (
                            <Form.Group controlId="check">
                              <Form.Label>{"Check"}</Form.Label>
                              <Form.Control
                                tabIndex={this.state.tabEnable}
                                type="text"
                                placeholder="Enter Check Number"
                                value={this.state.formData.checkNo}
                                maxLength={10}
                                onChange={(event: any) =>
                                  this.handleChange(event, "check")
                                }
                                className={
                                  this.state.formData.accPeriodstatus
                                    .toString()
                                    .toLowerCase() !== "active" ||
                                    this.state.formData.concilestatus
                                      .toString()
                                      .toLowerCase() === "yes"
                                    ? "disabled-area"
                                    : ""
                                }
                                autoComplete="off"
                              />
                            </Form.Group>
                          )}

                        {this.state.formData.entryType === "payment" && (
                          <Form.Group
                            className={`${iSePayEntry && isStatusPaidSent && isePayMethod
                              ? "mr-1"
                              : ""
                              }`}
                            controlId="check"
                          >
                            <Form.Label>{"Type"}</Form.Label>
                            {(this.state.formData.checkNo
                              .toString()
                              .toLowerCase()
                              .includes("check") ||
                              this.state.formData.checkNo
                                .toString()
                                .toLowerCase() == "epay") && (
                                <>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Check Number"
                                    className="check-number"
                                    value={
                                      iSePayEntry &&
                                        isStatusPaidSent &&
                                        isePayMethod
                                        ? this.state.formData.checkNo +
                                        " - " +
                                        this.state.ePayMethod
                                        : this.state.formData.checkNo
                                    }
                                    disabled
                                  />
                                  {iSePayEntry &&
                                    isStatusPaidSent &&
                                    isePayMethod && (
                                      <div className="forPaymentSent forPaymentSentW">
                                        Payment Sent: {this.state.paymentSentDT}
                                      </div>
                                    )}
                                </>
                              )}
                            {!this.state.formData.checkNo.includes("Check") &&
                              this.state.formData.checkNo.toLowerCase() !==
                              "epay" && (
                                <div className="single-select type">
                                  {this.state.paymentTypelist.length > 0 && (
                                    <SingleDropdownListWithoutSearch
                                      id={"paymentType"}
                                      itemList={this.state.paymentTypelist}
                                      handleSelectedItem={this.handleSelectedItem.bind(
                                        this,
                                        5 + "_" + 0
                                      )}
                                      defaultItem={
                                        this.state.defaultpaymentType.toLowerCase() ===
                                          "m-ach"
                                          ? "ACH"
                                          : this.state.defaultpaymentType
                                      }
                                      defaultText={"Type"}
                                      defaultName={
                                        this.state.defaultpaymentType.toLowerCase() ===
                                          "m-ach"
                                          ? "Manual ACH"
                                          : this.state.defaultpaymentType
                                      }
                                      controlID="5"
                                      disabled={
                                        this.state.isCreditcardPayment ===
                                          "Yes" ||
                                          this.state.isApprove === "No" ||
                                          this.state.formData.adj === "Y" ||
                                          this.state.voidConcile.toLowerCase() ===
                                          "yes"
                                          ? true
                                          : false
                                      }
                                    />
                                  )}
                                </div>
                              )}
                          </Form.Group>
                        )}

                        {/* <Form.Group controlId="totalAmt">
                                                <Form.Label>Total Amount</Form.Label>
                                                <div className="single-select type w-200">
                                                    <Form.Control type="text" placeholder="Enter Total Amount" id="txttotalAmt"
                                                        value={this.state.formData.transactionTotal}
                                                        onChange={(event: any) => this.handleChange(event, 'totalAmt')}
                                                        pattern="[+-]?\d+(?:[.,]\d+)?"
                                                        maxLength={12}


                                                    />
                                                </div>
                                            </Form.Group> */}
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      (this.state.formData.vendorID === 0 || this.props?.callFrom == "Draft" )||
                      this.state.isPermission === "No" ||
                        this.state.isError === "NotEdit"
                        ? "disabled-area"
                        : this.state.formData.accPeriodstatus
                          .toString()
                          .toLowerCase() !== "active" ||
                          this.state.formData.concilestatus
                            .toString()
                            .toLowerCase() !== "no"
                          ? "disabled-area"
                          : ""
                    }
                  >
                    {this.state.formData.entryType !== "payment" && (
                      <div className="total-amount inpute">
                        <Form.Group controlId="totalAmt">
                          {/* <Form.Label>Total Amount</Form.Label> */}
                          <div className="single-select">
                            <div className="label margin-Bottom">Amount</div>
                            <Form.Control
                              type="text"
                              placeholder="0.00"
                              id="txttotalAmt"
                              value={this.state.formData.transactionTotal}
                              onChange={(event: any) =>
                                this.handleChange(event, "totalAmt")
                              }
                              onBlur={this.handleTotalAmount}
                              onFocus={this.onAmountFocus}
                              pattern="[+-]?\d+(?:[.,]\d+)?"
                              maxLength={20}
                              autoComplete="off"
                              title=""
                              disabled={
                                this.props?.accDetails?.isNewTransBankSync
                              }
                            />
                          </div>
                        </Form.Group>
                      </div>
                    )}
                    {this.state.formData.entryType === "payment" && (
                      // <div className="total-amount inpute">
                      //     <div className="label margin-Bottom">Amount</div>
                      //      <div className="amount"> {this.state.totalAmount} </div>
                      // </div>

                      <div className="total-amount inpute">
                        <Form.Group controlId="totalAmt">
                          {/* <Form.Label>Total Amount</Form.Label> */}
                          <div className="single-select">
                            <div className="label margin-Bottom">Amount</div>
                            <Form.Control
                              type="text"
                              value={this.state.totalAmount}
                              disabled={true}
                            />
                          </div>
                        </Form.Group>
                      </div>
                    )}
                  </div>
                </div>
                {this.state.isPreviousTransactions && (
                  <div className="PreviousTransactions">
                    <BootstrapTable
                      keyField="uniqueNo"
                      data={this.state.previousTransactionsData.filter(
                        (x) =>
                          x.mainType === 1 &&
                          x.uniqueNo !=
                          (this.state.formData.actionType === "copy"
                            ? 0
                            : this.state.formData.uniqueno)
                      )}
                      columns={previousTransactionsColumns}
                      expandRow={expandSplitRow}
                    />
                    <button
                      type="button"
                      className="btn wht-bg link-btn"
                      onClick={this.loadPreviousData}
                    >
                      Show More
                    </button>
                  </div>
                )}
                {!this.state.isRepeat && (
                  <div
                    className={
                      this.state.isPermission === "No" ||
                        this.state.isError === "NotEdit"
                        ? "disabled-area"
                        : ""
                    }
                  >
                    <div
                      className={
                        (this.state.formData.vendorID === 0 || this.props?.callFrom === "Draft")
                          ? "mr-auto d-flex disabled-area"
                          : this.state.formData.accPeriodstatus
                              .toString()
                              .toLowerCase() === "active"
                          ? "mr-auto d-flex"
                          : "mr-auto d-flex disabled-area"
                      }
                    >
                      {this.state.formData.entryType !== "payment" && (
                        <Form.Group
                          className="rm-bottom-margin"
                          controlId="vendorName"
                        >
                          <Form.Label>Accounting Period</Form.Label>                          
                          <div className="single-select">
                            {this.state.accPeriodList.length > 0 && (
                              <SingleDropdownListWithoutSearch
                                id={"accountingPeriod"}
                                itemList={this.state.accPeriodList}
                                handleSelectedItem={this.handleSelectedItem.bind(
                                  this,
                                  6 + "_" + 0
                                )}
                                defaultItem={this.state.defaultaccountingPeriod}
                                defaultText={"Accouting Period"}
                                defaultName={this.state.defaultaccountingPeriod}
                                controlID="6"
                                disabled={                                 
                                  this.state.isPermission === "No" ||
                                    this.state.isError === "NotEdit" ||
                                    this.state.formData.accPeriodstatus
                                      .toString()
                                      .toLowerCase() !== "active"
                                    ? true
                                    : false
                                }
                              />
                            )}
                            {this.state.accPeriodList.length === 0 && (
                              <SingleDropdownListWithoutSearch
                                id={"accountingPeriod"}
                                itemList={this.state.accPeriodList}
                                handleSelectedItem={this.handleSelectedItem.bind(
                                  this,
                                  6 + "_" + 0
                                )}
                                defaultItem={this.state.defaultaccountingPeriod}
                                defaultText={"Accouting Period"}
                                defaultName={this.state.defaultaccountingPeriod}
                                controlID="6"
                              />
                            )}
                          </div>
                        </Form.Group>
                      )}
                      {this.state.formData.checkNo.toString().toLowerCase() ===
                        "epay" &&
                        this.state.epayCheckNo !== "" && (
                          <Form.Group controlId="epayCheckNo">
                            <Form.Label>{"ePay Check Number"}</Form.Label>
                            <Form.Control
                              type="text"
                              value={this.state.epayCheckNo}
                              disabled={true}
                              autoComplete="off"
                            />
                          </Form.Group>
                        )}
                      <div
                        className={
                          this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() === "active" &&
                            this.state.formData.concilestatus
                              .toString()
                              .toLowerCase() === "no"
                            ? "mr-auto d-flex"
                            : "mr-auto d-flex disabled-area"
                        }
                      >
                        <Form.Group
                          className="rm-bottom-margin"
                          controlId="amount"
                        >
                          <Form.Label>Transaction Date</Form.Label>
                          <div className="date-picker calender-picker">
                            <div
                              className="drop-arrow"
                              onClick={(event: any) =>
                                this.handleDatePicker(event, this.trdate)
                              }
                            >
                              <svg
                                width="8"
                                height="6"
                                viewBox="0 0 8 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                  fill="#3F4347"
                                />
                              </svg>
                            </div>
                            {this.state.formData.entryType !== "payment" && (
                              <>
                                {(this.state.isReconcilePage ||
                                  this.props.isBankSyncPage) &&
                                  this.props.uniqueNo === 0 ? (
                                  <DatePicker
                                    id="trdate"
                                    ref={this.trdate}
                                    tabIndex={this.state.tabEnable}
                                    className="form-control"
                                    placeholderText={"MM/DD/YY"}
                                    dateFormat="MM/dd/yy"
                                    highlightDates={
                                      this.state.formData.transcationDate ===
                                      null && highlightDates
                                    }
                                    selected={
                                      this.state.formData.transcationDate ===
                                        null
                                        ? ""
                                        : new Date(
                                          this.state.formData.transcationDate
                                        )
                                    }
                                    onChange={(event: any) =>
                                      this.handleChange(event, "trDate")
                                    }
                                    onKeyDown={(e: any) =>
                                      this.onTAB("trdate-1", e)
                                    }
                                    maxDate={
                                      new Date(
                                        new Date(
                                          this.props.accper
                                        ).getFullYear(),
                                        new Date(this.props.accper).getMonth() +
                                        1,
                                        0
                                      )
                                    }
                                    autoComplete="off"
                                  />
                                ) : (
                                  <DatePicker
                                    id="trdate"
                                    ref={this.trdate}
                                    tabIndex={this.state.tabEnable}
                                    className="form-control"
                                    placeholderText={"MM/DD/YY"}
                                    dateFormat="MM/dd/yy"
                                    highlightDates={
                                      this.state.formData.transcationDate ===
                                      null && highlightDates
                                    }
                                    selected={
                                      this.state.formData.transcationDate ===
                                        null
                                        ? ""
                                        : new Date(
                                          this.state.formData.transcationDate
                                        )
                                    }
                                    onChange={(event: any) =>
                                      this.handleChange(event, "trDate")
                                    }
                                    onKeyDown={(e: any) =>
                                      this.onTAB("trdate-1", e)
                                    }
                                    autoComplete="off"
                                  />
                                )}
                              </>
                            )}
                            {this.state.formData.entryType === "payment" && (
                              <DatePicker
                                id="trdate1"
                                className="form-control"
                                placeholderText={"MM/DD/YY"}
                                dateFormat="MM/dd/yy"
                                selected={
                                  this.state.formData.transcationDate === null
                                    ? ""
                                    : new Date(
                                      this.state.formData.transcationDate
                                    )
                                }
                                onChange={(event: any) =>
                                  this.handleChange(event, "trDate")
                                }
                                onKeyDown={(e: any) =>
                                  this.onTAB("trdate-1", e)
                                }
                                autoComplete="off"
                                disabled={
                                  !(
                                    (this.state.associatedPaymentEtype
                                      .toString()
                                      .toLowerCase()
                                      .includes("ach") ||
                                      this.state.associatedPaymentEtype
                                        .toString()
                                        .toLowerCase() ===
                                      "Credit Card"
                                        .toString()
                                        .toLowerCase()) &&
                                    this.state.voidConcile
                                      .toString()
                                      .toLowerCase() !== "yes" &&
                                    this.state.formData.adj !== "Y"
                                  ) ||
                                  this.state.formData?.paymenttype
                                    .toString()
                                    .toLowerCase() === "epay"
                                }
                              />
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                )}
                {this.state.isRepeat && (
                  <div
                    className={
                      this.state.isPermission === "No" ||
                        this.state.isError === "NotEdit"
                        ? "disabled-area"
                        : ""
                    }
                  >
                    <div
                      className={
                        this.state.formData.vendorID === 0
                          ? "d-flex disabled-area"
                          : this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() !== "active" ||
                            this.state.formData.concilestatus
                              .toString()
                              .toLowerCase() === "yes"
                            ? "d-flex disabled-area"
                            : "d-flex"
                      }
                    >
                      <Form.Group
                        className="rm-bottom-margin"
                        controlId="vendorName"
                      >
                        <Form.Label>Repeat</Form.Label>
                        {/* <div className="single-select">
                          <Form.Control
                            type="text"
                            tabIndex={this.state.tabEnable}
                            placeholder="Enter Account Name"
                            value={"Monthly"}
                            autoComplete="off"
                            disabled
                          />
                        </div> */}
                        <div className="single-select">
                          <Dropdown className="more-action bg-blue single-select-image repeat">
                            <Dropdown.Toggle variant="success" id="dropdown-basic" className="filter-btn">
                              <div className="d-flex align-items-center">
                                <div className="txt-area">
                                  <EllipsisWithTooltip placement="bottom">
                                    {this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase()).length > 0 ?
                                      this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase())[0].displayName : "Select"}
                                  </EllipsisWithTooltip>
                                </div>
                                <div className="drop-arrow ml-auto">
                                  <FiChevronDown />
                                </div>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {this.state.repeatList.map(
                                (item: any, idx: any) => (
                                  <Dropdown.Item
                                    eventKey={item.displayName}
                                    onClick={() => this.onSelectRepeatType(item)}
                                  >
                                    <EllipsisWithTooltip placement="bottom">
                                      {item.displayName}
                                    </EllipsisWithTooltip>
                                  </Dropdown.Item>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Form.Group>
                      <Form.Group
                        className="rm-bottom-margin"
                        controlId="amount"
                      >
                        <Form.Label>Transaction Date</Form.Label>
                        <div className="date-picker calender-picker">
                          <div
                            className="drop-arrow"
                            onClick={(event: any) =>
                              this.handleDatePicker(event, this.trdate1)
                            }
                          >
                            <svg
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                fill="#3F4347"
                              />
                            </svg>
                          </div>
                          <DatePicker
                            id="trdate"
                            ref={this.trdate1}
                            tabIndex={this.state.tabEnable}
                            className="form-control"
                            placeholderText={"MM/DD/YY"}
                            dateFormat="MM/dd/yy"
                            selected={
                              this.state.formData.transcationDate === null
                                ? ""
                                : new Date(this.state.formData.transcationDate)
                            }
                            onChange={(event: any) =>
                              this.handleChange(event, "trDate")
                            }
                            onKeyDown={(e: any) => this.onTAB("trdate1-1", e)}
                            autoComplete="off"
                          />
                        </div>
                      </Form.Group>
                      <Form.Group
                        className="rm-bottom-margin"
                        controlId="amount"
                      >
                        <Form.Label>End Date</Form.Label>
                        <div className="date-picker calender-picker">
                          <div
                            className="drop-arrow"
                            onClick={(event: any) =>
                              this.handleDatePicker(event, this.trenddate)
                            }
                          >
                            <svg
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                fill="#3F4347"
                              />
                            </svg>
                          </div>
                          <DatePicker
                            id="trenddate"
                            ref={this.trenddate}
                            tabIndex={this.state.tabEnable}
                            className="form-control"
                            placeholderText={"none"}
                            dateFormat="MM/dd/yy"
                            selected={
                              this.state.formData.endDate === null
                                ? ""
                                : new Date(this.state.formData.endDate)
                            }
                            onBlur={(event) =>
                              this.endDatefocousOut(event.target.value)
                            }
                            onChange={(event: any) =>
                              this.handleChange(event, "endDate")
                            }
                            onKeyDown={(e: any) => this.onTAB("trenddate-1", e)}
                            autoComplete="off"
                          />
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                )}
                <div
                  className={
                    this.state.isPermission === "No" ||                      
                      this.state.isError === "NotEdit"
                      ? "disabled-area notes-section"
                      : "notes-section"
                  }
                >
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      id="txtNotes"
                      as="textarea"
                      wrap="hard"
                      rows={3}
                      value={this.state.formData.internalNotes}
                      maxLength={99}
                      onChange={(event: any) =>
                        this.handleChange(event, "notes")
                      }
                      onKeyDown={(e: any) => this.onTAB("txtNotes-1", e)}
                      autoComplete="off"
                    />
                  </Form.Group>
                </div>
              </div>
              <div
                className={
                  (this.state.formData.vendorID === 0 && this.props?.callFrom !== "Draft") ? "disabled-area" : ""
                }
              >
                {this.state.formData.entryType === "payment" && (
                  <div className={"transactions-list associated-invoices"}>
                    <div className="sec-ttl">Associated Invoice</div>
                    <BootstrapTable
                      keyField="id"
                      data={this.state.associatedPayment.filter(
                        (x) => x.viewType === 1
                      )}
                      columns={associatedInvoicesColumns}
                      expandRow={expandAssociatedInvoiceRow}
                      rowEvents={this.rowEvents}
                    />
                  </div>
                )}
                {this.state.formData.entryType !== "payment" && (
                  <div
                    className={
                      this.state.isPermission === "No" ||
                        this.state.isError === "NotEdit"
                        ? "disabled-area transactions-list inpute"
                        : "transactions-list inpute"
                    }
                  >
                    {this.state.transactionsColumns.length > 0 && (
                      <BootstrapTable
                        id="tblSplit"
                        keyField="rno"
                        data={this.state.splitData}
                        columns={this.state.transactionsColumns}
                      />
                    )}
                    <div className="d-flex action-btn align-items-center">
                      <button
                        type="button"
                        className="btn wht-bg link-btn mr-auto"
                        onClick={this.handleNewRow}
                        disabled={
                          this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() === "active"
                            ? false
                            : this.state.formData.vendorID === 0
                              ? false
                              : true
                        }
                      >
                        Add Row
                      </button>
                      {/* <button type="button" className="btn wht-bg link-btn mr-auto">Clear All</button> */}
                      <div className="total-amount">
                        Total: {this.state.totalAmount}
                        {this.state.isAmountDiff === "Yes" && (
                          <span className="text-danger">
                            {" "}
                            {`(${this.state.totalAmountdiff})`}
                          </span>
                        )}
                      </div>
                      {/* <div className="total-amount">diff: {Utils.amountFormatted(this.state.totalAmountdiff)}</div> */}
                    </div>
                  </div>
                )}
              </div>
              <div className="filter-sec upload-section">
                {/* <Form.Group controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Notes</Form.Label>
                                    <Form.Control className={this.state.isPermission === "No" ? "form-control" : "form-control"} id="txtNotes" as="textarea" wrap="hard" rows={3} value={this.state.formData.internalNotes}
                                        maxLength={99} onChange={(event: any) => this.handleChange(event, 'notes')}
                                        onKeyDown={(e: any) => this.onTAB('txtNotes-1', e)}
                                    />
                                </Form.Group> */}

                {/* {!this.state.isRepeat && ()} */}
                {this.props.pageFrom !== undefined &&
                  this.props.pageFrom === "repeatingPage" ? (
                  <></>
                ) : (
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <div className="d-flex">
                      <Form.Label className="mr-auto">Attachments</Form.Label>
                      {/* <div className={this.state.formData.actionType === "copy" ? "d-none" : ""}> */}
                      {this.state.savedfiles.length > 0 && (
                        <div className="upload-link">
                          <button
                            type="button"
                            className="btn wht-bg link-btn mr-auto"
                            onClick={this.OpenViewer}
                          >
                            {this.state.isOpenViewer
                              ? "Close Viewer"
                              : "Open Viewer"}
                          </button>
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                    <Dropzone
                      onDrop={this.onDrop}
                    //accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                    >
                      {({
                        getRootProps,
                        getInputProps,
                        isDragActive,
                        isDragReject,
                      }) => (
                        <section
                          className={
                            isDragActive
                              ? "container upload-area default drag-active "
                              : "container upload-area default"
                          }
                        >
                          {/* <div className={this.state.formData.vendorID === 0 || this.state.isPermission === "No" || this.state.isError === "NotEdit" ? "disabled-area" : ""}> */}

                          <div
                            id="droparea"
                            onKeyDown={(event: any) =>
                              this.handleKeyDown(event, "droparea")
                            }
                            {...getRootProps({
                              className: "dropzone d-flex align-items-center",
                              onClick:
                                this.state.newSelectedfiles.length > 0 ||
                                  this.state.savedfiles.length > 0
                                  ? (event) => event.stopPropagation()
                                  : (event) => event,
                            })}
                          >
                            <input {...getInputProps()} />
                            {this.state.newSelectedfiles.length < 1 &&
                              this.state.savedfiles.length < 1 && (
                                <p>
                                  Drag and drop Document or{" "}
                                  <span>browse files</span> to upload.
                                </p>
                              )}
                            {(this.state.newSelectedfiles.length > 0 ||
                              this.state.savedfiles.length > 0) &&
                              isDragActive && (
                                <p>Drag and drop Document here to upload.</p>
                              )}
                          </div>

                          {/* </div> */}

                          {(this.state.newSelectedfiles.length > 0 ||
                            this.state.savedfiles.length > 0) && (
                              <aside className="d-flex flex-column file-area">
                                <ul>{files}</ul>
                                <ul>{files1}</ul>
                              </aside>
                            )}
                        </section>
                      )}
                    </Dropzone>
                    <div className="d-flex">
                      {(this.state.newSelectedfiles.length > 0 ||
                        this.state.savedfiles.length > 0) && (
                          // <div className={this.state.isPermission === "No" || this.state.isError === "NotEdit" ? "upload-link mt-2 disabled-area addAttachmentButton" : "mt-2 upload-link addAttachmentButton"}>
                          <div className="mt-2 upload-link addAttachmentButton">
                            <button
                              type="button"
                              className="btn wht-bg link-btn mr-auto"
                            >
                              Add Attachment
                            </button>
                            <Form.Control
                              id="formControlsFile"
                              type="file"
                              multiple
                              onChange={(event: any) =>
                                this.onFileChange(event, "1")
                              }
                              accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                            />
                          </div>
                        )}
                    </div>
                  </Form.Group>
                )}
              </div>
              {this.state.isComment && !this.state.isRepeat && (
                <div 
                className={this.state.isStateChanged || this.props.selectedRow?.isDraftUpdate === "Yes" ? "footer-show" : ""}
                //className={"footer-show"}
                >
                  <CommentBox
                    ref={this.ChildComment}
                    hotelid={this.state.hotelValue}
                    entryType={
                      this.props.isFromRepeating
                        ? this.state.requestlist.etype + "repeat"
                        : this.state.requestlist.etype
                    }
                    uniqueNo={
                      this.state.formData.actionType === "copy"
                        ? 0
                        : this.props.uniqueNo
                    }
                    precommentlist={this.state.htmlcomment}
                    parentScrollMethod={this.scrollToBottom}
                    updatedCommentItem={this.updatedCommentItem}

                    callBackCommentLoad={this.callBackCommentLoad}
                    commentModalClose={this.CommentModalClose}
                    canReview={this.state.canReview}
                    canFlag={this.props.pageType === "payment" ? "No" : this.state.canFlag}
                    showbanner={this.showbanner}
                    currentReviewStatus={this.state.selectedReviewStatus}
                  //  addCommentDisabled={this.state.isError === "NotEdit" ? true : false}
                  />
                </div>
              )}

              <div
                className={
                  (this.state.isStateChanged || this.props.selectedRow?.isDraftUpdate === "Yes")
                    ? "footer-section viewer-panel"
                    : "footer-section viewer-panel isHide"
                }
              >
                <div
                  className={
                    this.state.isError === "NotEdit" ? "disabled-area" : ""
                  }
                >
                  <div className="d-flex align-items-center justify-content-end height-72">
                    {this.props.uniqueNo === 0 &&
                      this.props?.callFrom != "BankSync" && this.props?.callFrom !== "Draft" && (
                        <Form.Group controlId="formBasicCheckbox">
                          <Form.Check
                            id="chkAnother"
                            type="checkbox"
                            label="Create Another"
                            checked={this.state.createOther}
                            onChange={(event: any) =>
                              this.handleChange(event, "createOther")
                            }
                            onKeyDown={(event: any) =>
                              this.handleKeyDown(event, "createOther")
                            }
                            custom
                          />
                        </Form.Group>
                      )}                    
                    <Button
                      variant="primary"
                      type="button"
                      className="space btn btn-primary btn-discard"
                      onClick={this.closeSlideOut}
                    >
                      Cancel
                    </Button>
                    {this.props?.callFrom == "Draft" && (
                      <Button
                        variant="primary"
                        type="button"
                        className="btn btn-primary"
                        onClick={() => { this.saveDeposit("Yes") }}
                        style={{ marginRight: '10px' }}
                        disabled={this.state.isPermission === "No"}
                      >
                        Save as Draft
                      </Button>
                    )}
                    {(this.state.isStateChanged || this.props.selectedRow?.isDraftUpdate === "Yes") && (
                      <div
                        // className={
                        //   this.state.isPermission === "No"
                        //     ? "disabled-area"
                        //     : ""
                        // }
                      >
                        <Button
                          variant="primary"
                          id="btnSavetran"
                          type="button"
                          onClick={() => {
                            this.state.formData.entryType !== "payment"
                              ? this.saveDeposit("No")
                              : this.SavePaymentData("No")
                          }}
                          disabled={
                            this.state.isDisabled ||
                            this.state.newSelectedfiles.length > 0 ||
                            this.state.isPermission === "No"
                          }
                          onKeyDown={(e: any) => this.onTAB("btnSavetran-1", e)}
                        >
                          {this.props.pageType.toLowerCase() === "deposit"
                            ? "Save Deposit"
                            : "Save Withdrawal"}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
          {this.state.isSpinner && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          {this.state.showInvoiceModal &&
            <Modal
              className="move-invoice-modal"
              show={this.state.showInvoiceModal}
            >
              <Modal.Header>
                <Modal.Title>Move Transaction</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group className="rm-bottom-margin" controlId="vendorName">
                  <Form.Label>EHID</Form.Label>
                  <SingleSelectSearchDDL
                    id={"moveacc"}
                    ref={this.singleSerch}
                    returnData={this.returnEHIDList}
                    moduleName={"Accounting"}
                    defaultText={"EHID"}
                    selectedHID={this.state.hotelValue}
                    pageType={"Transaction"}
                  ></SingleSelectSearchDDL>
                </Form.Group>
                <Form.Group
                  className={
                    this.state.moveHID.hidValue === -1 ? "disabled-area" : ""
                  }
                  controlId="accoutlist"
                >
                  <Form.Label>Account</Form.Label>
                  <div className="single-select type w-200">
                    <SingleDropdownListWithoutSearch
                      id={"accoutlist"}
                      itemList={this.state.accountlist}
                      handleSelectedItem={this.handleaccountNameSelectedItem.bind(
                        this
                      )}
                      defaultItem={this.state.defaultaccountType}
                      defaultText={this.state.accountNameMove}
                      defaultName={this.state.defaultaccountType}
                      controlID="7"
                    />
                  </div>
                </Form.Group>
                <Form.Group
                  className={
                    this.state.moveHID.hidValue === -1
                      ? "rm-bottom-margin disabled-area"
                      : "rm-bottom-margin"
                  }
                  controlId="accountingPeriod1"
                >
                  <Form.Label>Accounting Period</Form.Label>
                  <SingleDropdownListWithoutSearch
                    id={"accountingPeriod1"}
                    itemList={this.state.PeriodList}
                    handleSelectedItem={this.handleSelectedItem.bind(
                      this,
                      10 + "_" + 0
                    )}
                    defaultItem={this.state.defaultPeriod}
                    defaultText={"Accouting Period"}
                    defaultName={this.state.defaultPeriod}
                    controlID="6"
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn-outline-primary"
                  onClick={this.hideMoveInvoiceModal}
                >
                  Close
                </Button>
                <Button className="btn-primary" onClick={this.moveInvoiceEHID}>
                  Move
                </Button>
              </Modal.Footer>
              {this.state.isSpinner && (
                <div className="loader-spinner d-flex justify-content-center align-items-center">
                  <Spinner animation="border" variant="success" />
                </div>
              )}
            </Modal>
          }
          <Modal
            className="move-invoice-modal"
            show={this.state.showVoidModal}
            dialogClassName="modal-70w"
          >
            <Modal.Header>
              <Modal.Title>Void Invoices</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="filter-sec">
                <div className="d-flex">
                  <Form.Group controlId="vendorName">
                    <Form.Label>Accounting Period</Form.Label>
                    <SingleDropdownListWithoutSearch
                      id={"voidPeriod"}
                      itemList={this.state.voidPeriodList}
                      handleSelectedItem={this.handleSelectedItem.bind(
                        this,
                        11 + "_" + 0
                      )}
                      defaultItem={this.state.defaultvoidPeriod}
                      defaultText={"Accouting Period"}
                      defaultName={this.state.defaultvoidPeriod}
                      controlID="11"
                    />
                  </Form.Group>

                  <Form.Group className="rm-bottom-margin" controlId="amount">
                    <Form.Label>Void Date</Form.Label>
                    <div className="date-picker calender-picker">
                      <div className="drop-arrow">
                        <svg
                          width="8"
                          height="6"
                          viewBox="0 0 8 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                            fill="#3F4347"
                          />
                        </svg>
                      </div>
                      <DatePicker
                        id="trvoiddate"
                        tabIndex={this.state.tabEnable}
                        className="form-control"
                        placeholderText={"MM/DD/YY"}
                        dateFormat="MM/dd/yy"
                        selected={
                          this.state.transcationvoidDate === null
                            ? ""
                            : new Date(this.state.transcationvoidDate)
                        }
                        onChange={(event: any) =>
                          this.handleChange(event, "trvoidDate")
                        }
                        onKeyDown={(e: any) => this.onTAB("trvoiddate-1", e)}
                        autoComplete="off"
                      />
                    </div>
                  </Form.Group>
                </div>
                <div className="d-flex">
                  <Form.Group controlId="voidReason">
                    <Form.Label>Reason</Form.Label>
                    <Form.Control
                      className={"form-control"}
                      id="txtvoidNotes"
                      as="textarea"
                      wrap="hard"
                      rows={3}
                      value={this.state.voidNotes}
                      maxLength={200}
                      onChange={(event: any) =>
                        this.handleChange(event, "voidnotes")
                      }
                      autoComplete="off"
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="associated-invoices">
                <div className="sec-ttl">
                  {" "}
                  Select the invoices below that should be recreated
                </div>
                <BootstrapTable
                  keyField="id"
                  data={this.state.associatedPayment.filter(
                    (x) => x.viewType === 1
                  )}
                  columns={associatedInvoicesColumns}
                  // rowEvents={this.rowEvents}
                  selectRow={selectRow}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-outline-primary"
                onClick={this.hideVoidModal}
              >
                Close
              </Button>
              <Button className="btn-primary" onClick={this.handleVoidAction}>
                Void
              </Button>
            </Modal.Footer>
            {this.state.isSpinner && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}
          </Modal>
          {this.state.isOtpNeed && (
            <>
              {/* <OtpModal
                                closePopup={this.closeOtpModal.bind(this)}
                                ValidateOTP={this.ValidateOTP.bind(this)}
                                ReSendOTP={this.ReSendOTP.bind(this)}
                                purpose={"ReprintCheck"}
                            ></OtpModal> */}
              <OtpValidator
                ref={this.ChildOTP}
                closePopup={this.closeOtpModal.bind(this)}
                ValidateOTP={this.ValidateOTP.bind(this)}
                PageName={"ReprintCheck"}
                Source={1}
              ></OtpValidator>
            </>
          )}
          <Modal
            className="move-invoice-modal"
            show={this.state.showMoveAfterPaymentModal}
          >
            <Modal.Header>
              <Modal.Title>Move Transaction</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="rm-bottom-margin" controlId="vendorName">
                <Form.Label>EHID</Form.Label>

                <SingleSelectSearchMove
                  id={"moveacc"}
                  ref={this.singleSerch}
                  returnData={this.onSelectEHIDList}
                  moduleName={"Accounting"}
                  defaultText={"EHID"}
                  selectedHID={this.state.hotelValue}
                  pageType={"Invoice"}
                  search={"Yes"}
                  dropDownList={this.state.moveInvoiceEHID}
                ></SingleSelectSearchMove>
              </Form.Group>

              {this.state.showContractDropdown && (
                <Form.Group>
                  <Form.Label>Contract</Form.Label>
                  <div className="single-select dropdown type w-200">
                    <Dropdown>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {this.state.moveSelectedContract}
                        <div className="drop-arrow ml-0 d-flex">
                          <FiChevronDown />
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {this.state.contractsArray.map(
                          (item: any, idx: any) => (
                            <Dropdown.Item
                              eventKey={item.displayVendorContract}
                              onClick={() => this.onSelectContract(item)}
                            >
                              <EllipsisWithTooltip placement="bottom">
                                {item.displayVendorContract}
                              </EllipsisWithTooltip>
                            </Dropdown.Item>
                          )
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Form.Group>
              )}
              {this.state.showAccountsDropdown && (
                <Form.Group>
                  <Form.Label>Account</Form.Label>
                  <SingleDropdownListWithoutSearch
                    id={"accoutlistmodal"}
                    itemList={this.state.moveAccountListArray}
                    handleSelectedItem={this.handleSelectedItem.bind(
                      this,
                      7 + "_" + 0
                    )}
                    defaultName={"Select Account"}
                    controlID="7"
                  />
                </Form.Group>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-outline-primary"
                onClick={this.hideMoveAfterPaymentModal}
              >
                Close
              </Button>
              <Button
                className="btn-primary"
                disabled={
                  (this.state.moveSelectedContract === "" &&
                    this.state.moveSelectedAccountOprId === -1) ||
                  (this.state.moveSelectedContract === "Select Contract" &&
                    this.state.moveSelectedAccountOprId === -1)
                }
                onClick={this.moveInvoiceEHIDAfterPayment}
              >
                Move
              </Button>
            </Modal.Footer>
            {this.state.isLoader && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}
          </Modal>


          {this.state.showCommentModal &&
            <CommentWithoutList
              hotelid={this.state.hotelValue}
              closeCommentModal={this.closeCommentModal}
              addReviewComment={this.addReviewComment}
              title={this.state.commentModalTitle}
            />
          }
        </div>
      </div>
    );
  }
}
